import { defineComponent as R, openBlock as f, createBlock as A, resolveDynamicComponent as be, normalizeClass as S, withCtx as h, renderSlot as T, createElementBlock as k, createCommentVNode as D, computed as B, unref as u, createElementVNode as v, createTextVNode as j, toDisplayString as E, createVNode as x, Fragment as K, renderList as le, mergeProps as J, ref as O, watch as X, normalizeStyle as ye, withKeys as $e, useSlots as Ba, createSlots as Et, isRef as Be, cloneVNode as yn, h as ct, toRefs as et, getCurrentInstance as Ot, reactive as Kt, watchEffect as za, markRaw as ya, onMounted as Ne, onUnmounted as Aa, effectScope as kn, nextTick as Ce, inject as xn, provide as wn, mergeModels as ka, useModel as $n, useAttrs as Pt, withDirectives as tt, vModelCheckbox as Cn, withModifiers as Pe, resolveComponent as _n, vShow as bt, Teleport as Zt, Transition as ft, onBeforeUnmount as Va, withAsyncContext as Xt, normalizeProps as Ta, guardReactiveProps as Ea, shallowRef as Jt, onBeforeMount as Sn, toHandlers as pt } from "vue";
import * as Mn from "@cfgtech/icons";
import { InfoCircleIcon as jt, CheckCircleIcon as Dn, DangerTriangleFillIcon as Bn, ErrorOctagonIcon as zn, TickIcon as Ue, ChevronLeftIcon as zt, ChevronRightIcon as Lt, ChevronDownIcon as Xe, CheckmarkIcon as Oa, SearchIcon as An, QuestionCircleIcon as ot, DangerTriangleIcon as Vn, HomeIcon as Tn, CalendarIcon as En, EyeIcon as On, ArrowLeftIcon as Pn, MoreDotsIcon as Ln } from "@cfgtech/icons";
import { useFocus as at, useVModel as ce, templateRef as At, unrefElement as Nn, tryOnScopeDispose as In, useEventListener as Ht, useArrayMap as mt, useTextareaAutosize as Rn, useElementSize as Qt, watchDebounced as Pa, useElementBounding as gt, useResizeObserver as Fn, asyncComputed as jn, onClickOutside as La, computedAsync as Hn, tryOnUnmounted as Un, computedEager as Yn } from "@vueuse/core";
import { uniqueId as ht, omit as Ie, isEqual as vt, pick as Le, isUndefined as Ut, isEmpty as xa, cloneDeep as it, pickBy as Wn } from "lodash-es";
import { SwitchGroup as qn, Switch as Gn, SwitchLabel as Kn, SwitchDescription as Zn, Listbox as Xn, ListboxButton as Jn, ListboxOptions as Qn, ListboxOption as er, TabGroup as tr, TabList as ar, TabPanels as nr, TabPanel as rr, Tab as lr, TransitionRoot as ea, Dialog as ta, TransitionChild as Je, DialogPanel as aa, DialogTitle as or, DialogDescription as sr } from "@headlessui/vue";
import { useFloating as na, autoUpdate as ra, autoPlacement as Na, shift as Ia, offset as Ra, flip as Fa } from "@floating-ui/vue";
import la from "dayjs";
import { createFocusTrap as ir } from "focus-trap";
var N = /* @__PURE__ */ ((e) => (e.h1 = "h1", e.h2 = "h2", e.h3 = "h3", e.h4 = "h4", e.subtitle = "subtitle", e.label = "label", e.xl = "xl", e.lg = "lg", e.md = "md", e.sm = "sm", e.xs = "xs", e.perex = "perex", e.small = "small", e.micro = "micro", e))(N || {});
const ur = ["innerHTML"], dr = /* @__PURE__ */ R({
  __name: "CfgTypography",
  props: {
    size: {
      type: String,
      default: N.md
    },
    tagName: {
      type: String,
      default: "span"
    },
    html: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (a, t) => a.$slots.default ? (f(), A(be(e.tagName), {
      key: 0,
      class: S(["heading", {
        [`heading-${e.size}`]: !!e.size
      }])
    }, {
      default: h(() => [
        T(a.$slots, "default", {}, () => [
          e.html ? (f(), k("span", {
            key: 0,
            innerHTML: e.html
          }, null, 8, ur)) : D("", !0)
        ], !0)
      ]),
      _: 3
    }, 8, ["class"])) : e.html ? (f(), A(be(e.tagName), {
      key: 1,
      class: S(["heading", {
        [`heading-${e.size}`]: !!e.size
      }]),
      innerHTML: e.html
    }, null, 8, ["class", "innerHTML"])) : D("", !0);
  }
});
const Re = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [l, r] of a)
    t[l] = r;
  return t;
}, I = /* @__PURE__ */ Re(dr, [["__scopeId", "data-v-4dcad173"]]);
var ge = /* @__PURE__ */ ((e) => (e.brand = "brand", e.success = "success", e.warning = "warning", e.info = "info", e.error = "error", e))(ge || {});
const cr = { class: "flex gap-x-3" }, fr = { class: "space-y-1" }, qu = /* @__PURE__ */ R({
  __name: "CfgAlert",
  props: {
    variant: {
      type: String,
      default: ge.info
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = e, t = B(() => {
      if (a.variant === ge.info)
        return jt;
      if (a.variant === ge.success)
        return Dn;
      if (a.variant === ge.warning)
        return Bn;
      if (a.variant === ge.error)
        return zn;
    });
    return (l, r) => (f(), k("div", {
      class: S(["mb-4 rounded-md px-3 py-4 text-black md:px-4", {
        "bg-brand/20": e.variant === u(ge).brand,
        "bg-blue/20": e.variant === u(ge).info,
        "bg-success-light": e.variant === u(ge).success,
        "bg-warning-light": e.variant === u(ge).warning,
        "bg-red-light": e.variant === u(ge).error
      }])
    }, [
      v("div", cr, [
        t.value || l.$slots.icon ? (f(), k("div", {
          key: 0,
          class: S(["w-6 flex-none [&>*]:text-[24px]", {
            "text-brand": e.variant === u(ge).brand,
            "text-blue": e.variant === u(ge).info,
            "text-success": e.variant === u(ge).success,
            "text-warning": e.variant === u(ge).warning,
            "text-red": e.variant === u(ge).error
          }])
        }, [
          T(l.$slots, "icon", {}, () => [
            (f(), A(be(t.value), { "aria-hidden": "true" }))
          ])
        ], 2)) : D("", !0),
        v("div", fr, [
          e.title ? (f(), A(I, {
            key: 0,
            "tag-name": "h3",
            class: "font-semibold",
            size: u(N).md
          }, {
            default: h(() => [
              j(E(e.title), 1)
            ]),
            _: 1
          }, 8, ["size"])) : D("", !0),
          x(I, {
            "tag-name": "p",
            size: u(N).md
          }, {
            default: h(() => [
              T(l.$slots, "text", {}, () => [
                j(E(e.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"])
        ])
      ])
    ], 2));
  }
});
const pr = {}, mr = { class: "lds-ring" };
function gr(e, a) {
  return f(), k("span", mr, [
    (f(), k(K, null, le(4, (t) => v("span", { key: t })), 64))
  ]);
}
const yt = /* @__PURE__ */ Re(pr, [["render", gr]]), me = {
  primary: "primary",
  primaryLight: "primary-light",
  secondary: "secondary",
  successLight: "success-light",
  success: "success",
  grey: "grey",
  light: "light",
  orange: "orange",
  dark: "dark",
  danger: "danger",
  dangerLight: "danger-light",
  black: "black",
  stroke: "stroke",
  white: "white"
}, vr = { class: "relative block" }, br = {
  key: 0,
  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
}, Nt = /* @__PURE__ */ R({
  __name: "CfgButton",
  props: {
    variant: { default: me.primary },
    label: { default: "" },
    flat: { type: Boolean },
    text: { type: Boolean },
    loading: { type: Boolean },
    small: { type: Boolean },
    stroke: { type: Boolean },
    as: { default: "button" },
    iconPlacement: { default: "right" }
  },
  setup(e) {
    const a = e, t = B(() => ({
      [me.primary]: {
        DEFAULT: "text-white bg-brand border-brand",
        stroke: "border-brand text-brand",
        text: "text-brand"
      },
      "primary-inverted": {
        DEFAULT: "text-brand bg-white border-white",
        stroke: "border-white text-white",
        text: "text-white"
      },
      [me.primaryLight]: {
        DEFAULT: "text-brand bg-brand-opacity border-brand-opacity",
        stroke: "border-brand-opacity text-brand-opacity",
        text: "text-brand-opacity"
      },
      [me.secondary]: {
        DEFAULT: "text-white bg-secondary border-secondary",
        stroke: "border-secondary text-secondary",
        text: "text-secondary"
      },
      [me.grey]: {
        DEFAULT: "text-white bg-grey-300 border-grey-300",
        stroke: "border-grey-300 text-grey-300",
        text: "text-grey-300"
      },
      [me.dark]: {
        DEFAULT: "text-white bg-secondary-dark border-secondary-dark",
        stroke: "border-secondary-dark text-secondary-dark",
        text: "text-secondary-dark"
      },
      [me.light]: {
        DEFAULT: "text-secondary-dark bg-grey-100 border-grey-100",
        stroke: "border-grey-100 text-grey-100",
        text: "text text-grey-100"
      },
      [me.orange]: {
        DEFAULT: "text-white bg-orange border-orange",
        stroke: "border-orange text-orange",
        text: "text-orange"
      },
      [me.danger]: {
        DEFAULT: "text-red-light bg-red border-red",
        stroke: "border-red text-red",
        text: "text-red"
      },
      [me.dangerLight]: {
        DEFAULT: "text-red bg-red-light border-red-light",
        stroke: "border-red-light text-red-light",
        text: "text-red-light"
      },
      [me.success]: {
        DEFAULT: "text-success-light bg-success border-success",
        stroke: "border-success text-success",
        text: "text-success"
      },
      [me.successLight]: {
        DEFAULT: "text-success bg-success-light border-success-light",
        stroke: "border-success-light text-success-light",
        text: "text-success-light"
      },
      [me.black]: {
        DEFAULT: "text-white bg-black border-black",
        stroke: "border-black text-black",
        text: "text-black"
      },
      [me.stroke]: {
        DEFAULT: "text-grey-100 bg-black border-grey-100",
        stroke: "border-grey-100 text-black",
        text: "text-black"
      },
      [me.white]: {
        DEFAULT: "text-black bg-white border-black",
        stroke: "border-white text-white",
        text: "text-white"
      }
    })), l = B(() => {
      if (a.text && a.stroke)
        throw new Error("CfgButton cannot have both text and stroke properties");
      return a.stroke ? "stroke" : a.text ? "text" : "DEFAULT";
    }), r = B(() => {
      const o = a.variant || me.primary;
      return t.value[o][l.value];
    });
    return (o, n) => (f(), A(be(o.as), J({
      disabled: o.$attrs.disabled || o.loading
    }, {
      ...o.as === "button" && !o.$attrs.type ? { type: "button" } : {}
    }, {
      class: ["button focusable inline-block px-0 font-display font-bold", {
        [`button-variant__${o.variant}`]: !0,
        "button-flat": o.flat,
        "button-small": o.small,
        "button-text": o.text,
        "cursor-not-allowed opacity-60": o.$attrs.disabled,
        "button-stroke": o.stroke,
        [r.value]: !0
      }]
    }), {
      default: h(() => [
        v("span", vr, [
          v("span", {
            class: S(["flex items-center justify-center", {
              "opacity-0": o.loading,
              "gap-x-3": !o.small,
              "gap-x-2": o.small
            }])
          }, [
            o.label || o.$slots.default ? (f(), k("span", {
              key: 0,
              class: S(["button_label block text-center first-letter:uppercase", { "order-2": o.iconPlacement === "left" }])
            }, [
              T(o.$slots, "default", {}, () => [
                j(E(o.label), 1)
              ])
            ], 2)) : D("", !0),
            o.$slots.icon ? (f(), k("span", {
              key: 1,
              class: S({ "order-1": o.iconPlacement === "left" })
            }, [
              T(o.$slots, "icon")
            ], 2)) : D("", !0)
          ], 2),
          o.loading ? (f(), k("span", br, [
            x(yt, {
              class: S({
                "text-[7px]": !o.small,
                "text-[5px]": o.small
              })
            }, null, 8, ["class"])
          ])) : D("", !0)
        ])
      ]),
      _: 3
    }, 16, ["disabled", "class"]));
  }
});
const hr = {}, yr = { class: "rounded-xl p-5" };
function kr(e, a) {
  return f(), k("div", yr, [
    T(e.$slots, "default")
  ]);
}
const Gu = /* @__PURE__ */ Re(hr, [["render", kr]]);
function oa() {
  return { generateGuid: ht };
}
const xr = {
  key: 0,
  class: "text-red"
}, wr = {
  key: 0,
  class: "text-field-template__right absolute top-1/2 flex -translate-y-1/2 items-center justify-center"
}, $r = /* @__PURE__ */ R({
  __name: "AbstractTextField",
  props: {
    required: { type: Boolean },
    placeholder: { default: "" },
    fluid: { type: Boolean },
    error: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    empty: { type: Boolean, default: !0 },
    focused: { type: Boolean },
    placeholderAs: { default: "span" },
    placeholderAttrs: { default: () => ({}) },
    loading: { type: Boolean },
    height: { default: void 0 },
    as: { default: "span" }
  },
  emits: ["update:focused"],
  setup(e, { emit: a }) {
    const t = e, l = B(() => ({
      "--height": t.height || "var(--input-height)"
    })), r = a, o = O(), { focused: n } = at(o), i = B(() => t.focused || !t.empty);
    return X(n, (s) => {
      r("update:focused", s);
    }), (s, c) => {
      var p, d;
      return f(), A(be(s.as), {
        ref_key: "textFieldRef",
        ref: o,
        class: S(["text-field-template relative block rounded-xl text-sm transition-all duration-200", {
          "w-full": s.fluid,
          "w-max": !s.fluid,
          "with-right-content": (d = (p = s.$slots).placeRight) == null ? void 0 : d.call(p),
          "opacity-50": s.disabled
        }]),
        style: ye(l.value),
        onClick: c[0] || (c[0] = () => {
          n.value = !0;
        }),
        onKeypress: c[1] || (c[1] = $e(() => {
          n.value = !0;
        }, ["enter"]))
      }, {
        default: h(() => [
          (f(), A(be(s.placeholderAs), J(s.placeholderAttrs, {
            class: ["text-field-template__placeholder absolute left-[var(--pl)] origin-top-left -translate-y-1/2 cursor-text font-medium leading-none text-grey-200 transition-all duration-200", {
              active: i.value,
              "text-red": s.error,
              "!text-brand": !s.error && i.value && s.focused
            }]
          }), {
            default: h(() => [
              j(E(s.placeholder) + " ", 1),
              s.required ? (f(), k("span", xr, "*")) : D("", !0)
            ]),
            _: 1
          }, 16, ["class"])),
          v("span", {
            class: S(["text-field-template__wrapper block rounded-xl border transition duration-200", {
              "border-grey-stroke": !i.value || !s.focused,
              "border-brand": i.value && s.focused,
              "disabled:border-gray-200 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-grey-500": s.disabled,
              "error border-red text-red": s.error
            }])
          }, [
            T(s.$slots, "default", {}, void 0, !0)
          ], 2),
          s.$slots.placeRight || s.loading ? (f(), k("span", wr, [
            s.loading ? (f(), A(u(yt), {
              key: 0,
              class: "text-[6px] text-brand"
            })) : T(s.$slots, "placeRight", { key: 1 }, void 0, !0)
          ])) : D("", !0)
        ]),
        _: 3
      }, 40, ["class", "style"]);
    };
  }
});
const sa = /* @__PURE__ */ Re($r, [["__scopeId", "data-v-b8a82996"]]), ie = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Input value (v-model)
   */
  modelValue: {
    type: [String, Number],
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   * */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, ke = {
  ...ie,
  /**
   * Input type like text, number, email, etc.
   */
  type: {
    type: String,
    default: "text"
  },
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  /**
   * Input suffix. The Recommended length is 2-3 characters, like 'Let'
   */
  suffix: {
    type: String,
    default: ""
  },
  transformToCommaDelimiter: {
    type: Boolean,
    default: void 0
  }
}, Cr = { class: "block leading-none" }, _r = ["id", "value", "type", "readonly", "tabindex", "disabled"], Sr = { class: "absolute inset-y-0 right-0 flex items-center" }, Mr = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, Dr = ["innerHTML"], Se = /* @__PURE__ */ R({
  __name: "CfgInput",
  props: {
    ...ie,
    ...ke,
    fieldClass: {
      type: String,
      default: ""
    },
    /**
     * If false, icon slot will have pointer-events-none class
     * @default false
     */
    interactWithIcon: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "input", "focusout", "focusin", "blur", "keydown"],
  setup(e, { expose: a, emit: t }) {
    const l = e, r = t, o = oa().generateGuid(), n = ce(l, "modelValue", r), i = B(() => l.transformToCommaDelimiter !== void 0 ? l.transformToCommaDelimiter : l.type === "number"), s = B(() => i.value && i.value && l.type === "number" ? "tel" : l.type), c = B(() => i.value ? String(n.value).replaceAll(".", ",") : n.value), p = Ba(), d = B(() => !String(n.value).trim().length), m = B(() => !!(p.icon || l.suffix) || l.type === "search" && !d.value), y = O(), { focused: w } = at(y, {
      initialValue: l.initialFocused
    });
    a({
      focus() {
        w.value = !0;
      }
    }), X(w, (b) => {
      r(b ? "focusin" : "focusout");
    });
    function g(b) {
      b && (w.value = !0);
    }
    function _(b) {
      const { value: C } = b.target;
      if (i.value) {
        n.value = M(
          C.replace(/[^0-9,.]/g, "").replaceAll(",", ".")
          // replace comma with dot
        );
        return;
      }
      n.value = C;
    }
    function M(b) {
      const C = b.split(".");
      if (C.length > 1 && C[0] !== "") {
        const z = C[0], P = C.slice(1).join("");
        return `${z}.${P}`;
      }
      return b.replaceAll(".", "");
    }
    function $() {
      n.value = "", g(!0);
    }
    return (b, C) => (f(), k("div", {
      class: S({ "w-full": b.fluid, "w-72": !b.fluid })
    }, [
      x(u(sa), {
        as: "label",
        focused: u(w),
        placeholder: b.placeholder,
        fluid: !0,
        readonly: b.readonly,
        disabled: b.disabled,
        empty: d.value,
        error: b.error,
        required: b.required,
        loading: b.loading,
        class: S(["cfg-input cursor-text bg-white", { [e.fieldClass]: e.fieldClass }]),
        "placeholder-as": "label",
        "placeholder-attrs": { for: u(o) },
        "onUpdate:focused": g
      }, Et({
        default: h(() => [
          v("span", Cr, [
            v("input", J({
              id: u(o),
              ref_key: "inputRef",
              ref: y,
              value: c.value,
              type: s.value,
              class: "cfg-input__input h-[1em] w-full border-none bg-transparent p-0 leading-none outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              readonly: b.readonly,
              tabindex: b.readonly ? -1 : 0,
              disabled: b.disabled
            }, b.$attrs.autocomplete ? {
              autocomplete: b.$attrs.autocomplete
            } : {}, {
              onFocusin: C[0] || (C[0] = (z) => w.value = !0),
              onFocusout: C[1] || (C[1] = (z) => w.value = !1),
              onKeydown: C[2] || (C[2] = (z) => r("keydown", z)),
              onBlur: C[3] || (C[3] = (z) => r("blur")),
              onInput: _
            }), null, 16, _r)
          ])
        ]),
        _: 2
      }, [
        m.value ? {
          name: "placeRight",
          fn: h(() => [
            v("div", Sr, [
              b.suffix ? (f(), k("span", {
                key: 0,
                id: "price-currency",
                class: S(["text-grey-500 sm:text-sm", { "pointer-events-none": !e.interactWithIcon }])
              }, E(b.suffix), 3)) : D("", !0),
              b.type === "search" && String(u(n)).length ? (f(), A(Nt, {
                key: 1,
                text: "",
                flat: "",
                onClick: $
              }, {
                default: h(() => [
                  x(u(Ue))
                ]),
                _: 1
              })) : b.$slots.icon ? T(b.$slots, "icon", {
                key: 2,
                class: S({ "pointer-events-none": !e.interactWithIcon })
              }) : D("", !0)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["focused", "placeholder", "readonly", "disabled", "empty", "error", "required", "loading", "class", "placeholder-attrs"]),
      b.error && b.errorMessage ? (f(), k("small", Mr, E(b.errorMessage), 1)) : D("", !0),
      !(b.errorMessage && b.error) && b.caption ? (f(), k("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: b.caption
      }, null, 8, Dr)) : D("", !0)
    ], 2));
  }
}), Br = { class: "sr-only" }, zr = { class: "absolute left-0 top-0 h-full w-full rounded-[inherit] bg-[inherit]" }, Ar = ["innerHTML"], Ku = /* @__PURE__ */ R({
  __name: "CfgSwitch",
  props: {
    ...ie,
    modelValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = ce(t, "modelValue", a), o = O();
    return at(o, {
      initialValue: t.initialFocused
    }), (n, i) => (f(), A(u(qn), null, {
      default: h(() => [
        v("div", {
          class: S(["flex gap-x-4 gap-y-3", {
            "flex-col": !n.placeholder,
            "cursor-pointer": !n.disabled,
            "cursor-not-allowed": n.disabled
          }])
        }, [
          x(u(Gn), {
            ref_key: "inputRef",
            ref: o,
            modelValue: u(r),
            "onUpdate:modelValue": i[0] || (i[0] = (s) => Be(r) ? r.value = s : null),
            disabled: n.disabled,
            class: S(["cfg-switch relative inline-flex h-[27px] w-11 shrink-0 rounded-full border-[3px] border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2", {
              "cfg-switch--selected": u(r),
              "!bg-red/10": n.error
            }])
          }, {
            default: h(() => [
              v("span", Br, E(n.placeholder), 1),
              v("span", {
                class: S(["cfg-switch__swiper pointer-events-none mx-0 inline-block h-[calc(27px-6px)] w-[calc(27px-6px)] rounded-full ring-0 transition duration-200 ease-in-out", {
                  "translate-x-4 bg-brand text-white": u(r),
                  "translate-x-0 bg-white text-grey-300": !u(r),
                  "bg-red": n.error && u(r)
                }]),
                "aria-hidden": "true"
              }, [
                v("span", zr, [
                  e.modelValue ? T(n.$slots, "enabled", { key: 0 }) : T(n.$slots, "disabled", { key: 1 })
                ])
              ], 2)
            ]),
            _: 3
          }, 8, ["modelValue", "disabled", "class"]),
          v("div", null, [
            n.placeholder ? (f(), A(u(Kn), {
              key: 0,
              class: "flex items-center"
            }, {
              default: h(() => [
                x(I, {
                  size: u(N).sm,
                  class: S({
                    "opacity-40": n.disabled,
                    "cursor-pointer": !n.disabled,
                    "cursor-not-allowed": n.disabled,
                    "text-red": n.error,
                    "text-grey-400": !n.error
                  })
                }, {
                  default: h(() => [
                    j(E(n.placeholder), 1)
                  ]),
                  _: 1
                }, 8, ["size", "class"])
              ]),
              _: 1
            })) : D("", !0),
            n.caption || n.error && n.errorMessage ? (f(), A(u(Zn), {
              key: 1,
              class: "cursor-text"
            }, {
              default: h(() => [
                n.caption && !(n.error && n.errorMessage) ? (f(), A(I, {
                  key: 0,
                  size: u(N).xs,
                  class: S(["mt-1 block cursor-text text-grey-300", { "mt-0": !n.placeholder }])
                }, {
                  default: h(() => [
                    v("span", { innerHTML: n.caption }, null, 8, Ar)
                  ]),
                  _: 1
                }, 8, ["size", "class"])) : n.errorMessage && n.error ? (f(), A(I, {
                  key: 1,
                  class: S(["mt-1 block cursor-text text-red", { "mt-0": !n.placeholder }]),
                  size: u(N).xs
                }, {
                  default: h(() => [
                    j(E(n.errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["size", "class"])) : D("", !0)
              ]),
              _: 1
            })) : D("", !0)
          ])
        ], 2)
      ]),
      _: 3
    }));
  }
});
function ia(e, a) {
  const t = typeof e == "string" && !a ? `${e}Context` : a, l = Symbol(t);
  return [(r) => {
    const o = xn(l, r);
    if (o || o === null)
      return o;
    throw new Error(
      `Injection \`${l.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(
        ", "
      )}` : `\`${e}\``}`
    );
  }, (r) => (wn(l, r), r)];
}
function ja(e) {
  let a = !1, t;
  const l = kn(!0);
  return (...r) => (a || (t = l.run(() => e(...r)), a = !0), t);
}
function Vr(e) {
  return typeof e == "function" ? e() : u(e);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Tr = (e) => typeof e < "u";
function ua(e) {
  var a;
  const t = Vr(e);
  return (a = t == null ? void 0 : t.$el) != null ? a : t;
}
function Er(e) {
  return JSON.parse(JSON.stringify(e));
}
function Or(e, a, t, l = {}) {
  var r, o, n;
  const {
    clone: i = !1,
    passive: s = !1,
    eventName: c,
    deep: p = !1,
    defaultValue: d,
    shouldEmit: m
  } = l, y = Ot(), w = t || (y == null ? void 0 : y.emit) || ((r = y == null ? void 0 : y.$emit) == null ? void 0 : r.bind(y)) || ((n = (o = y == null ? void 0 : y.proxy) == null ? void 0 : o.$emit) == null ? void 0 : n.bind(y == null ? void 0 : y.proxy));
  let g = c;
  a || (a = "modelValue"), g = g || `update:${a.toString()}`;
  const _ = (b) => i ? typeof i == "function" ? i(b) : Er(b) : b, M = () => Tr(e[a]) ? _(e[a]) : d, $ = (b) => {
    m ? m(b) && w(g, b) : w(g, b);
  };
  if (s) {
    const b = M(), C = O(b);
    let z = !1;
    return X(
      () => e[a],
      (P) => {
        z || (z = !0, C.value = _(P), Ce(() => z = !1));
      }
    ), X(
      C,
      (P) => {
        !z && (P !== e[a] || p) && $(P);
      },
      { deep: p }
    ), C;
  } else
    return B({
      get() {
        return M();
      },
      set(b) {
        $(b);
      }
    });
}
function da(e) {
  return e ? e.flatMap((a) => a.type === K ? da(a.children) : [a]) : [];
}
const Pr = ["INPUT", "TEXTAREA"];
function Lr(e, a, t, l = {}) {
  if (!a || l.enableIgnoredElement && Pr.includes(a.nodeName))
    return null;
  const {
    arrowKeyOptions: r = "both",
    attributeName: o = "[data-radix-vue-collection-item]",
    itemsArray: n = [],
    loop: i = !0,
    dir: s = "ltr",
    preventScroll: c = !0,
    focus: p = !1
  } = l, [d, m, y, w, g, _] = [
    e.key === "ArrowRight",
    e.key === "ArrowLeft",
    e.key === "ArrowUp",
    e.key === "ArrowDown",
    e.key === "Home",
    e.key === "End"
  ], M = y || w, $ = d || m;
  if (!g && !_ && (!M && !$ || r === "vertical" && $ || r === "horizontal" && M))
    return null;
  const b = t ? Array.from(t.querySelectorAll(o)) : n;
  if (!b.length)
    return null;
  c && e.preventDefault();
  let C = null;
  return $ || M ? C = Ha(b, a, {
    goForward: M ? w : s === "ltr" ? d : m,
    loop: i
  }) : g ? C = b.at(0) || null : _ && (C = b.at(-1) || null), p && (C == null || C.focus()), C;
}
function Ha(e, a, { goForward: t, loop: l }, r = e.length) {
  if (--r === 0)
    return null;
  const o = e.indexOf(a), n = t ? o + 1 : o - 1;
  if (!l && (n < 0 || n >= e.length))
    return null;
  const i = (n + e.length) % e.length, s = e[i];
  return s ? s.hasAttribute("disabled") && s.getAttribute("disabled") !== "false" ? Ha(
    e,
    s,
    { goForward: t, loop: l },
    r
  ) : s : null;
}
const [Nr, Zu] = ia("ConfigProvider");
ja(() => ({ count: O(0) }));
function Ir(e) {
  const a = Nr({
    dir: O("ltr")
  });
  return B(() => {
    var t;
    return (e == null ? void 0 : e.value) || ((t = a.dir) == null ? void 0 : t.value) || "ltr";
  });
}
function Rr() {
  const e = Ot(), a = O(), t = B(() => {
    var n, i;
    return ["#text", "#comment"].includes((n = a.value) == null ? void 0 : n.$el.nodeName) ? (i = a.value) == null ? void 0 : i.$el.nextElementSibling : ua(a);
  }), l = Object.assign({}, e.exposed), r = {};
  for (const n in e.props)
    Object.defineProperty(r, n, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[n]
    });
  if (Object.keys(l).length > 0)
    for (const n in l)
      Object.defineProperty(r, n, {
        enumerable: !0,
        configurable: !0,
        get: () => l[n]
      });
  Object.defineProperty(r, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => e.vnode.el
  }), e.exposed = r;
  function o(n) {
    a.value = n, !(n instanceof Element || !n) && (Object.defineProperty(r, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => n.$el
    }), e.exposed = r);
  }
  return { forwardRef: o, currentRef: a, currentElement: t };
}
function Fr(e, a) {
  const t = O(e);
  function l(r) {
    return a[t.value][r] ?? t.value;
  }
  return {
    state: t,
    dispatch: (r) => {
      t.value = l(r);
    }
  };
}
const ca = R({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(e, { attrs: a, slots: t }) {
    return () => {
      var l, r;
      if (!t.default)
        return null;
      const o = da(t.default()), [n, ...i] = o;
      if (Object.keys(a).length > 0) {
        (l = n.props) == null || delete l.ref;
        const s = J(a, n.props ?? {});
        a.class && (r = n.props) != null && r.class && delete n.props.class;
        const c = yn(n, s);
        for (const p in s)
          p.startsWith("on") && (c.props || (c.props = {}), c.props[p] = s[p]);
        return o.length === 1 ? c : [c, ...i];
      }
      return o;
    };
  }
}), jr = R({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(e, { attrs: a, slots: t }) {
    return (e.asChild ? "template" : e.as) !== "template" ? () => ct(e.as, a, { default: t.default }) : () => ct(ca, a, { default: t.default });
  }
});
function Ua() {
  const e = O(), a = B(() => {
    var t, l;
    return ["#text", "#comment"].includes((t = e.value) == null ? void 0 : t.$el.nodeName) ? (l = e.value) == null ? void 0 : l.$el.nextElementSibling : ua(e);
  });
  return {
    primitiveElement: e,
    currentElement: a
  };
}
function Hr(e, a) {
  const t = O({}), l = O("none"), r = e.value ? "mounted" : "unmounted", { state: o, dispatch: n } = Fr(r, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  X(
    e,
    async (d, m) => {
      var y;
      const w = m !== d;
      if (await Ce(), w) {
        const g = l.value, _ = kt(a.value);
        d ? n("MOUNT") : _ === "none" || ((y = t.value) == null ? void 0 : y.display) === "none" ? n("UNMOUNT") : n(m && g !== _ ? "ANIMATION_OUT" : "UNMOUNT");
      }
    },
    { immediate: !0 }
  );
  const i = (d) => {
    const m = kt(a.value), y = m.includes(
      d.animationName
    );
    d.target === a.value && y && n("ANIMATION_END"), d.target === a.value && m === "none" && n("ANIMATION_END");
  }, s = (d) => {
    d.target === a.value && (l.value = kt(a.value));
  }, c = X(
    a,
    (d, m) => {
      d ? (t.value = getComputedStyle(d), d.addEventListener("animationstart", s), d.addEventListener("animationcancel", i), d.addEventListener("animationend", i)) : (n("ANIMATION_END"), m == null || m.removeEventListener("animationstart", s), m == null || m.removeEventListener("animationcancel", i), m == null || m.removeEventListener("animationend", i));
    },
    { immediate: !0 }
  ), p = X(o, () => {
    const d = kt(a.value);
    l.value = o.value === "mounted" ? d : "none";
  });
  return Aa(() => {
    c(), p();
  }), {
    isPresent: B(
      () => ["mounted", "unmountSuspended"].includes(o.value)
    )
  };
}
function kt(e) {
  return e && getComputedStyle(e).animationName || "none";
}
R({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(e, { slots: a, expose: t }) {
    var l;
    const { present: r, forceMount: o } = et(e), n = O(), { isPresent: i } = Hr(r, n);
    t({ present: i });
    let s = a.default({ present: i });
    s = da(s || []);
    const c = Ot();
    if (s && (s == null ? void 0 : s.length) > 1) {
      const p = (l = c == null ? void 0 : c.parent) != null && l.type.name ? `<${c.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${p}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((d) => `  - ${d}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => o.value || r.value || i.value ? ct(a.default({ present: i })[0], {
      ref: (p) => {
        const d = ua(p);
        return typeof (d == null ? void 0 : d.hasAttribute) > "u" || (d != null && d.hasAttribute("data-radix-popper-content-wrapper") ? n.value = d.firstElementChild : n.value = d), d;
      }
    }) : null;
  }
});
Kt({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
ja(() => O([]));
const [Ya, Xu] = ia("CollectionProvider");
R({
  name: "CollectionSlot",
  setup(e, { slots: a }) {
    const t = Ya(), { primitiveElement: l, currentElement: r } = Ua();
    return X(r, () => {
      t.collectionRef.value = r.value;
    }), () => ct(ca, { ref: l }, a);
  }
});
R({
  name: "CollectionItem",
  setup(e, { slots: a, attrs: t }) {
    const l = Ya(), { primitiveElement: r, currentElement: o } = Ua(), n = Ot();
    return za((i) => {
      var s;
      if (o.value) {
        const c = ya(o.value);
        l.itemMap.value.set(c, { ref: o.value, ...ya(((s = n == null ? void 0 : n.parent) == null ? void 0 : s.props) ?? {}) }), i(() => l.itemMap.value.delete(c));
      }
    }), () => ct(ca, { ...t, [l.attrName]: "", ref: r }, a);
  }
});
const Ur = ["id", "value", "name", "disabled", "required"], [Yr, Wr] = ia("PinInputRoot"), qr = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "PinInputRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    placeholder: { default: "" },
    mask: { type: Boolean },
    otp: { type: Boolean },
    type: { default: "text" },
    dir: {},
    name: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    id: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "complete"],
  setup(e, { emit: a }) {
    const t = e, l = a, { mask: r, otp: o, placeholder: n, type: i, disabled: s, dir: c } = et(t), { forwardRef: p } = Rr(), d = Ir(c), m = Or(t, "modelValue", l, {
      defaultValue: t.defaultValue ?? [],
      passive: t.modelValue === void 0
    }), y = O(/* @__PURE__ */ new Set());
    function w(_) {
      y.value.add(_);
    }
    const g = B(() => m.value.filter((_) => !!_).length === y.value.size);
    return X(m, () => {
      g.value && l("complete", m.value);
    }, { deep: !0 }), Wr({
      modelValue: m,
      mask: r,
      otp: o,
      placeholder: n,
      type: i,
      dir: d,
      disabled: s,
      isCompleted: g,
      inputElements: y,
      onInputElementChange: w
    }), (_, M) => (f(), k(K, null, [
      x(u(jr), J(_.$attrs, {
        ref: u(p),
        dir: u(d),
        "data-complete": g.value ? "" : void 0,
        "data-disabled": u(s) ? "" : void 0
      }), {
        default: h(() => [
          T(_.$slots, "default", { modelValue: u(m) })
        ]),
        _: 3
      }, 16, ["dir", "data-complete", "data-disabled"]),
      v("input", {
        id: _.id,
        type: "text",
        tabindex: "-1",
        "aria-hidden": "",
        value: u(m).join(""),
        name: _.name,
        disabled: u(s),
        required: _.required,
        style: ye({
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }),
        onFocus: M[0] || (M[0] = ($) => {
          var b, C;
          return (C = (b = Array.from(y.value)) == null ? void 0 : b[0]) == null ? void 0 : C.focus();
        })
      }, null, 44, Ur)
    ], 64));
  }
}), Gr = ["autocomplete", "type", "inputmode", "pattern", "placeholder", "value", "disabled", "data-disabled", "data-complete", "aria-label"], Kr = /* @__PURE__ */ R({
  __name: "PinInputInput",
  props: {
    index: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(e) {
    const a = e, t = Yr(), l = B(() => Array.from(t.inputElements.value)), r = B(() => a.disabled || t.disabled.value), o = B(() => t.otp.value), n = B(() => t.type.value === "number"), i = B(() => t.mask.value), s = O();
    function c(M) {
      const $ = M.target;
      if (n.value && !/^[0-9]*$/.test($.value)) {
        $.value = $.value.replace(/\D/g, "");
        return;
      }
      $.value = $.value.slice(-1), _(a.index, $.value);
      const b = l.value[a.index + 1];
      b && b.focus();
    }
    function p(M) {
      Lr(M, document.activeElement, void 0, {
        itemsArray: l.value,
        focus: !0,
        loop: !1,
        arrowKeyOptions: "horizontal",
        dir: t.dir.value
      });
    }
    function d(M) {
      if (M.preventDefault(), M.target.value)
        _(a.index, "");
      else {
        const $ = l.value[a.index - 1];
        $ && ($.focus(), _(a.index - 1, ""));
      }
    }
    function m(M) {
      M.key === "Delete" && (M.preventDefault(), _(a.index, ""));
    }
    function y(M) {
      const $ = M.target;
      $.setSelectionRange(1, 1), $.value || ($.placeholder = "");
    }
    function w(M) {
      const $ = M.target;
      Ce(() => {
        $.value || ($.placeholder = t.placeholder.value);
      });
    }
    function g(M) {
      var $;
      M.preventDefault();
      const b = M.clipboardData;
      if (!b)
        return;
      const C = [...t.modelValue.value], z = b.getData("text"), P = z.length >= l.value.length ? 0 : a.index, Z = Math.min(P + z.length, l.value.length);
      for (let V = P; V < Z; V++) {
        const U = l.value[V], q = z[V - P];
        n.value && !/^[0-9]*$/.test(q) || (C[V] = q, U.focus());
      }
      t.modelValue.value = C, ($ = l.value[Z]) == null || $.focus();
    }
    function _(M, $) {
      const b = [...t.modelValue.value];
      b[M] = $, t.modelValue.value = b;
    }
    return Ne(() => {
      t.onInputElementChange(s.value);
    }), Aa(() => {
      var M;
      (M = t.inputElements) == null || M.value.delete(s.value);
    }), (M, $) => (f(), k("input", {
      ref_key: "inputRef",
      ref: s,
      autocapitalize: "none",
      autocomplete: o.value ? "one-time-code" : "false",
      type: i.value ? "password" : "text",
      inputmode: n.value ? "numeric" : "text",
      pattern: n.value ? "[0-9]*" : void 0,
      placeholder: u(t).placeholder.value,
      value: u(t).modelValue.value.at(M.index),
      disabled: r.value,
      "data-disabled": r.value ? "" : void 0,
      "data-complete": u(t).isCompleted.value ? "" : void 0,
      "aria-label": `pin input ${M.index + 1} of ${l.value.length}`,
      onInput: c,
      onKeydown: [
        $e(p, ["left", "right", "up", "down", "home", "end"]),
        $e(d, ["backspace"]),
        $e(m, ["delete"])
      ],
      onFocus: y,
      onBlur: w,
      onPaste: g
    }, null, 40, Gr));
  }
}), fa = "-";
function Zr(e) {
  const a = Jr(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: l
  } = e;
  function r(n) {
    const i = n.split(fa);
    return i[0] === "" && i.length !== 1 && i.shift(), Wa(i, a) || Xr(n);
  }
  function o(n, i) {
    const s = t[n] || [];
    return i && l[n] ? [...s, ...l[n]] : s;
  }
  return {
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  };
}
function Wa(e, a) {
  var n;
  if (e.length === 0)
    return a.classGroupId;
  const t = e[0], l = a.nextPart.get(t), r = l ? Wa(e.slice(1), l) : void 0;
  if (r)
    return r;
  if (a.validators.length === 0)
    return;
  const o = e.join(fa);
  return (n = a.validators.find(({
    validator: i
  }) => i(o))) == null ? void 0 : n.classGroupId;
}
const wa = /^\[(.+)\]$/;
function Xr(e) {
  if (wa.test(e)) {
    const a = wa.exec(e)[1], t = a == null ? void 0 : a.substring(0, a.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function Jr(e) {
  const {
    theme: a,
    prefix: t
  } = e, l = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return el(Object.entries(e.classGroups), t).forEach(([o, n]) => {
    Yt(n, l, o, a);
  }), l;
}
function Yt(e, a, t, l) {
  e.forEach((r) => {
    if (typeof r == "string") {
      const o = r === "" ? a : $a(a, r);
      o.classGroupId = t;
      return;
    }
    if (typeof r == "function") {
      if (Qr(r)) {
        Yt(r(l), a, t, l);
        return;
      }
      a.validators.push({
        validator: r,
        classGroupId: t
      });
      return;
    }
    Object.entries(r).forEach(([o, n]) => {
      Yt(n, $a(a, o), t, l);
    });
  });
}
function $a(e, a) {
  let t = e;
  return a.split(fa).forEach((l) => {
    t.nextPart.has(l) || t.nextPart.set(l, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(l);
  }), t;
}
function Qr(e) {
  return e.isThemeGetter;
}
function el(e, a) {
  return a ? e.map(([t, l]) => {
    const r = l.map((o) => typeof o == "string" ? a + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([n, i]) => [a + n, i])) : o);
    return [t, r];
  }) : e;
}
function tl(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let a = 0, t = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
  function r(o, n) {
    t.set(o, n), a++, a > e && (a = 0, l = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get(o) {
      let n = t.get(o);
      if (n !== void 0)
        return n;
      if ((n = l.get(o)) !== void 0)
        return r(o, n), n;
    },
    set(o, n) {
      t.has(o) ? t.set(o, n) : r(o, n);
    }
  };
}
const qa = "!";
function al(e) {
  const a = e.separator, t = a.length === 1, l = a[0], r = a.length;
  return function(n) {
    const i = [];
    let s = 0, c = 0, p;
    for (let g = 0; g < n.length; g++) {
      let _ = n[g];
      if (s === 0) {
        if (_ === l && (t || n.slice(g, g + r) === a)) {
          i.push(n.slice(c, g)), c = g + r;
          continue;
        }
        if (_ === "/") {
          p = g;
          continue;
        }
      }
      _ === "[" ? s++ : _ === "]" && s--;
    }
    const d = i.length === 0 ? n : n.substring(c), m = d.startsWith(qa), y = m ? d.substring(1) : d, w = p && p > c ? p - c : void 0;
    return {
      modifiers: i,
      hasImportantModifier: m,
      baseClassName: y,
      maybePostfixModifierPosition: w
    };
  };
}
function nl(e) {
  if (e.length <= 1)
    return e;
  const a = [];
  let t = [];
  return e.forEach((l) => {
    l[0] === "[" ? (a.push(...t.sort(), l), t = []) : t.push(l);
  }), a.push(...t.sort()), a;
}
function rl(e) {
  return {
    cache: tl(e.cacheSize),
    splitModifiers: al(e),
    ...Zr(e)
  };
}
const ll = /\s+/;
function ol(e, a) {
  const {
    splitModifiers: t,
    getClassGroupId: l,
    getConflictingClassGroupIds: r
  } = a, o = /* @__PURE__ */ new Set();
  return e.trim().split(ll).map((n) => {
    const {
      modifiers: i,
      hasImportantModifier: s,
      baseClassName: c,
      maybePostfixModifierPosition: p
    } = t(n);
    let d = l(p ? c.substring(0, p) : c), m = !!p;
    if (!d) {
      if (!p)
        return {
          isTailwindClass: !1,
          originalClassName: n
        };
      if (d = l(c), !d)
        return {
          isTailwindClass: !1,
          originalClassName: n
        };
      m = !1;
    }
    const y = nl(i).join(":");
    return {
      isTailwindClass: !0,
      modifierId: s ? y + qa : y,
      classGroupId: d,
      originalClassName: n,
      hasPostfixModifier: m
    };
  }).reverse().filter((n) => {
    if (!n.isTailwindClass)
      return !0;
    const {
      modifierId: i,
      classGroupId: s,
      hasPostfixModifier: c
    } = n, p = i + s;
    return o.has(p) ? !1 : (o.add(p), r(s, c).forEach((d) => o.add(i + d)), !0);
  }).reverse().map((n) => n.originalClassName).join(" ");
}
function sl() {
  let e = 0, a, t, l = "";
  for (; e < arguments.length; )
    (a = arguments[e++]) && (t = Ga(a)) && (l && (l += " "), l += t);
  return l;
}
function Ga(e) {
  if (typeof e == "string")
    return e;
  let a, t = "";
  for (let l = 0; l < e.length; l++)
    e[l] && (a = Ga(e[l])) && (t && (t += " "), t += a);
  return t;
}
function il(e, ...a) {
  let t, l, r, o = n;
  function n(s) {
    const c = a.reduce((p, d) => d(p), e());
    return t = rl(c), l = t.cache.get, r = t.cache.set, o = i, i(s);
  }
  function i(s) {
    const c = l(s);
    if (c)
      return c;
    const p = ol(s, t);
    return r(s, p), p;
  }
  return function() {
    return o(sl.apply(null, arguments));
  };
}
function re(e) {
  const a = (t) => t[e] || [];
  return a.isThemeGetter = !0, a;
}
const Ka = /^\[(?:([a-z-]+):)?(.+)\]$/i, ul = /^\d+\/\d+$/, dl = /* @__PURE__ */ new Set(["px", "full", "screen"]), cl = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, fl = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, pl = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, ml = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, gl = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function De(e) {
  return Fe(e) || dl.has(e) || ul.test(e);
}
function Ve(e) {
  return nt(e, "length", $l);
}
function Fe(e) {
  return !!e && !Number.isNaN(Number(e));
}
function xt(e) {
  return nt(e, "number", Fe);
}
function rt(e) {
  return !!e && Number.isInteger(Number(e));
}
function vl(e) {
  return e.endsWith("%") && Fe(e.slice(0, -1));
}
function Y(e) {
  return Ka.test(e);
}
function Te(e) {
  return cl.test(e);
}
const bl = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function hl(e) {
  return nt(e, bl, Za);
}
function yl(e) {
  return nt(e, "position", Za);
}
const kl = /* @__PURE__ */ new Set(["image", "url"]);
function xl(e) {
  return nt(e, kl, _l);
}
function wl(e) {
  return nt(e, "", Cl);
}
function lt() {
  return !0;
}
function nt(e, a, t) {
  const l = Ka.exec(e);
  return l ? l[1] ? typeof a == "string" ? l[1] === a : a.has(l[1]) : t(l[2]) : !1;
}
function $l(e) {
  return fl.test(e) && !pl.test(e);
}
function Za() {
  return !1;
}
function Cl(e) {
  return ml.test(e);
}
function _l(e) {
  return gl.test(e);
}
function Sl() {
  const e = re("colors"), a = re("spacing"), t = re("blur"), l = re("brightness"), r = re("borderColor"), o = re("borderRadius"), n = re("borderSpacing"), i = re("borderWidth"), s = re("contrast"), c = re("grayscale"), p = re("hueRotate"), d = re("invert"), m = re("gap"), y = re("gradientColorStops"), w = re("gradientColorStopPositions"), g = re("inset"), _ = re("margin"), M = re("opacity"), $ = re("padding"), b = re("saturate"), C = re("scale"), z = re("sepia"), P = re("skew"), Z = re("space"), V = re("translate"), U = () => ["auto", "contain", "none"], q = () => ["auto", "hidden", "clip", "visible", "scroll"], G = () => ["auto", Y, a], L = () => [Y, a], fe = () => ["", De, Ve], pe = () => ["auto", Fe, Y], ze = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Ae = () => ["solid", "dashed", "dotted", "double", "none"], F = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], ee = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], H = () => ["", "0", Y], Q = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ne = () => [Fe, xt], ue = () => [Fe, Y];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [lt],
      spacing: [De, Ve],
      blur: ["none", "", Te, Y],
      brightness: ne(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Te, Y],
      borderSpacing: L(),
      borderWidth: fe(),
      contrast: ne(),
      grayscale: H(),
      hueRotate: ue(),
      invert: H(),
      gap: L(),
      gradientColorStops: [e],
      gradientColorStopPositions: [vl, Ve],
      inset: G(),
      margin: G(),
      opacity: ne(),
      padding: L(),
      saturate: ne(),
      scale: ne(),
      sepia: H(),
      skew: ue(),
      space: L(),
      translate: L()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Y]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Te]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Q()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Q()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...ze(), Y]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: q()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": q()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": q()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: U()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": U()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": U()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", rt, Y]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: G()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Y]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: H()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: H()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", rt, Y]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [lt]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", rt, Y]
        }, Y]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": pe()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": pe()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [lt]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [rt, Y]
        }, Y]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": pe()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": pe()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Y]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Y]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...ee()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ee(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...ee(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [$]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [$]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [$]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [$]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [$]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [$]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [$]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [$]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [$]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [_]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [_]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [_]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [_]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [_]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [_]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [_]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [_]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [_]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [Z]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [Z]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Y, a]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Y, a, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Y, a, "none", "full", "min", "max", "fit", "prose", {
          screen: [Te]
        }, Te]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Y, a, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Y, a, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Y, a, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Y, a, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Te, Ve]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", xt]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [lt]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Y]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Fe, xt]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", De, Y]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Y]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Y]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [M]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [M]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Ae(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", De, Ve]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", De, Y]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: L()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Y]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Y]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [M]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...ze(), yl]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", hl]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, xl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [w]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [w]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [w]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [y]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [M]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Ae(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [M]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Ae()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Ae()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [De, Y]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [De, Ve]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: fe()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [M]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [De, Ve]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Te, wl]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [lt]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [M]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": F()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": F()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [l]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [s]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Te, Y]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [p]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [b]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [z]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [l]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [s]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [p]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [M]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [b]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [z]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [n]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [n]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [n]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Y]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ue()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Y]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ue()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Y]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [rt, Y]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [V]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [V]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [P]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [P]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Y]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Y]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": L()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": L()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": L()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": L()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": L()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": L()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": L()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": L()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": L()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": L()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": L()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": L()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": L()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": L()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": L()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": L()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": L()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": L()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Y]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [De, Ve, xt]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const We = /* @__PURE__ */ il(Sl), Ju = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "CfgOtpInput",
  props: /* @__PURE__ */ ka({
    placeholder: {},
    disabled: { type: Boolean },
    size: { default: 6 },
    error: { type: Boolean, default: !1 },
    inputClass: { default: "" }
  }, {
    modelValue: { default: [] }
  }),
  emits: /* @__PURE__ */ ka(["complete"], ["update:modelValue"]),
  setup(e) {
    const a = $n(e, "modelValue");
    return (t, l) => (f(), A(u(qr), J({
      modelValue: a.value,
      "onUpdate:modelValue": l[0] || (l[0] = (r) => a.value = r)
    }, { ...u(Ie)(t.$attrs, ["class"]), ...t.$props }, {
      otp: "",
      type: "number",
      class: u(We)("flex items-center gap-x-4", t.$attrs.class),
      onComplete: l[1] || (l[1] = (r) => t.$emit("complete", r))
    }), {
      default: h(() => [
        (f(!0), k(K, null, le(t.size, (r, o) => (f(), A(u(Kr), {
          key: r,
          index: o,
          class: S({
            [`${u(We)(`
          shadow-lg focus:borcer-white size-14 rounded-lg border-[#e8e8f0] bg-white text-center
          focus:border-[#e8e8f0] focus:outline focus:outline-2 focus:outline-offset-0 focus:outline-brand
        `, t.inputClass)}`]: !0,
            "shadow-[0_2px_0_0_#D16363]": t.error
          })
        }, null, 8, ["index", "class"]))), 128))
      ]),
      _: 1
    }, 16, ["modelValue", "class"]));
  }
}), Ml = { class: "flex" }, Dl = { class: "cfg-checkbox__checkbox flex h-[1.3em] w-[1.3em] items-center" }, Bl = ["id", "disabled"], zl = { class: "flex" }, Al = ["innerHTML"], Vl = {
  key: 0,
  class: "text-red"
}, Tl = { inheritAttrs: !1 }, El = /* @__PURE__ */ R({
  ...Tl,
  __name: "CfgCheckbox",
  props: {
    ...ie,
    inputClasses: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    focused: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "update:focused"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = B(() => s.id || ht("checkbox")), o = At("inputRef"), n = ce(t, "modelValue", l), { class: i, ...s } = Pt(), c = B(() => ({
      root: { class: i || "" },
      input: s
    })), { focused: p } = at(o, {
      initialValue: t.initialFocused
    });
    return X(p, (d) => {
      l("update:focused", d);
    }), X(() => t.focused, (d) => {
      p.value = d;
    }), (d, m) => (f(), k("span", J(c.value.root, {
      class: ["cfg-checkbox relative block", {
        focused: e.focused,
        disabled: d.disabled,
        "opacity-60": d.disabled,
        "cursor-pointer": !d.disabled,
        "cursor-not-allowed": d.disabled
      }]
    }), [
      v("span", Ml, [
        v("label", Dl, [
          tt(v("input", J({
            id: String(r.value),
            ref_key: "inputRef",
            ref: o,
            "onUpdate:modelValue": m[0] || (m[0] = (y) => Be(n) ? n.value = y : null),
            type: "checkbox",
            disabled: d.disabled
          }, c.value.input, {
            class: ["relative z-10 h-[1.3em] w-[1.3em] rounded border-grey-stroke text-brand focus:ring-brand-200", e.inputClasses]
          }), null, 16, Bl), [
            [Cn, u(n)]
          ])
        ]),
        v("span", {
          class: S(["ml-3 block text-sm", {
            "text-red": d.error
          }])
        }, [
          x(I, {
            for: String(r.value),
            class: S(["block", {
              "cursor-pointer": !d.disabled,
              "cursor-not-allowed": d.disabled,
              "pt-1": !d.caption && !d.$slots.label && !d.placeholder,
              "text-grey-400": !d.error
            }]),
            "tag-name": "label",
            size: u(N).sm
          }, {
            default: h(() => [
              d.$slots.label || d.placeholder ? T(d.$slots, "label", {
                key: 0,
                focused: e.focused,
                checked: e.modelValue
              }, () => [
                v("span", zl, [
                  v("span", {
                    class: "leading-6",
                    innerHTML: d.placeholder
                  }, null, 8, Al),
                  d.required ? (f(), k("span", Vl, "*")) : D("", !0)
                ])
              ], !0) : D("", !0)
            ]),
            _: 3
          }, 8, ["for", "class", "size"]),
          d.caption && d.placeholder ? (f(), A(I, {
            key: 0,
            size: u(N).xs,
            class: S(["mt-1 block", {
              "text-grey-300": !d.error
            }])
          }, {
            default: h(() => [
              j(E(d.caption), 1)
            ]),
            _: 1
          }, 8, ["size", "class"])) : D("", !0)
        ], 2)
      ]),
      d.error && d.errorMessage ? (f(), A(I, {
        key: 0,
        size: u(N).xs,
        class: "mt-3 block text-red"
      }, {
        default: h(() => [
          j(E(d.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : d.caption && !d.placeholder ? (f(), A(I, {
        key: 1,
        size: u(N).xs,
        class: "mt-3 block text-grey-300"
      }, {
        default: h(() => [
          j(E(d.caption), 1)
        ]),
        _: 1
      }, 8, ["size"])) : D("", !0)
    ], 16));
  }
});
const Vt = /* @__PURE__ */ Re(El, [["__scopeId", "data-v-2ad8ed21"]]), Ol = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vt
}, Symbol.toStringTag, { value: "Module" })), Pl = { class: "flex gap-x-4" }, Ll = { class: "-m-3 flex grow justify-center gap-x-1 overflow-auto p-3 transition-all md:gap-x-2.5" }, Nl = /* @__PURE__ */ R({
  __name: "CfgPagination",
  props: {
    page: {},
    totalItems: {},
    itemsPerPage: {}
  },
  emits: ["update:page"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = B(() => Array.from({
      length: Math.ceil(t.totalItems / t.itemsPerPage)
    })), o = B(() => {
      const d = Math.ceil(t.totalItems / t.itemsPerPage), m = 1, y = [], w = 5 + m * 2;
      let g = d <= w ? 1 : t.page - m, _ = d <= w ? d : t.page + m;
      if (_ = _ > d ? d : _, g = g < 1 ? 1 : g, d > w) {
        const M = g - 1 < 3, $ = d - _ < 3;
        if (M) {
          _ = w - 2;
          for (let b = 1; b < g; b++)
            y.push(b);
        } else
          y.push(1), y.push(null);
        if ($) {
          g = d - (w - 3);
          for (let b = g; b <= d; b++)
            y.push(b);
        } else {
          for (let b = g; b <= _; b++)
            y.push(b);
          y.push(null), y.push(d);
        }
      } else
        for (let M = g; M <= _; M++)
          y.push(M);
      return y;
    }), n = B(() => t.page > 1), i = B(() => t.page < r.value.length);
    function s() {
      n.value && l("update:page", t.page - 1);
    }
    function c() {
      i.value && l("update:page", t.page + 1);
    }
    function p(d) {
      l("update:page", d);
    }
    return (d, m) => (f(), k("nav", Pl, [
      v("button", {
        type: "button",
        class: S(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !n.value
        }]),
        "aria-label": "Předchozí stránka",
        onClick: s
      }, [
        x(u(zt))
      ], 2),
      v("ul", Ll, [
        (f(!0), k(K, null, le(o.value, (y, w) => (f(), k("li", {
          key: y || w
        }, [
          (f(), A(be(y ? "a" : "span"), {
            class: S(["rounded-md border py-[0.5em] text-sm font-medium leading-none transition-colors duration-200", {
              "text-brand": y === d.page,
              "border-[transparent] text-grey-300": y !== d.page,
              "lg:hover:border-grey-stroke lg:hover:text-grey-400": d.page && y !== d.page,
              "focusable px-3": d.page
            }]),
            href: "#",
            onClick: Pe((g) => y && p(y), ["prevent"])
          }, {
            default: h(() => [
              v("span", null, E(y || "..."), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        ]))), 128))
      ]),
      v("button", {
        type: "button",
        class: S(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !i.value
        }]),
        "aria-label": "Další stránka",
        onClick: c
      }, [
        x(u(Lt))
      ], 2)
    ]));
  }
}), Il = {
  primary: "primary",
  secondary: "secondary",
  grey: "grey",
  light: "light",
  warning: "warning",
  dark: "dark"
}, Rl = { class: "container mx-auto py-3" }, Fl = { class: "flex flex-wrap items-center justify-between" }, jl = { class: "flex w-0 flex-1 items-center" }, Hl = {
  key: 0,
  class: "cfg-header-banner--icon flex rounded-lg p-2"
}, Ul = {
  key: 1,
  class: "cfg-header-banner--text ml-3 font-medium"
}, Yl = {
  key: 0,
  class: "order-3 mt-2 w-full shrink-0 sm:order-2 sm:mt-0 sm:w-auto"
}, Wl = { class: "order-2 shrink-0 sm:order-3 sm:ml-3" }, ql = /* @__PURE__ */ v("span", { class: "sr-only" }, "Dismiss", -1), Qu = /* @__PURE__ */ R({
  __name: "CfgHeaderBanner",
  props: {
    variant: { default: Il.primary },
    modelValue: { type: Boolean, default: !0 },
    text: { default: "" },
    buttonText: { default: "" },
    buttonLink: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const r = ce(e, "modelValue", a);
    return (o, n) => {
      const i = _n("RouterLink");
      return tt((f(), k("div", {
        class: S(["cfg-header-banner", { [`cfg-header-banner--${o.variant}`]: !0 }])
      }, [
        v("div", Rl, [
          v("div", Fl, [
            v("div", jl, [
              o.$slots.icon ? (f(), k("span", Hl, [
                T(o.$slots, "icon", {
                  class: "h-6 w-6",
                  ariaHidden: "true"
                })
              ])) : D("", !0),
              o.text || o.$slots.default ? (f(), k("p", Ul, [
                T(o.$slots, "default", {}, () => [
                  j(E(o.text), 1)
                ])
              ])) : D("", !0)
            ]),
            o.buttonLink ? (f(), k("div", Yl, [
              x(i, {
                to: o.buttonLink,
                class: "cfg-header-banner--link flex items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium"
              }, {
                default: h(() => [
                  j(E(o.buttonText || o.buttonLink), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])) : D("", !0),
            v("div", Wl, [
              v("button", {
                type: "button",
                class: "cfg-header-banner--dismiss -mr-1 flex rounded-md p-2 focus:outline-none focus:ring-2 sm:-mr-2",
                onClick: n[0] || (n[0] = (s) => r.value = !1)
              }, [
                ql,
                x(u(Ue), {
                  class: "h-6 w-6",
                  "aria-hidden": "true"
                })
              ])
            ])
          ])
        ])
      ], 2)), [
        [bt, u(r)]
      ]);
    };
  }
});
function Gl(e, a = {}) {
  let t;
  const { immediate: l, ...r } = a, o = O(!1), n = O(!1), i = (d) => t && t.activate(d), s = (d) => t && t.deactivate(d), c = () => {
    t && (t.pause(), n.value = !0);
  }, p = () => {
    t && (t.unpause(), n.value = !1);
  };
  return X(
    () => Nn(e),
    (d) => {
      d && (t = ir(d, {
        ...r,
        onActivate() {
          o.value = !0, a.onActivate && a.onActivate();
        },
        onDeactivate() {
          o.value = !1, a.onDeactivate && a.onDeactivate();
        }
      }), l && i());
    },
    { flush: "post" }
  ), In(() => s()), {
    hasFocus: o,
    isPaused: n,
    activate: i,
    deactivate: s,
    pause: c,
    unpause: p
  };
}
const Kl = ["aria-expanded"], Zl = {
  inheritAttrs: !1
}, Xl = /* @__PURE__ */ R({
  ...Zl,
  __name: "CfgDropdown",
  props: {
    /**
     * Controls the position of the menu;
     */
    originX: {
      type: String,
      default: "right"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: String,
      default: "280px"
    },
    hideOnScroll: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, l = O(!1), r = O(null), o = O(null), n = O(null), i = O(l.value);
    let s = null;
    const { deactivate: c, activate: p } = Gl(n, {
      immediate: !1,
      preventScroll: !0,
      clickOutsideDeactivates: !0
    });
    Ne(() => {
      if (Ht(document.documentElement, "keydown", ($) => {
        $.key === "Escape" && M();
      }), t.hideOnScroll) {
        let $ = 0;
        Ht(window, "scroll", () => {
          $ += 1, $ > 3 && (M(), $ = 0);
        });
      }
    });
    const { x: d, y: m, strategy: y } = na(o, n, {
      placement: "bottom-end",
      whileElementsMounted: ra
    });
    X(l, ($) => {
      $ || (s && (clearTimeout(s), s = null), s = setTimeout(() => {
        i.value = $;
      }, $ ? 0 : 50), g() && c()), i.value = $;
    });
    function w() {
      g() && p();
    }
    function g() {
      return n.value && n.value.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').length > 0;
    }
    function _() {
      l.value = !0;
    }
    function M() {
      l.value = !1;
    }
    return ($, b) => (f(), k("div", {
      ref_key: "dropdownRoot",
      ref: r
    }, [
      v("div", J($.$attrs, {
        class: ["relative w-max", {
          "z-floating-overlay": l.value && e.overlay
        }]
      }), [
        v("div", {
          ref_key: "menuButton",
          ref: o
        }, [
          v("button", {
            type: "button",
            class: S(["focusable flex cursor-pointer items-center justify-center", {
              "z-floating-trigger relative rounded-t-xl bg-white": l.value && e.overlay,
              "lg:hover:bor==der-brand hover:!text-brand rounded-xl": !l.value && e.overlay,
              "border-2 border-transparent !transition-all !duration-300": e.overlay
            }]),
            "aria-expanded": l.value,
            onClick: b[0] || (b[0] = (C) => l.value ? M() : _())
          }, [
            T($.$slots, "trigger", { opened: l.value })
          ], 10, Kl)
        ], 512),
        (f(), A(Zt, { to: "body" }, [
          v("div", {
            class: S(["z-floating-overlay fixed inset-0", {
              "pointer-events-none opacity-0": !l.value,
              "bg-black/30": e.overlay
            }]),
            onClick: M,
            onKeydown: $e(() => {
            }, ["enter"])
          }, null, 34),
          x(ft, {
            "enter-active-class": "transition duration-200 ease-out",
            "enter-from-class": "transform scale-75 -translate-y-3 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
            "leave-active-class": "transition duration-200 ease-out",
            "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
            "leave-to-class": "transform scale-75 -translate-y-3 opacity-0",
            onAfterEnter: w
          }, {
            default: h(() => [
              i.value ? tt((f(), k("div", {
                key: 0,
                ref_key: "dropdownContent",
                ref: n,
                style: ye({
                  top: `${u(m)}px`,
                  left: `${u(d)}px`,
                  position: u(y),
                  maxWidth: e.maxWidth
                }),
                class: S(["z-floating-content dropdown-content w-max bg-white focus:outline-none", {
                  "origin-top-right": e.originX === "right",
                  "left-0 origin-top-left": e.originX === "left",
                  "shadow-extra mt-2 rounded-xl": !e.overlay,
                  "rounded-b-xl rounded-tl-xl": e.overlay
                }])
              }, [
                T($.$slots, "default", {
                  opened: l.value,
                  close: M
                })
              ], 6)), [
                [bt, l.value]
              ]) : D("", !0)
            ]),
            _: 3
          })
        ]))
      ], 16)
    ], 512));
  }
}), Jl = { class: "relative block" }, Ql = ["value"], eo = {
  inheritAttrs: !1
}, St = /* @__PURE__ */ R({
  ...eo,
  __name: "CfgCompactInput",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    /**
     * @param string
    * Suffix to be displayed after the input. Recommended length is 2-3 characters.
    */
    suffix: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur", "keydown:enter"],
  setup(e, { emit: a }) {
    const t = a;
    function l(n) {
      var i;
      t("update:modelValue", ((i = n == null ? void 0 : n.target) == null ? void 0 : i.value) || "");
    }
    function r(n) {
      var i;
      t("blur", ((i = n == null ? void 0 : n.target) == null ? void 0 : i.value) || "");
    }
    function o(n) {
      var i;
      t("keydown:enter", ((i = n == null ? void 0 : n.target) == null ? void 0 : i.value) || "");
    }
    return (n, i) => {
      var s;
      return f(), k("label", Jl, [
        v("input", J({
          class: ["cfg-slider__input focusable w-full rounded-md border border-grey-stroke px-3 py-2 text-xs !leading-none", {
            "!pr-11": !!((s = e.suffix) != null && s.trim())
          }],
          value: e.modelValue
        }, n.$attrs, {
          onInput: l,
          onBlur: r,
          onKeydown: $e(o, ["enter"])
        }), null, 16, Ql),
        e.suffix ? (f(), A(I, {
          key: 0,
          class: "absolute right-4 top-1/2 -translate-y-1/2 leading-none text-grey-300",
          size: u(N).xs
        }, {
          default: h(() => [
            j(E(e.suffix), 1)
          ]),
          _: 1
        }, 8, ["size"])) : D("", !0)
      ]);
    };
  }
});
var Xa = 60, Ja = Xa * 60, Qa = Ja * 24, to = Qa * 7, Qe = 1e3, Rt = Xa * Qe, Ca = Ja * Qe, ao = Qa * Qe, no = to * Qe, pa = "millisecond", qe = "second", Ge = "minute", Ke = "hour", Ee = "day", Mt = "week", we = "month", en = "quarter", Oe = "year", Ze = "date", ro = "YYYY-MM-DDTHH:mm:ssZ", _a = "Invalid Date", lo = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, oo = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
const so = {
  name: "en",
  weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
  months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
  ordinal: function(a) {
    var t = ["th", "st", "nd", "rd"], l = a % 100;
    return "[" + a + (t[(l - 20) % 10] || t[l] || t[0]) + "]";
  }
};
var Wt = function(a, t, l) {
  var r = String(a);
  return !r || r.length >= t ? a : "" + Array(t + 1 - r.length).join(l) + a;
}, io = function(a) {
  var t = -a.utcOffset(), l = Math.abs(t), r = Math.floor(l / 60), o = l % 60;
  return (t <= 0 ? "+" : "-") + Wt(r, 2, "0") + ":" + Wt(o, 2, "0");
}, uo = function e(a, t) {
  if (a.date() < t.date())
    return -e(t, a);
  var l = (t.year() - a.year()) * 12 + (t.month() - a.month()), r = a.clone().add(l, we), o = t - r < 0, n = a.clone().add(l + (o ? -1 : 1), we);
  return +(-(l + (t - r) / (o ? r - n : n - r)) || 0);
}, co = function(a) {
  return a < 0 ? Math.ceil(a) || 0 : Math.floor(a);
}, fo = function(a) {
  var t = {
    M: we,
    y: Oe,
    w: Mt,
    d: Ee,
    D: Ze,
    h: Ke,
    m: Ge,
    s: qe,
    ms: pa,
    Q: en
  };
  return t[a] || String(a || "").toLowerCase().replace(/s$/, "");
}, po = function(a) {
  return a === void 0;
};
const mo = {
  s: Wt,
  z: io,
  m: uo,
  a: co,
  p: fo,
  u: po
};
var ut = "en", je = {};
je[ut] = so;
var tn = "$isDayjsObject", ma = function(a) {
  return a instanceof It || !!(a && a[tn]);
}, Tt = function e(a, t, l) {
  var r;
  if (!a)
    return ut;
  if (typeof a == "string") {
    var o = a.toLowerCase();
    je[o] && (r = o), t && (je[o] = t, r = o);
    var n = a.split("-");
    if (!r && n.length > 1)
      return e(n[0]);
  } else {
    var i = a.name;
    je[i] = a, r = i;
  }
  return !l && r && (ut = r), r || !l && ut;
}, ae = function(a, t) {
  if (ma(a))
    return a.clone();
  var l = typeof t == "object" ? t : {};
  return l.date = a, l.args = arguments, new It(l);
}, go = function(a, t) {
  return ae(a, {
    locale: t.$L,
    utc: t.$u,
    x: t.$x,
    $offset: t.$offset
    // todo: refactor; do not use this.$offset in you code
  });
}, te = mo;
te.l = Tt;
te.i = ma;
te.w = go;
var vo = function(a) {
  var t = a.date, l = a.utc;
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  if (te.u(t))
    return /* @__PURE__ */ new Date();
  if (t instanceof Date)
    return new Date(t);
  if (typeof t == "string" && !/Z$/i.test(t)) {
    var r = t.match(lo);
    if (r) {
      var o = r[2] - 1 || 0, n = (r[7] || "0").substring(0, 3);
      return l ? new Date(Date.UTC(r[1], o, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, n)) : new Date(r[1], o, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, n);
    }
  }
  return new Date(t);
}, It = /* @__PURE__ */ function() {
  function e(t) {
    this.$L = Tt(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[tn] = !0;
  }
  var a = e.prototype;
  return a.parse = function(l) {
    this.$d = vo(l), this.init();
  }, a.init = function() {
    var l = this.$d;
    this.$y = l.getFullYear(), this.$M = l.getMonth(), this.$D = l.getDate(), this.$W = l.getDay(), this.$H = l.getHours(), this.$m = l.getMinutes(), this.$s = l.getSeconds(), this.$ms = l.getMilliseconds();
  }, a.$utils = function() {
    return te;
  }, a.isValid = function() {
    return this.$d.toString() !== _a;
  }, a.isSame = function(l, r) {
    var o = ae(l);
    return this.startOf(r) <= o && o <= this.endOf(r);
  }, a.isAfter = function(l, r) {
    return ae(l) < this.startOf(r);
  }, a.isBefore = function(l, r) {
    return this.endOf(r) < ae(l);
  }, a.$g = function(l, r, o) {
    return te.u(l) ? this[r] : this.set(o, l);
  }, a.unix = function() {
    return Math.floor(this.valueOf() / 1e3);
  }, a.valueOf = function() {
    return this.$d.getTime();
  }, a.startOf = function(l, r) {
    var o = this, n = te.u(r) ? !0 : r, i = te.p(l), s = function(M, $) {
      var b = te.w(o.$u ? Date.UTC(o.$y, $, M) : new Date(o.$y, $, M), o);
      return n ? b : b.endOf(Ee);
    }, c = function(M, $) {
      var b = [0, 0, 0, 0], C = [23, 59, 59, 999];
      return te.w(o.toDate()[M].apply(
        // eslint-disable-line prefer-spread
        o.toDate("s"),
        (n ? b : C).slice($)
      ), o);
    }, p = this.$W, d = this.$M, m = this.$D, y = "set" + (this.$u ? "UTC" : "");
    switch (i) {
      case Oe:
        return n ? s(1, 0) : s(31, 11);
      case we:
        return n ? s(1, d) : s(0, d + 1);
      case Mt: {
        var w = this.$locale().weekStart || 0, g = (p < w ? p + 7 : p) - w;
        return s(n ? m - g : m + (6 - g), d);
      }
      case Ee:
      case Ze:
        return c(y + "Hours", 0);
      case Ke:
        return c(y + "Minutes", 1);
      case Ge:
        return c(y + "Seconds", 2);
      case qe:
        return c(y + "Milliseconds", 3);
      default:
        return this.clone();
    }
  }, a.endOf = function(l) {
    return this.startOf(l, !1);
  }, a.$set = function(l, r) {
    var o, n = te.p(l), i = "set" + (this.$u ? "UTC" : ""), s = (o = {}, o[Ee] = i + "Date", o[Ze] = i + "Date", o[we] = i + "Month", o[Oe] = i + "FullYear", o[Ke] = i + "Hours", o[Ge] = i + "Minutes", o[qe] = i + "Seconds", o[pa] = i + "Milliseconds", o)[n], c = n === Ee ? this.$D + (r - this.$W) : r;
    if (n === we || n === Oe) {
      var p = this.clone().set(Ze, 1);
      p.$d[s](c), p.init(), this.$d = p.set(Ze, Math.min(this.$D, p.daysInMonth())).$d;
    } else
      s && this.$d[s](c);
    return this.init(), this;
  }, a.set = function(l, r) {
    return this.clone().$set(l, r);
  }, a.get = function(l) {
    return this[te.p(l)]();
  }, a.add = function(l, r) {
    var o = this, n;
    l = Number(l);
    var i = te.p(r), s = function(m) {
      var y = ae(o);
      return te.w(y.date(y.date() + Math.round(m * l)), o);
    };
    if (i === we)
      return this.set(we, this.$M + l);
    if (i === Oe)
      return this.set(Oe, this.$y + l);
    if (i === Ee)
      return s(1);
    if (i === Mt)
      return s(7);
    var c = (n = {}, n[Ge] = Rt, n[Ke] = Ca, n[qe] = Qe, n)[i] || 1, p = this.$d.getTime() + l * c;
    return te.w(p, this);
  }, a.subtract = function(l, r) {
    return this.add(l * -1, r);
  }, a.format = function(l) {
    var r = this, o = this.$locale();
    if (!this.isValid())
      return o.invalidDate || _a;
    var n = l || ro, i = te.z(this), s = this.$H, c = this.$m, p = this.$M, d = o.weekdays, m = o.months, y = o.meridiem, w = function(b, C, z, P) {
      return b && (b[C] || b(r, n)) || z[C].slice(0, P);
    }, g = function(b) {
      return te.s(s % 12 || 12, b, "0");
    }, _ = y || function($, b, C) {
      var z = $ < 12 ? "AM" : "PM";
      return C ? z.toLowerCase() : z;
    }, M = function(b) {
      switch (b) {
        case "YY":
          return String(r.$y).slice(-2);
        case "YYYY":
          return te.s(r.$y, 4, "0");
        case "M":
          return p + 1;
        case "MM":
          return te.s(p + 1, 2, "0");
        case "MMM":
          return w(o.monthsShort, p, m, 3);
        case "MMMM":
          return w(m, p);
        case "D":
          return r.$D;
        case "DD":
          return te.s(r.$D, 2, "0");
        case "d":
          return String(r.$W);
        case "dd":
          return w(o.weekdaysMin, r.$W, d, 2);
        case "ddd":
          return w(o.weekdaysShort, r.$W, d, 3);
        case "dddd":
          return d[r.$W];
        case "H":
          return String(s);
        case "HH":
          return te.s(s, 2, "0");
        case "h":
          return g(1);
        case "hh":
          return g(2);
        case "a":
          return _(s, c, !0);
        case "A":
          return _(s, c, !1);
        case "m":
          return String(c);
        case "mm":
          return te.s(c, 2, "0");
        case "s":
          return String(r.$s);
        case "ss":
          return te.s(r.$s, 2, "0");
        case "SSS":
          return te.s(r.$ms, 3, "0");
        case "Z":
          return i;
      }
      return null;
    };
    return n.replace(oo, function($, b) {
      return b || M($) || i.replace(":", "");
    });
  }, a.utcOffset = function() {
    return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
  }, a.diff = function(l, r, o) {
    var n = this, i = te.p(r), s = ae(l), c = (s.utcOffset() - this.utcOffset()) * Rt, p = this - s, d = function() {
      return te.m(n, s);
    }, m;
    switch (i) {
      case Oe:
        m = d() / 12;
        break;
      case we:
        m = d();
        break;
      case en:
        m = d() / 3;
        break;
      case Mt:
        m = (p - c) / no;
        break;
      case Ee:
        m = (p - c) / ao;
        break;
      case Ke:
        m = p / Ca;
        break;
      case Ge:
        m = p / Rt;
        break;
      case qe:
        m = p / Qe;
        break;
      default:
        m = p;
        break;
    }
    return o ? m : te.a(m);
  }, a.daysInMonth = function() {
    return this.endOf(we).$D;
  }, a.$locale = function() {
    return je[this.$L];
  }, a.locale = function(l, r) {
    if (!l)
      return this.$L;
    var o = this.clone(), n = Tt(l, r, !0);
    return n && (o.$L = n), o;
  }, a.clone = function() {
    return te.w(this.$d, this);
  }, a.toDate = function() {
    return new Date(this.valueOf());
  }, a.toJSON = function() {
    return this.isValid() ? this.toISOString() : null;
  }, a.toISOString = function() {
    return this.$d.toISOString();
  }, a.toString = function() {
    return this.$d.toUTCString();
  }, e;
}(), an = It.prototype;
ae.prototype = an;
[["$ms", pa], ["$s", qe], ["$m", Ge], ["$H", Ke], ["$W", Ee], ["$M", we], ["$y", Oe], ["$D", Ze]].forEach(function(e) {
  an[e[1]] = function(a) {
    return this.$g(a, e[0], e[1]);
  };
});
ae.extend = function(e, a) {
  return e.$i || (e(a, It, ae), e.$i = !0), ae;
};
ae.locale = Tt;
ae.isDayjs = ma;
ae.unix = function(e) {
  return ae(e * 1e3);
};
ae.en = je[ut];
ae.Ls = je;
ae.p = {};
var ga = {};
Object.defineProperty(ga, "__esModule", {
  value: !0
});
ga.RodneCislo = rn;
var nn = ga.rodnecislo = yo, wt = {
  MALE: "MALE",
  FEMALE: "FEMALE"
}, Sa = 1, bo = 18, ho = 0;
function rn(e) {
  var a = this, t, l, r, o, n, i, s, c = wt.MALE, p = !1, d = null;
  this.year = function() {
    return s;
  }, this.month = function() {
    return i;
  }, this.day = function() {
    return n;
  }, this.birthDate = function() {
    return new Date(s, i, n);
  }, this.birthDateAsString = function() {
    return "".concat(n, ".").concat(i + Sa, ".").concat(s);
  }, this.dic = function() {
    return "CZ".concat(t).concat(l).concat(r).concat(o);
  }, this.gender = function() {
    return c;
  }, this.isMale = function() {
    return c === wt.MALE;
  }, this.isFemale = function() {
    return c === wt.FEMALE;
  }, this.isValid = function() {
    return !d && a.age() >= ho;
  }, this.isPossible = function() {
    return !d;
  }, this.error = function() {
    return d;
  }, this.isAdult = function() {
    var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : bo;
    return a.age() >= H;
  }, this.age = function() {
    var H = /* @__PURE__ */ new Date(), Q = H.getFullYear(), ne = H.getMonth(), ue = H.getDate(), W = Q - s;
    return ne > i ? W : ne < i ? --W : ue >= n ? W : --W;
  };
  var m = /^(\d\d)(\d\d)(\d\d)\/?(\d\d\d\d?)$/, y = 1, w = 2, g = 3, _ = 4, M = 4, $ = 0, b = -1, C = 11, z = 0, P = 10, Z = 0;
  function V(H) {
    var Q = m.exec(H);
    if (!Q)
      return d = "Didn't match RegEx", !1;
    p = Q[_].length === M;
    var ne, ue, W;
    try {
      t = Q[y], l = Q[w], r = Q[g], o = Q[_], p && (ne = "".concat(Q[y]).concat(Q[w]).concat(Q[g]).concat(Q[_]), ue = +ne.slice($, b), W = +ne.slice(b), ne = +ne);
    } catch {
      return d = "Failed to parse input string", !1;
    }
    if (p && ne % C !== z) {
      if (!(ue % C === P && W === Z))
        return d = "Failed the modulo condition", !1;
    }
    return !0;
  }
  var U = 53, q = 1900, G = 2e3, L = 2004, fe = 50, pe = 20;
  function ze() {
    if (s = +t, !p && s <= U)
      s += q;
    else if (p && s > U)
      s += q;
    else if (p && s <= U)
      s += G;
    else
      return d = "We didn't think about this yet...", !1;
    return !0;
  }
  function Ae() {
    if (i = +l, i > fe && (c = wt.FEMALE, i %= fe), i > pe)
      if (s >= L)
        i %= pe;
      else
        return d = "Addition of month+20 is allowed for year >= 2004 only.", !1;
    return i -= Sa, n = +r, !0;
  }
  function F() {
    var H = new Date(s, i, n), Q = "".concat(H.getFullYear(), "-").concat(H.getMonth(), "-").concat(H.getDate()), ne = "".concat(s, "-").concat(i, "-").concat(n);
    return ne !== Q ? (d = "Invalid birth date", !1) : !0;
  }
  function ee() {
    return ze() && Ae() && F();
  }
  return V(e), ee(), this;
}
function yo(e) {
  return new rn(e);
}
var dt = /* @__PURE__ */ ((e) => (e.KomercniBanka = "0100", e.CeskoslovenskaObchodniBanka = "0300", e.MonetaMoneyBank = "0600", e.CeskaNarodniBanka = "0710", e.CeskaSporitelna = "0800", e.FioBanka = "2010", e.Cifin = "2060", e.TrinityBank = "2070", e.HypotecniBanka = "2100", e.PenezniDum = "2200", e.Artesa = "2220", e.BankaCreditas = "2250", e.Ney = "2260", e.PodnikatelskaDruzstevniZalozna = "2275", e.CitibankEurope = "2600", e.UniCreditBank = "2700", e.AirBank = "3030", e.BNPParibasPersonalFinance = "3050", e.PKO = "3060", e.INGBank = "3500", e.MaxBanka = "4000", e.NarodniRozvojovaBanka = "4300", e.Raiffeisenbank = "5500", e.JAndTBanka = "5800", e.PPFBanka = "6000", e.COMMERZBANK = "6200", e.MBank = "6210", e.BNPParibas = "6300", e.VseobecnaUverovaBanka = "6700", e.Sberbank = "6800", e.DeutscheBank = "7910", e.RaiffeisenStavebniSporitelna = "7950", e.CSOBStavebniSporitelna = "7960", e.MonetaStavebniSporitelna = "7970", e.ModraPyramidaStavebniSporitelna = "7990", e.VolksbankRaiffeisenbank = "8030", e.Oberbank = "8040", e.StavebniSporitelnaCeskeSporitelny = "8060", e.CeskaExportniBanka = "8090", e.HSBCContinentalEurope = "8150", e.SparkasseOberlausitzNiederschlesien = "8190", e.FASFinanceCompany = "8198", e.MoneyPoloEurope = "8199", e.PRIVATBANKDerRaiffeisenlandesbank = "8200", e.PaymentExecution = "8220", e.ABAPAY = "8230", e.DruzstevniZaloznaKredit = "8240", e.BankOfChina = "8250", e.BankOfCommunications = "8255", e.IndustrialAndCommercialBankOfChina = "8265", e.FairplayPay = "8270", e.BEfekt = "8280", e.MercuriusPartners = "8293", e.BESTPAY = "8299", e.FerratumBank = "8500", e))(dt || {});
const ko = {
  "0100": "Komerční banka, a.s.",
  "0300": "Československá obchodní banka, a. s.",
  "0600": "MONETA Money Bank, a.s.",
  "0710": "ČESKÁ NÁRODNÍ BANKA",
  "0800": "Česká spořitelna, a.s.",
  2010: "Fio banka, a.s.",
  2060: "Citfin, spořitelní družstvo",
  2070: "TRINITY BANK a.s.",
  2100: "Hypoteční banka,",
  2200: "Peněžní dům, spořitelní",
  2220: "Artesa, spořitelní družstvo",
  2250: "Banka CREDITAS a.s.",
  2260: "NEY spořitelní",
  2275: "Podnikatelská družstevní záložna",
  2600: "Citibank Europe plc, organizační složka",
  2700: "UniCredit Bank Czech Republic and Slovakia, a.s.",
  3030: "Air Bank a.s.",
  3050: "BNP Paribas Personal Finance SA, odštěpný závod",
  3060: "PKO BP S.A., Czech Branch",
  3500: "ING Bank N.V.",
  4e3: "Max banka a.s.",
  4300: "Národní rozvojová banka, a.s.",
  5500: "Raiffeisenbank a.s.",
  5800: "J&T BANKA, a.s.",
  6e3: "PPF banka a.s.",
  6200: "COMMERZBANK Aktiengesellschaft, pobočka Praha",
  6210: "mBank S.A., organizační složka",
  6300: "BNP Paribas S.A., pobočka Česká republika",
  6700: "Všeobecná úverová banka a.s., pobočka Praha",
  6800: "Sberbank CZ, a.s. v likvidaci",
  7910: "Deutsche Bank Aktiengesellschaft Filiale Prag, organizační složka",
  7950: "Raiffeisen stavební spořitelna",
  7960: "ČSOB Stavební spořitelna,",
  7970: "MONETA Stavební Spořitelna, a.s.",
  7990: "Modrá pyramida stavební spořitelna,",
  8030: "Volksbank Raiffeisenbank Nordoberpfalz eG pobočka Cheb",
  8040: "Oberbank AG pobočka Česká republika",
  8060: "Stavební spořitelna České spořitelny,",
  8090: "Česká exportní banka, a.s.",
  8150: "HSBC Continental Europe, Czech Republic",
  8190: "Sparkasse",
  8198: "FAS finance company s.r.o.",
  8199: "MoneyPolo Europe s.r.o.",
  8200: "PRIVAT BANK der Raiffeisenlandesbank OberösterreichAktiengesellschaft, pobočka Česká republika",
  8220: "Payment execution s.r.o.",
  8230: "ABAPAY s.r.o.",
  8240: "Družstevní záložna Kredit, v likvidaci",
  8250: "Bank of China (CEE) Ltd. Prague Branch",
  8255: "Bank of Communications Co., Ltd., Prague Branch odštěpný závod",
  8265: "Industrial and Commercial Bank of China Limited, Prague Branch,odštěpný závod",
  8270: "Fairplay Pay s.r.o.",
  8280: "B-Efekt a.s.",
  8293: "Mercurius partners s.r.o.",
  8299: "BESTPAY s.r.o.",
  8500: "Ferratum Bank plc"
};
function st(e) {
  return typeof e == "object" ? Object.keys(e).length > 0 : typeof e == "string" && e.trim().length > 0;
}
function xo(e) {
  return e ? !Number.isNaN(e.getTime()) : !1;
}
function wo(e) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e);
}
function $o(e) {
  return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(e);
}
function Co(e) {
  return /^-?\d+(\.\d+)?$/.test(e);
}
function _o(e) {
  return /^-?\d+$/.test(e);
}
function So(e, a) {
  return a > 0 && e.startsWith("0") ? !1 : Number(e) >= a;
}
function Mo(e, a) {
  return Number(e) <= a;
}
function Do(e, a = 2) {
  const t = e.split(".")[1];
  return !t || t.length <= a;
}
const qt = (e) => {
  if (!e || !Number.isInteger(Number(e)))
    return !1;
  const a = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];
  return e.split("").reduce((t, l, r) => t + Number(l) * a[r], 0) % 11 === 0;
};
function ln(e) {
  const a = e.split("-"), t = a.length === 2 ? a[0] : "", l = a.length === 2 ? a[1] : a[0];
  return !l || !Number.isInteger(Number(l)) || !Number.isInteger(Number(t)) || t && t.length > 6 || l.length < 2 || l.length > 10 || Number(l) < 11 || t && !qt(t) ? !1 : qt(l);
}
function Bo(e) {
  return e ? ln(e.accountNumber) && Object.values(dt).includes(e.bankCode) : !1;
}
function zo(e) {
  return /^(\+(420|421))? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/.test(e);
}
function Ao(e, a) {
  const t = nn(e);
  if (!a)
    return t.isValid();
  const l = t.birthDate();
  return t.isValid() && l.getDate() === a.getDate() && l.getMonth() === a.getMonth() && l.getFullYear() === a.getFullYear();
}
function Vo(e) {
  if (e.length !== 8)
    return !1;
  const a = e.split("").map((l) => Number(l)), t = a.pop();
  return (11 - a.reduce((l, r, o) => l + r * (8 - o), 0) % 11) % 10 === t;
}
function To(e) {
  return st(e.firstLine) && st(e.secondLine) && st(e.zip) && st(e.state);
}
function Eo(e) {
  return !!(e.birthDate.birthNumber && e.birthDate.birthDate);
}
const Oo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bankAccountNumber: ln,
  bankAccountValidator: Bo,
  isIntegerValidator: _o,
  isNumberValidator: Co,
  maxValidator: Mo,
  maximumDecimals: Do,
  minValidator: So,
  validateAddressDetailsRequired: To,
  validateBankNumber: qt,
  validateBirthNumber: Ao,
  validateBirthNumberRequired: Eo,
  validateEmail: wo,
  validateIco: Vo,
  validatePassword: $o,
  validatePhone: zo,
  validateRequired: st,
  validateRequiredDate: xo
}, Symbol.toStringTag, { value: "Module" }));
async function Po(e, a) {
  return (await Promise.all(e.map(async (t) => await a(t) ? t : null))).filter(Boolean);
}
function Lo(e, { min: a, max: t, step: l }) {
  const r = l ? Math.floor(e / l) * l : e;
  return r < a ? a : r > t ? t : r;
}
function $t(e, a = !1) {
  const t = new Intl.NumberFormat("cs", {
    maximumFractionDigits: a ? 0 : 2,
    minimumFractionDigits: a ? 0 : 2
  }).format(e);
  return t === "NaN" ? "0.00" : t;
}
function No(e) {
  return nn(e).birthDate();
}
var on = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var un = { exports: {} };
(function(e, a) {
  (function(t, l) {
    e.exports = l();
  })(on, function() {
    var t = "month", l = "quarter";
    return function(r, o) {
      var n = o.prototype;
      n.quarter = function(c) {
        return this.$utils().u(c) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (c - 1));
      };
      var i = n.add;
      n.add = function(c, p) {
        return c = Number(c), this.$utils().p(p) === l ? this.add(3 * c, t) : i.bind(this)(c, p);
      };
      var s = n.startOf;
      n.startOf = function(c, p) {
        var d = this.$utils(), m = !!d.u(p) || p;
        if (d.p(c) === l) {
          var y = this.quarter() - 1;
          return m ? this.month(3 * y).startOf(t).startOf("day") : this.month(3 * y + 2).endOf(t).endOf("day");
        }
        return s.bind(this)(c, p);
      };
    };
  });
})(un);
var Io = un.exports;
const Ro = /* @__PURE__ */ sn(Io);
var dn = { exports: {} };
(function(e, a) {
  (function(t, l) {
    e.exports = l();
  })(on, function() {
    var t = "minute", l = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(o, n, i) {
      var s = n.prototype;
      i.utc = function(g) {
        var _ = { date: g, utc: !0, args: arguments };
        return new n(_);
      }, s.utc = function(g) {
        var _ = i(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? _.add(this.utcOffset(), t) : _;
      }, s.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = s.parse;
      s.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), c.call(this, g);
      };
      var p = s.init;
      s.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else
          p.call(this);
      };
      var d = s.utcOffset;
      s.utcOffset = function(g, _) {
        var M = this.$utils().u;
        if (M(g))
          return this.$u ? 0 : M(this.$offset) ? d.call(this) : this.$offset;
        if (typeof g == "string" && (g = function(z) {
          z === void 0 && (z = "");
          var P = z.match(l);
          if (!P)
            return null;
          var Z = ("" + P[0]).match(r) || ["-", 0, 0], V = Z[0], U = 60 * +Z[1] + +Z[2];
          return U === 0 ? 0 : V === "+" ? U : -U;
        }(g), g === null))
          return this;
        var $ = Math.abs(g) <= 16 ? 60 * g : g, b = this;
        if (_)
          return b.$offset = $, b.$u = g === 0, b;
        if (g !== 0) {
          var C = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (b = this.local().add($ + C, t)).$offset = $, b.$x.$localOffset = C;
        } else
          b = this.utc();
        return b;
      };
      var m = s.format;
      s.format = function(g) {
        var _ = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return m.call(this, _);
      }, s.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, s.isUTC = function() {
        return !!this.$u;
      }, s.toISOString = function() {
        return this.toDate().toISOString();
      }, s.toString = function() {
        return this.toDate().toUTCString();
      };
      var y = s.toDate;
      s.toDate = function(g) {
        return g === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : y.call(this);
      };
      var w = s.diff;
      s.diff = function(g, _, M) {
        if (g && this.$u === g.$u)
          return w.call(this, g, _, M);
        var $ = this.local(), b = i(g).local();
        return w.call($, b, _, M);
      };
    };
  });
})(dn);
var Fo = dn.exports;
const jo = /* @__PURE__ */ sn(Fo);
la.extend(Ro);
la.extend(jo);
const Ho = {
  name: "cs",
  // name String
  weekdays: "Neděle_Pondělí_Úterý_Středa_Čtvrtek_Pátek_Sobota".split("_"),
  weekdaysShort: "Ne_Po_Út_St_Čt_Pá_So".split("_"),
  weekdaysMin: "Ne_Po_Út_St_Čt_Pá_So".split("_"),
  weekStart: 1,
  yearStart: 1,
  months: "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),
  // months Array
  monthsShort: "led_úno_bře_dub_kvě_čer_čvc_srp_zář_říj_lis_pro".split("_"),
  ordinal: (e) => `${e}.`,
  formats: {
    // abbreviated format options allowing localization
    LTS: "H:mm:ss",
    LT: "H:mm",
    L: "DD.MM.YYYY",
    LL: "D. MMMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
    // lowercase/short, optional formats for localization
    l: "D. M. YYYY",
    ll: "D. MMM YYYY",
    lll: "D. MMM YYYY H:mm",
    llll: "ddd D. MMM YYYY H:mm"
  },
  relativeTime: {
    // relative time format strings, keep %s %d as the same
    future: "za %s",
    // e.g. za 2 hodiny, %s been replaced with 2 hodiny
    past: "před %s",
    s: "pár sekund",
    m: "minuta",
    mm: "%d minut",
    h: "hodina",
    hh: "%d hodin",
    // e.g. 2 hodiny, %d been replaced with 2
    d: "den",
    dd: "%d dní",
    M: "měsíc",
    MM: "%d měsíců",
    y: "rok",
    yy: "%d let"
  },
  meridiem: (e) => e >= 12 ? "odpoledne" : "dopoledne"
}, Gt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  localeObjectCs: Ho
}, Symbol.toStringTag, { value: "Module" })), Dt = 7, Uo = 5;
function Yo(e) {
  const a = new Date(e.getFullYear(), e.getMonth() + 1, 0), t = Array.from({ length: a.getDate() }, (o, n) => n + 1).map((o) => Ft(new Date(e.getFullYear(), e.getMonth(), o)));
  if (t[0].dayOfWeek !== 1) {
    const o = new Date(e.getFullYear(), e.getMonth(), 0), n = new Date(o.getFullYear(), o.getMonth() + 1, 0).getDate(), i = t[0].dayOfWeek - 1, s = [];
    let c = 0;
    for (; c < i; )
      s.unshift(
        Ft(
          new Date(o.getFullYear(), o.getMonth(), n - c),
          { isPast: !0 }
        )
      ), c++;
    t.unshift(...s);
  }
  if (t[t.length - 1].dayOfWeek !== 7) {
    const o = new Date(e.getFullYear(), e.getMonth() + 1, 1), n = Dt * Uo + 1 - t.length;
    let i = 0;
    for (; i < n; )
      t.push(
        Ft(
          new Date(o.getFullYear(), o.getMonth(), i + 1),
          { isFuture: !0 }
        )
      ), i++;
  }
  const l = Array.from({ length: 6 }, (o, n) => n + 1).map((o) => t.slice((o - 1) * Dt, o * Dt)), r = l[l.length - 1];
  return (!r.length || r.every((o) => o.inNextMonth)) && l.pop(), l;
}
function Ft(e, a) {
  const t = /* @__PURE__ */ new Date(), l = e.getDay();
  return {
    day: e.getDate(),
    date: e.toISOString(),
    isToday: e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear(),
    isWeekend: [6, 7].includes(e.getDay()),
    dayOfWeek: l === 0 ? Dt : l,
    inPastMonth: a == null ? void 0 : a.isPast,
    inNextMonth: a == null ? void 0 : a.isFuture
  };
}
const cn = {
  modelValue: {
    type: Date,
    default: null
  },
  disabledDates: {
    type: Array,
    default: () => []
  },
  minDate: {
    type: Date,
    default: null
  },
  maxDate: {
    type: Date,
    default: null
  },
  format: {
    type: String,
    default: "D. M. YYYY"
  }
}, Wo = { class: "mb-5" }, qo = { class: "flex items-center justify-center gap-x-10 pb-5" }, Go = ["disabled"], Ko = ["disabled"], Zo = {
  key: 0,
  class: "absolute left-0 top-10 z-10 size-full overflow-auto bg-white pb-10"
}, Xo = { class: "grid max-h-full grid-cols-3 gap-3" }, Jo = ["onClick"], Qo = { key: 1 }, es = { class: "grid auto-rows-fr grid-cols-3 gap-3 pb-10" }, ts = ["disabled", "onClick"], as = /* @__PURE__ */ R({
  __name: "CfgMonthAndYearSelection",
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    minDate: {
      type: Date,
      default: () => new Date(1900, 0, 1)
    },
    maxDate: {
      type: Date,
      default: () => new Date((/* @__PURE__ */ new Date()).getFullYear() + 10, 0, 1)
    },
    openWindow: {
      type: String,
      default: "month"
    }
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = [...Gt.localeObjectCs.months], o = B(() => {
      const b = [];
      for (let C = new Date(t.minDate).getFullYear(); C <= new Date(t.maxDate).getFullYear(); C += 1)
        b.push(C);
      return b.sort((C, z) => z - C);
    }), n = ce(t, "modelValue", l), i = O(n.value.year), s = O(t.openWindow === "year"), c = mt(r, (b, C) => {
      const z = la(
        new Date(i.value, C, 1)
      );
      return {
        month: b,
        number: C,
        isSelected: C === n.value.month,
        disabled: z.isBefore(t.minDate, "month") || z.isAfter(t.maxDate, "month")
      };
    }), p = mt(o, (b) => ({
      year: b,
      isSelected: b === i.value
    })), d = O([]), m = B(() => i.value > new Date(t.minDate).getFullYear()), y = B(() => i.value < new Date(t.maxDate).getFullYear());
    X(() => t.modelValue, (b) => {
      i.value = b.year;
    }), X(() => t.openWindow, () => {
      s.value = t.openWindow === "year";
    }), X(s, (b) => {
      b && Ce(() => {
        var C, z;
        (z = (C = d.value) == null ? void 0 : C[o.value.findIndex((P) => P === i.value)]) == null || z.focus();
      });
    });
    function w() {
      i.value += 1;
    }
    function g() {
      i.value -= 1;
    }
    function _(b) {
      n.value = {
        month: b,
        year: i.value
      };
    }
    function M(b) {
      i.value = b, s.value = !1;
    }
    function $() {
      s.value ? s.value = !1 : l("close");
    }
    return (b, C) => (f(), k("div", null, [
      v("div", Wo, [
        x(u(Nt), {
          text: "",
          class: "mb-5",
          "aria-label": s.value ? "Měsíc" : "Zavřít",
          "icon-placement": "left",
          onClick: $
        }, {
          icon: h(() => [
            x(u(zt), { class: "text-sm" })
          ]),
          default: h(() => [
            x(u(I), {
              size: u(N).sm
            }, {
              default: h(() => [
                j(E(s.value ? "Měsíc" : "Zpět"), 1)
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["aria-label"])
      ]),
      v("div", qo, [
        v("button", {
          type: "button",
          class: "focusable border-grey-stroke rounded-md border p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !m.value,
          onClick: g
        }, [
          x(u(zt))
        ], 8, Go),
        x(u(I), {
          size: u(N).sm,
          class: "flex min-w-[140px] shrink-0 grow justify-center text-center"
        }, {
          default: h(() => [
            v("button", {
              type: "button",
              class: "lg:hover:text-brand flex items-center justify-center gap-x-2 capitalize lg:transition lg:duration-200",
              onClick: C[0] || (C[0] = (z) => s.value = !0)
            }, [
              v("span", null, E(i.value), 1),
              x(u(Xe), { class: "text-grey-300 text-[0.85em]" })
            ])
          ]),
          _: 1
        }, 8, ["size"]),
        v("button", {
          type: "button",
          class: "focusable border-grey-stroke rounded-md border p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !y.value,
          onClick: w
        }, [
          x(u(Lt))
        ], 8, Ko)
      ]),
      s.value ? (f(), k("div", Zo, [
        v("ul", Xo, [
          (f(!0), k(K, null, le(u(p), ({ year: z, isSelected: P }) => (f(), k("li", { key: z }, [
            v("button", {
              ref_for: !0,
              ref_key: "yearsButtonRefs",
              ref: d,
              type: "button",
              class: S(["border-grey-stroke lg:hover:border-brand flex w-full flex-1 items-center justify-center rounded-xl border p-3 lg:transition lg:duration-200", {
                "border-brand text-brand": P
              }]),
              onClick: (Z) => M(z)
            }, [
              x(u(I), {
                size: u(N).sm,
                class: "capitalize"
              }, {
                default: h(() => [
                  j(E(z), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, Jo)
          ]))), 128))
        ])
      ])) : (f(), k("div", Qo, [
        v("ul", es, [
          (f(!0), k(K, null, le(u(c), ({
            month: z,
            number: P,
            isSelected: Z,
            disabled: V
          }) => (f(), k("li", {
            key: z,
            class: "col-span-1 flex"
          }, [
            v("button", {
              type: "button",
              class: S(["focusable border-grey-stroke lg:hover:border-brand flex w-full flex-1 items-center justify-center rounded-xl border p-3 disabled:cursor-not-allowed disabled:line-through disabled:opacity-50 lg:transition lg:duration-200", {
                "border-brand text-brand": Z
              }]),
              disabled: V,
              onClick: (U) => _(P)
            }, [
              x(u(I), {
                size: u(N).sm,
                class: "capitalize"
              }, {
                default: h(() => [
                  j(E(z), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, ts)
          ]))), 128))
        ])
      ]))
    ]));
  }
}), ns = { class: "relative" }, rs = {
  key: 0,
  class: "absolute left-0 top-0 z-20 flex size-full bg-white"
}, ls = { class: "flex items-center justify-center gap-x-5 px-1 pb-7" }, os = ["disabled"], ss = {
  key: 1,
  class: "grid grid-cols-7"
}, is = { class: "mt-3 grid grid-cols-7" }, us = ["aria-label", "disabled", "data-selected", "onClick"], ds = { class: "cfg-day-item__content" }, cs = { class: "block w-full" }, fs = /* @__PURE__ */ R({
  __name: "CfgCalendar",
  props: cn,
  emits: ["selectDate", "update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = [...Gt.localeObjectCs.weekdaysShort];
    l.push(l.shift());
    const r = [...Gt.localeObjectCs.months], o = a, n = ce(t, "modelValue", o), i = O([]), s = O(!1), c = O("month"), p = ae(n.value || /* @__PURE__ */ new Date()), d = Kt({
      year: p.year(),
      month: p.month()
    }), m = B(() => r[d.month]), y = B(() => new Date(d.year, d.month, 1)), w = B(() => C(
      z(
        Yo(y.value)
      )
    )), g = B(() => new Date(t.minDate || "1900") < new Date(y.value)), _ = B(() => t.maxDate ? ae(t.maxDate).isAfter(ae(y.value), "month") : !0);
    Ne(() => {
      i.value.length && (i.value.find((U) => U.getAttribute("data-selected") === "true") || i.value[0]).focus();
    });
    function M() {
      d.month === 11 ? (d.month = 0, d.year += 1) : d.month += 1;
    }
    function $() {
      d.month === 0 ? (d.month = 11, d.year -= 1) : d.month -= 1;
    }
    function b(V) {
      o("update:modelValue", new Date(V)), o("selectDate", new Date(V));
    }
    function C(V) {
      return V.map((U) => U.map((q) => {
        var fe;
        const G = ae(q.date);
        let L = (fe = t.disabledDates) == null ? void 0 : fe.some((pe) => {
          const ze = ae(pe);
          return G.isSame(ze, "day");
        });
        if (!L && t.minDate) {
          const pe = ae(t.minDate);
          L = G.isBefore(pe, "day");
        }
        if (!L && t.maxDate) {
          const pe = ae(t.maxDate);
          L = G.isAfter(pe, "day");
        }
        return { ...q, disabled: L };
      }));
    }
    function z(V) {
      return V.map((U) => U.map((q) => {
        const G = ae(q.date), L = ae(n.value);
        return { ...q, selected: G.isSame(L, "day") };
      }));
    }
    function P({ month: V, year: U }) {
      d.month = V, d.year = U, s.value = !1;
    }
    function Z(V = "month") {
      c.value = V, s.value = !0;
    }
    return (V, U) => (f(), k("div", ns, [
      s.value ? (f(), k("div", rs, [
        x(as, {
          class: "w-full flex-1",
          "min-date": V.minDate || void 0,
          "max-date": V.maxDate || void 0,
          "model-value": {
            year: d.year,
            month: d.month
          },
          "open-window": c.value,
          "onUpdate:modelValue": P,
          onClose: U[0] || (U[0] = (q) => s.value = !1)
        }, null, 8, ["min-date", "max-date", "model-value", "open-window"])
      ])) : D("", !0),
      v("div", ls, [
        v("button", {
          type: "button",
          class: "focusable border-grey-stroke rounded-md border p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !g.value,
          onClick: $
        }, [
          x(u(zt))
        ], 8, os),
        x(I, {
          size: u(N).sm,
          class: "flex min-w-[140px] shrink-0 grow items-center justify-center gap-x-5 text-center"
        }, {
          default: h(() => [
            x(I, {
              size: u(N).sm,
              "tag-name": "button",
              type: "button",
              class: "lg:hover:text-brand flex items-center gap-x-2 capitalize lg:transition lg:duration-200",
              onClick: U[1] || (U[1] = (q) => Z("month"))
            }, {
              default: h(() => [
                j(E(m.value) + " ", 1),
                x(u(Xe), { class: "text-grey-300 text-[0.85em]" })
              ]),
              _: 1
            }, 8, ["size"]),
            x(I, {
              "tag-name": "button",
              size: u(N).sm,
              type: "button",
              class: "lg:hover:text-brand flex items-center gap-x-2 capitalize lg:transition lg:duration-200",
              onClick: U[2] || (U[2] = (q) => Z("year"))
            }, {
              default: h(() => [
                j(E(d.year) + " ", 1),
                x(u(Xe), { class: "text-grey-300 text-[0.85em]" })
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["size"]),
        x(I, {
          size: u(N).sm,
          "tag-name": "button",
          type: "button",
          class: "focusable border-grey-stroke rounded-md border p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !_.value,
          onClick: M
        }, {
          default: h(() => [
            x(u(Lt))
          ]),
          _: 1
        }, 8, ["size", "disabled"])
      ]),
      s.value ? D("", !0) : (f(), k("div", ss, [
        (f(), k(K, null, le(l, (q) => x(I, {
          key: q,
          size: u(N).xs,
          class: "text-grey-300 px-3 text-center"
        }, {
          default: h(() => [
            j(E(q), 1)
          ]),
          _: 2
        }, 1032, ["size"])), 64))
      ])),
      v("div", is, [
        (f(!0), k(K, null, le(w.value, (q) => (f(), k(K, null, [
          (f(!0), k(K, null, le(q, (G) => (f(), k("button", {
            key: G.day,
            ref_for: !0,
            ref_key: "dayRefs",
            ref: i,
            "aria-label": G.date,
            class: S(["focusable cfg-day-item disabled:cursor-not-allowed disabled:line-through disabled:opacity-50", {
              selected: G.selected
            }]),
            disabled: G.disabled,
            type: "button",
            "data-selected": G.selected,
            onClick: (L) => !G.disabled && b(G.date)
          }, [
            x(I, {
              size: u(N).sm,
              disabled: G.disabled,
              "tag-name": "span",
              class: S({
                "text-grey-200": (G.inPastMonth || G.inNextMonth) && !d,
                disabled: G.disabled
              })
            }, {
              default: h(() => [
                v("span", ds, [
                  v("span", cs, E(G.day), 1),
                  G.isToday ? (f(), k("span", {
                    key: 0,
                    class: S(["bg-brand absolute bottom-1.5 left-1/2 block size-1 -translate-x-1/2 rounded-full", { "!bg-white": G.selected }])
                  }, null, 2)) : D("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["size", "disabled", "class"])
          ], 10, us))), 128))
        ], 64))), 256))
      ])
    ]));
  }
});
const ps = /* @__PURE__ */ Re(fs, [["__scopeId", "data-v-6f36ca67"]]), ms = { class: "cfg-radio flex gap-x-3" }, gs = ["for"], vs = ["id", "disabled", "checked"], bs = ["for"], hs = ["innerHTML"], ys = {
  inheritAttrs: !1
}, ks = /* @__PURE__ */ R({
  ...ys,
  __name: "CfgRadio",
  props: {
    ...ke,
    modelValue: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = Pt(), o = B(() => r.id || ht("radio")), n = O();
    at(n, {
      initialValue: t.initialFocused
    });
    function i(s) {
      var c;
      l("update:modelValue", ((c = s == null ? void 0 : s.target) == null ? void 0 : c.checked) ?? !t.modelValue);
    }
    return (s, c) => (f(), k("div", null, [
      v("div", ms, [
        v("label", {
          class: "block",
          for: o.value
        }, [
          v("input", J({ id: o.value }, s.$attrs, {
            ref_key: "inputRef",
            ref: n,
            type: "radio",
            disabled: s.disabled,
            checked: e.modelValue,
            class: ["focusable h-5 w-5 border-grey-stroke text-brand", {
              "!border-red": s.error
            }],
            onChange: i
          }), null, 16, vs)
        ], 8, gs),
        s.$slots.default || e.placeholder ? (f(), k("label", {
          key: 0,
          for: o.value,
          class: S(["block", {
            "text-dark-100": e.modelValue,
            "text-grey-300": !e.modelValue,
            "!text-red": s.error
          }])
        }, [
          x(I, {
            size: u(N).sm,
            class: S({
              "opacity-40": s.disabled,
              "cursor-pointer": !s.disabled,
              "cursor-not-allowed": s.disabled,
              "text-grey-400": !s.error
            })
          }, {
            default: h(() => [
              T(s.$slots, "default", {}, () => [
                v("span", { innerHTML: e.placeholder }, null, 8, hs)
              ])
            ]),
            _: 3
          }, 8, ["size", "class"]),
          s.caption ? (f(), A(I, {
            key: 0,
            class: S(["mt-1 block", {
              "text-grey-300": !s.error
            }]),
            size: u(N).xs
          }, {
            default: h(() => [
              j(E(s.caption), 1)
            ]),
            _: 1
          }, 8, ["class", "size"])) : D("", !0)
        ], 10, bs)) : D("", !0)
      ]),
      s.error && s.errorMessage ? (f(), A(I, {
        key: 0,
        size: u(N).xs,
        class: "mt-3 block text-red"
      }, {
        default: h(() => [
          j(E(s.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : s.caption && !e.placeholder ? (f(), A(I, {
        key: 1,
        size: u(N).xs,
        class: "mt-3 block text-grey-300"
      }, {
        default: h(() => [
          j(E(s.caption), 1)
        ]),
        _: 1
      }, 8, ["size"])) : D("", !0)
    ]));
  }
}), fn = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Input value (v-model)
   */
  modelValue: {
    type: [String, Number],
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   * */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, xs = {
  ...fn,
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  }
}, ws = { class: "block leading-none" }, $s = ["id", "value", "readonly", "tabindex", "disabled"], Cs = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, _s = ["innerHTML"], ed = /* @__PURE__ */ R({
  __name: "CfgTextarea",
  props: {
    ...fn,
    ...xs,
    fieldClass: {
      type: String,
      default: ""
    },
    minHeight: {
      type: Number,
      default: 100
    }
  },
  emits: ["update:modelValue", "input", "focusout", "focusin", "blur", "keydown"],
  setup(e, { expose: a, emit: t }) {
    const l = e, r = t, o = oa().generateGuid(), n = ce(l, "modelValue", r), i = B(() => !String(n.value).trim().length), { textarea: s, input: c } = Rn(), { focused: p } = at(s, {
      initialValue: l.initialFocused
    }), { height: d } = Qt(s);
    a({
      focus() {
        p.value = !0;
      }
    }), X(p, (w) => {
      r(w ? "focusin" : "focusout");
    });
    function m(w) {
      w && (p.value = !0);
    }
    function y(w) {
      const { value: g } = w.target;
      c.value = g, n.value = g;
    }
    return (w, g) => (f(), k("div", {
      class: S({ "w-full": w.fluid, "w-72": !w.fluid })
    }, [
      x(u(sa), {
        focused: u(p),
        placeholder: w.placeholder,
        fluid: !0,
        readonly: w.readonly,
        disabled: w.disabled,
        empty: i.value,
        error: w.error,
        required: w.required,
        caption: w.caption,
        height: `${u(d)}px`,
        loading: w.loading,
        class: S(["cfg-input cursor-text bg-white", { [e.fieldClass]: e.fieldClass }]),
        "placeholder-as": "label",
        "placeholder-attrs": { for: u(o) },
        "onUpdate:focused": m
      }, {
        default: h(() => [
          v("label", ws, [
            v("textarea", {
              id: u(o),
              ref_key: "textareaRef",
              ref: s,
              value: u(n),
              style: ye({ minHeight: `${e.minHeight}px` }),
              class: "w-full resize-none border-none bg-transparent p-0 outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              readonly: w.readonly,
              tabindex: w.readonly ? -1 : 0,
              disabled: w.disabled,
              onFocusin: g[0] || (g[0] = (_) => p.value = !0),
              onFocusout: g[1] || (g[1] = (_) => p.value = !1),
              onKeydown: g[2] || (g[2] = (_) => r("keydown", _)),
              onBlur: g[3] || (g[3] = (_) => r("blur")),
              onInput: y
            }, null, 44, $s)
          ])
        ]),
        _: 1
      }, 8, ["focused", "placeholder", "readonly", "disabled", "empty", "error", "required", "caption", "height", "loading", "class", "placeholder-attrs"]),
      w.error && w.errorMessage ? (f(), k("small", Cs, E(w.errorMessage), 1)) : D("", !0),
      !(w.errorMessage && w.error) && w.caption ? (f(), k("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: w.caption
      }, null, 8, _s)) : D("", !0)
    ], 2));
  }
}), Ss = /* @__PURE__ */ R({
  __name: "CfgScrollbarView",
  props: {
    as: { default: "div" }
  },
  setup(e, { expose: a }) {
    const t = O(void 0), l = O(0);
    Ne(() => {
      var o;
      (o = t.value) == null || o.addEventListener("scroll", r);
    }), Va(() => {
      var o;
      (o = t.value) == null || o.removeEventListener("scroll", r);
    }), a({
      scrollPositionY: l
    });
    function r() {
      var o;
      l.value = ((o = t.value) == null ? void 0 : o.scrollTop) || 0;
    }
    return (o, n) => (f(), A(be(o.as), {
      ref_key: "scrollbarView",
      ref: t,
      class: "cfg-scrollbar-view overflow-y-auto"
    }, {
      default: h(() => [
        T(o.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 512));
  }
});
const Ms = /* @__PURE__ */ Re(Ss, [["__scopeId", "data-v-7ffc6d52"]]), Ds = /* @__PURE__ */ R({
  __name: "CfgCollapsable",
  props: {
    closedHeight: {
      type: Number,
      default: 0
    },
    opened: {
      type: Boolean,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "update:content-overflowed"],
  async setup(e, { emit: a }) {
    let t, l;
    const r = e, o = a, { default: n } = ([t, l] = Xt(() => import("gsap")), t = await t, l(), t), i = At("contentController"), s = At("contentWrapper"), c = O(r.opened), p = O(r.opened ?? !0);
    Ne(() => {
      r.opened || y();
    }), Pa([p, () => r.disabled], () => y(), {
      debounce: 50
    }), X(
      () => r.opened,
      (w) => {
        p.value = w ?? !1;
      }
    ), X(
      () => p.value,
      () => {
        p.value !== r.opened && o("update:opened", p.value);
      }
    );
    const d = O(!1), m = O([]);
    async function y(w = !0) {
      if (!s.value)
        return;
      if (d.value) {
        m.value.push(() => y(w));
        return;
      }
      await (async () => {
        d.value = !0;
        const M = p.value && !r.disabled, $ = w ? 0.4 : 0;
        s.value && (s.value.style.overflow = "hidden"), await Ce(async () => {
          M && (n.set(s.value, { height: 0 }), await Ce(() => {
            c.value = !0;
          })), await Ce(() => new Promise((b) => {
            n.to(s.value, {
              duration: M ? $ * 1.3 : $ * 0.7,
              ease: "expo.inOut",
              autoAlpha: M ? 1 : 0
            }), n.to(s.value, {
              duration: $,
              ease: "expo.inOut",
              height: M ? "auto" : 0,
              onComplete() {
                s.value && (s.value.style.overflow = "initial"), M || (c.value = !1), d.value = !1, b(!0);
              }
            });
          }));
        });
      })();
      const _ = m.value;
      m.value = [];
      for await (const M of _)
        await M();
    }
    return (w, g) => (f(), k("div", {
      class: S(["collapsable_wrapper transform-all relative duration-300", {
        closed: !p.value && !e.disabled
      }])
    }, [
      v("div", {
        ref_key: "contentWrapper",
        ref: s,
        class: "relative"
      }, [
        v("div", {
          ref_key: "contentController",
          ref: i
        }, [
          c.value ? T(w.$slots, "default", { key: 0 }) : D("", !0)
        ], 512)
      ], 512)
    ], 2));
  }
}), xe = {
  default: "brand",
  blue: "blue",
  success: "success",
  warning: "warning",
  danger: "danger"
}, td = /* @__PURE__ */ R({
  __name: "CfgChip",
  props: {
    color: { default: xe.default }
  },
  setup(e) {
    const a = e, t = B(() => ({
      background: {
        "bg-brand/20": a.color === xe.default,
        "bg-blue/20": a.color === xe.blue,
        "bg-success/20": a.color === xe.success,
        "bg-warning/20": a.color === xe.warning,
        "bg-red/20": a.color === xe.danger
      },
      text: {
        "text-brand": a.color === xe.default,
        "text-blue": a.color === xe.blue,
        "text-success": a.color === xe.success,
        "text-warning": a.color === xe.warning,
        "text-red": a.color === xe.danger
      }
    }));
    return (l, r) => (f(), k("div", {
      class: S(["inline-flex w-max items-center justify-center rounded-full px-4 py-[10px]", { ...t.value.background, ...t.value.text }])
    }, [
      x(I, {
        size: u(N).xs
      }, {
        default: h(() => [
          T(l.$slots, "default")
        ]),
        _: 3
      }, 8, ["size"])
    ], 2));
  }
}), Bs = { class: "hide-scrollbar mt-3 flex overflow-x-auto" }, zs = ["onClick"], ad = /* @__PURE__ */ R({
  __name: "CfgButtonsGroup",
  props: {
    values: {}
  },
  emits: ["input"],
  setup(e, { emit: a }) {
    const t = a, l = O("");
    function r(o) {
      t("input", o), l.value = o;
    }
    return (o, n) => (f(), k(K, null, [
      T(o.$slots, "default", { value: l.value }),
      v("div", Bs, [
        (f(!0), k(K, null, le(o.values, (i) => (f(), k("button", {
          key: i,
          type: "button",
          class: "m-1 rounded-xl border border-grey-stroke px-3 py-2",
          onClick: (s) => r(i)
        }, E(i), 9, zs))), 128))
      ])
    ], 64));
  }
}), As = { class: "cfg-slider" }, Vs = {
  key: 1,
  class: "mx-[-12px] mt-6"
}, Ts = {
  key: 0,
  class: "inputs flex justify-between"
}, Es = {
  key: 2,
  class: "block max-w-full pt-3 text-warning"
}, Os = {
  key: 3,
  class: "block max-w-full pt-3 text-grey-300"
}, Ps = /* @__PURE__ */ R({
  __name: "CfgSlider",
  props: {
    ...ie,
    modelValue: {
      type: [Number, Array],
      required: !0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      required: !0
    },
    max: {
      type: Number,
      required: !0
    },
    tipSuffix: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    coloredMode: {
      type: String,
      default: "default"
    },
    useInputs: {
      type: Boolean,
      default: !1
    },
    inputsWidth: {
      type: String,
      default: "80px"
    },
    tooltips: {
      type: Boolean,
      default: !0
    },
    snap: {
      type: Boolean,
      default: !1
    },
    lazy: {
      type: Boolean,
      default: !0
    },
    range: {
      type: Object,
      default: void 0
    }
  },
  emits: ["update:modelValue", "apply", "drag:end"],
  async setup(e, { emit: a }) {
    let t, l;
    const r = e, o = a, n = O(r.modelValue), { default: i } = ([t, l] = Xt(() => import("./slider-6d809fd1.js")), t = await t, l(), t), s = B(() => {
      const d = {
        snap: r.snap,
        connect: !0,
        range: r.range || { min: r.min, max: r.max }
      };
      return r.lazy ? d : {};
    });
    X(
      () => r.modelValue,
      () => {
        vt(n.value, r.modelValue) || (n.value = r.modelValue);
      },
      { deep: !0, immediate: !0 }
    ), X(
      n,
      () => {
        r.lazy || vt(n.value, r.modelValue) || o("update:modelValue", n.value);
      },
      { deep: !0, immediate: !0 }
    );
    async function c(d, m) {
      const y = Array.isArray(n.value) && m === 1 ? n.value[0] : r.min;
      let w = Array.isArray(n.value) && m === 0 ? n.value[1] : r.max;
      m === 0 && Array.isArray(n.value) && (w = n.value[1]);
      let g = Number(d);
      g < y ? g = y : g > w && (g = w), g = Math.round(g / r.step) * r.step, Ce(() => {
        Array.isArray(n.value) && m !== void 0 ? (n.value[m] = g, n.value = [...n.value]) : n.value = g, p(n.value);
      });
    }
    function p(d) {
      o("update:modelValue", d), o("apply", d);
    }
    return (d, m) => (f(), k("div", As, [
      d.placeholder ? (f(), A(I, {
        key: 0,
        size: u(N).subtitle,
        class: "mb-5 block text-grey-300"
      }, {
        default: h(() => [
          j(E(d.placeholder), 1)
        ]),
        _: 1
      }, 8, ["size"])) : D("", !0),
      x(u(i), {
        modelValue: n.value,
        "onUpdate:modelValue": m[0] || (m[0] = (y) => n.value = y),
        class: S(["core-slider cfg-slider__slider w-full", { [`cfg-slider__slider--colored-mode__${e.coloredMode}`]: !0 }]),
        "show-tooltip": "drag",
        min: e.min,
        max: e.max,
        step: e.step,
        tooltips: e.tooltips,
        disabled: e.disabled || d.loading,
        lazy: e.lazy,
        options: s.value,
        onUpdate: p,
        onEnd: m[1] || (m[1] = (y) => d.$emit("drag:end"))
      }, null, 8, ["modelValue", "class", "min", "max", "step", "tooltips", "disabled", "lazy", "options"]),
      e.useInputs ? (f(), k("div", Vs, [
        Array.isArray(n.value) ? (f(), k("div", Ts, [
          x(St, {
            "model-value": String(n.value[0]),
            type: "number",
            min: n.value[0],
            max: e.max,
            suffix: e.tipSuffix,
            step: e.step,
            style: ye({
              width: e.inputsWidth
            }),
            onBlur: m[2] || (m[2] = (y) => c(y, 0))
          }, null, 8, ["model-value", "min", "max", "suffix", "step", "style"]),
          x(St, {
            "model-value": String(n.value[1]),
            type: "number",
            min: n.value[0],
            max: e.max,
            step: e.step,
            suffix: e.tipSuffix,
            style: ye({
              width: e.inputsWidth
            }),
            onBlur: m[3] || (m[3] = (y) => c(y, 1))
          }, null, 8, ["model-value", "min", "max", "step", "suffix", "style"])
        ])) : (f(), A(St, {
          key: 1,
          "model-value": String(n.value),
          type: "number",
          step: e.step,
          style: ye({
            width: e.inputsWidth
          }),
          onBlur: c
        }, null, 8, ["model-value", "step", "style"]))
      ])) : D("", !0),
      d.error && d.errorMessage ? (f(), k("small", Es, E(d.errorMessage), 1)) : D("", !0),
      !(d.error && d.errorMessage) && d.caption ? (f(), k("small", Os, E(d.caption), 1)) : D("", !0)
    ]));
  }
});
function pn(e, a) {
  const t = B(() => Array.isArray(e.value)), l = mt(a, (s, c) => ({
    label: typeof s == "string" ? s : s.label,
    value: typeof s == "string" ? c.toString() : s.value,
    subtext: typeof s == "string" ? void 0 : s.subtext,
    original: s
  })), r = B(() => {
    if (!e.value)
      return [];
    if (Array.isArray(e.value))
      return e.value.map((c) => {
        const p = n(c);
        return {
          ...p,
          label: typeof c == "string" ? c : (p == null ? void 0 : p.label) ?? ""
        };
      }).filter(Boolean);
    let s = n(e.value);
    return typeof e.value == "object" && s && (s = {
      ...s,
      label: e.value.label || ""
    }), s ? [s] : [];
  }), o = mt(l, (s) => ({
    ...s,
    selected: i(s)
  }));
  function n(s) {
    return typeof s == "string" ? l.value.find(({ label: c }) => c === s) : l.value.find(({ value: c }) => vt(c, s == null ? void 0 : s.value));
  }
  function i(s) {
    return !!r.value.find(({ value: c }) => s.value === c);
  }
  return {
    isMultiple: t,
    normalizedModelValue: r,
    statefullOptionsList: o,
    isOptionSelected: i,
    findOption: n
  };
}
const Ls = {
  type: "button",
  class: "cfg-select__button focusable block w-full rounded-xl text-left focus:border-none focus:outline-0"
}, Ns = {
  key: 0,
  class: "text-grey-200 absolute right-0"
}, Is = {
  key: 0,
  class: "text-red block max-w-full pt-1"
}, Rs = {
  key: 1,
  class: "text-grey-300 block max-w-full pt-1"
}, Fs = {
  key: 0,
  class: "z-floating-overlay fixed inset-0 bg-black/30"
}, js = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, Hs = { key: 1 }, Us = ["innerHTML"], Ys = ["innerHTML"], mn = /* @__PURE__ */ R({
  __name: "CfgSelect",
  props: {
    ...ie,
    modelValue: {
      type: [Object, Array, null],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    origin: {
      type: String,
      default: "left"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !0
    },
    contentMinWidth: {
      type: String,
      default: "350px"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = O(), o = O(), n = O(), i = O(), { width: s } = gt(o);
    Fn(r, z);
    const { width: c } = gt(n), {
      floatingStyles: p
    } = na(n, i, {
      whileElementsMounted: ra,
      transform: !1,
      middleware: [
        Na({
          allowedPlacements: ["top", "bottom"]
        }),
        Ia({ padding: 5 }),
        Ra(12),
        Fa()
      ]
    }), d = O(0), { options: m, modelValue: y } = et(t), {
      isMultiple: w,
      normalizedModelValue: g,
      statefullOptionsList: _,
      isOptionSelected: M
    } = pn(y, m), $ = B(() => d.value > s.value), b = B(() => {
      var V;
      return w.value ? g.value.map(({ value: U }) => U) : ((V = g.value[0]) == null ? void 0 : V.value) ?? "";
    }), C = B(() => ({
      label: g.value.map(({ label: V }) => V).join(", "),
      additionalLabel: $.value && g.value.length > 1 ? `(${g.value.length})` : ""
    }));
    function z() {
      var V;
      d.value = ((V = r.value) == null ? void 0 : V.getBoundingClientRect().width) ?? 0;
    }
    function P(V) {
      var q;
      let U = g.value;
      M(V) && w.value ? U = U.filter(({ value: G }) => G !== V.value) : w.value ? U.push(V) : U = [V], l(
        "update:modelValue",
        w.value ? U.map(({ original: G }) => G) : ((q = U[0]) == null ? void 0 : q.original) ?? null
      );
    }
    Pa(C, z, { immediate: !0, deep: !0, debounce: 50 });
    const Z = jn(async () => {
      try {
        return w.value ? (await Promise.resolve().then(() => Ol)).default : (await import("./CfgRadio-0fd8e1ac.js")).default;
      } catch {
        return null;
      }
    }, null);
    return (V, U) => (f(), A(u(Xn), {
      "model-value": b.value,
      multiple: u(w),
      as: "div",
      class: "cfg-select relative",
      disabled: V.disabled
    }, {
      default: h(({ open: q }) => [
        v("div", null, [
          v("div", null, [
            x(u(Jn), {
              as: "template",
              type: "button"
            }, {
              default: h(() => [
                v("button", Ls, [
                  v("span", {
                    ref_key: "triggerButtonRef",
                    ref: n,
                    class: "block"
                  }, [
                    T(V.$slots, "trigger", { isOpened: q }, () => [
                      x(sa, {
                        empty: !u(g).length,
                        placeholder: V.placeholder,
                        focused: q,
                        error: V.error,
                        required: V.required,
                        readonly: "",
                        loading: V.loading,
                        fluid: "",
                        class: S(["bg-white", {
                          "cursor-pointer": !V.disabled,
                          "cursor-not-allowed": V.disabled,
                          "z-floating-trigger relative ": q
                        }]),
                        disabled: V.disabled
                      }, {
                        placeRight: h(() => [
                          x(u(Xe), {
                            class: S(["text-grey-400 size-4 transition duration-200", {
                              "!text-brand rotate-180": q
                            }])
                          }, null, 8, ["class"])
                        ]),
                        default: h(() => [
                          v("span", {
                            ref_key: "textWrapperRef",
                            ref: o,
                            class: S(["relative block min-h-[1em] truncate", {
                              "pr-5": $.value && u(w)
                            }])
                          }, [
                            v("span", {
                              ref_key: "textRef",
                              ref: r,
                              class: "h-4"
                            }, E(C.value.label), 513),
                            C.value.additionalLabel ? (f(), k("span", Ns, E(C.value.additionalLabel), 1)) : D("", !0)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["empty", "placeholder", "focused", "error", "required", "loading", "class", "disabled"])
                    ])
                  ], 512),
                  V.error && V.errorMessage ? (f(), k("small", Is, E(V.errorMessage), 1)) : D("", !0),
                  !(V.error && V.errorMessage) && V.caption ? (f(), k("small", Rs, E(V.caption), 1)) : D("", !0)
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          (f(), A(Zt, { to: "body" }, [
            e.overlay ? (f(), A(ft, {
              key: 0,
              "enter-active-class": "transition-opacity duration-200 ease-out",
              "enter-from-class": "transition-opacity opacity-0",
              "enter-to-class": "transition-opacity opacity-100",
              "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
              "leave-from-class": "transition-opacity opacity-100",
              "leave-to-class": "transition-opacity opacity-0"
            }, {
              default: h(() => [
                q ? (f(), k("div", Fs)) : D("", !0)
              ]),
              _: 2
            }, 1024)) : D("", !0),
            x(u(Qn), {
              as: "template",
              static: ""
            }, {
              default: h((G) => [
                x(ft, {
                  "enter-active-class": "transition duration-200 ease-out",
                  "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
                  "leave-active-class": "transition duration-200 ease-out",
                  "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
                  "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
                }, {
                  default: h(() => [
                    tt(v("div", {
                      ref_key: "dropdownContent",
                      ref: i,
                      class: "cfg-select__body z-floating-content divide-grey-stroke shadow-light w-full divide-y overflow-auto rounded-xl bg-white focus-visible:outline-none",
                      style: ye({
                        ...u(p),
                        width: `${u(c)}px`,
                        minWidth: e.contentMinWidth
                      })
                    }, [
                      G.open ? (f(), k(K, { key: 0 }, [
                        V.loading ? (f(), k("div", js, [
                          x(u(yt), { class: "text-brand text-[8px]" })
                        ])) : (f(), k("ul", Hs, [
                          (f(!0), k(K, null, le(u(_), (L) => (f(), A(u(er), {
                            key: L.value,
                            as: "li",
                            value: L.label,
                            class: S(["cursor-pointer", {
                              "p-4": !V.$slots.item
                            }]),
                            onClick: (fe) => !u(w) && P(L),
                            onKeydown: [
                              $e((fe) => P(L), ["enter"]),
                              $e((fe) => P(L), ["space"])
                            ]
                          }, {
                            default: h(({ active: fe }) => [
                              T(V.$slots, "item", {
                                isSelected: L.selected,
                                focused: fe,
                                toggle: P,
                                option: L
                              }, () => [
                                (f(), A(be(u(Z)), {
                                  id: `cfgSelect-${L.value}`,
                                  "model-value": !!L.selected,
                                  focused: fe,
                                  "initial-focused": L.selected,
                                  "onUpdate:modelValue": (pe) => P(L)
                                }, Et({
                                  default: h(() => [
                                    u(w) ? D("", !0) : T(V.$slots, "label", {
                                      key: 0,
                                      value: L
                                    }, () => [
                                      v("span", {
                                        class: S([{ "text-brand": L.selected, "text-grey-500": !L.selected }, "leading-6"]),
                                        innerHTML: L.label
                                      }, null, 10, Ys),
                                      L.subtext ? (f(), A(u(I), {
                                        key: 0,
                                        size: u(N).xs,
                                        "tag-name": "sm",
                                        class: "text-grey-300 block"
                                      }, {
                                        default: h(() => [
                                          j(E(L.subtext), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["size"])) : D("", !0)
                                    ])
                                  ]),
                                  _: 2
                                }, [
                                  u(w) ? {
                                    name: "label",
                                    fn: h(() => [
                                      T(V.$slots, "label", { value: L }, () => [
                                        v("span", {
                                          class: S([{ "text-brand": L.selected, "text-grey-500": !L.selected }, "leading-6"]),
                                          innerHTML: L.label
                                        }, null, 10, Us),
                                        L.subtext ? (f(), A(u(I), {
                                          key: 0,
                                          size: u(N).xs,
                                          "tag-name": "sm",
                                          class: "text-grey-300 block"
                                        }, {
                                          default: h(() => [
                                            j(E(L.subtext), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["size"])) : D("", !0)
                                      ])
                                    ]),
                                    key: "0"
                                  } : void 0
                                ]), 1032, ["id", "model-value", "focused", "initial-focused", "onUpdate:modelValue"]))
                              ])
                            ]),
                            _: 2
                          }, 1032, ["value", "class", "onClick", "onKeydown"]))), 128))
                        ]))
                      ], 64)) : D("", !0)
                    ], 4), [
                      [bt, G.open]
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        ])
      ]),
      _: 3
    }, 8, ["model-value", "multiple", "disabled"]));
  }
});
const va = {
  opened: {
    type: Boolean,
    default: !1
  },
  origin: {
    type: String,
    default: "left"
  },
  openOnTriggerClick: {
    type: Boolean,
    default: !0
  },
  useTriggerContentWidth: {
    type: Boolean,
    default: !1
  },
  minWidth: {
    type: Number,
    default: 0
  },
  allowedPlacements: {
    type: Array,
    default: () => ["top", "bottom"]
  }
}, Ws = { class: "relative" }, qs = {
  key: 0,
  class: "z-floating-overlay fixed inset-0 bg-black/30"
}, gn = /* @__PURE__ */ R({
  __name: "CfgFloating",
  props: {
    ...va
  },
  emits: ["update:opened"],
  setup(e, { emit: a }) {
    const t = e, r = ce(t, "opened", a), o = O(null), n = O(null);
    La(n, p);
    const { floatingStyles: i } = na(o, n, {
      middleware: [Fa(), Ia(), Ra(12), Na({
        allowedPlacements: t.allowedPlacements
      })],
      whileElementsMounted: ra,
      transform: !1
    }), { width: s } = gt(o);
    Ne(() => {
      Ht(document.documentElement, "keydown", (d) => {
        d.key === "Escape" && r.value && p();
      });
    });
    function c() {
      r.value = !0;
    }
    function p() {
      r.value = !1;
    }
    return (d, m) => (f(), k("div", Ws, [
      v("div", {
        ref_key: "triggerButtonRef",
        ref: o,
        class: S(["focusable border-non relative rounded-xl bg-white p-0", {
          "z-floating-trigger": u(r)
        }]),
        tabindex: "0",
        onClick: m[0] || (m[0] = (y) => d.openOnTriggerClick && c()),
        onKeydown: m[1] || (m[1] = $e((y) => d.openOnTriggerClick && c(), ["enter"]))
      }, [
        T(d.$slots, "trigger", {
          opened: u(r),
          close: p
        })
      ], 34),
      x(ft, {
        "enter-active-class": "transition-opacity duration-200 ease-out",
        "enter-from-class": "transition-opacity opacity-0",
        "enter-to-class": "transition-opacity opacity-100",
        "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
        "leave-from-class": "transition-opacity opacity-100",
        "leave-to-class": "transition-opacity opacity-0"
      }, {
        default: h(() => [
          u(r) ? (f(), k("div", qs)) : D("", !0)
        ]),
        _: 1
      }),
      (f(), A(Zt, { to: "body" }, [
        x(ft, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
          "leave-active-class": "transition duration-200 ease-out",
          "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
          "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
        }, {
          default: h(() => [
            tt(v("div", {
              ref_key: "bodyRef",
              ref: n,
              class: S(["z-floating-content divide-grey-stroke border-grey-stroke shadow-light absolute top-[calc(var(--input-height)+5px)] w-max min-w-[350px] divide-y overflow-auto rounded-xl border bg-white focus-visible:outline-none", {
                "border-brand": u(r),
                "left-0": d.origin === "left",
                "right-0": d.origin === "right"
              }]),
              style: ye({
                ...u(i),
                "max-width": d.useTriggerContentWidth ? "100%" : `${u(s)}px`
              })
            }, [
              T(d.$slots, "content", {
                opened: u(r),
                close: p
              })
            ], 6), [
              [bt, u(r)]
            ])
          ]),
          _: 3
        })
      ]))
    ]));
  }
}), Gs = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, Ks = {
  key: 1,
  class: "max-h-[400px] divide-y divide-grey-stroke overflow-auto"
}, Zs = ["onClick", "onKeydown"], Xs = { class: "grow" }, Js = {
  key: 2,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, nd = /* @__PURE__ */ R({
  __name: "CfgCombobox",
  props: {
    ...ie,
    modelValue: {
      type: [Object, String, null],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    emptyMessage: {
      type: String,
      required: !0
    },
    initialSearch: {
      type: String,
      default: ""
    },
    origin: {
      type: String,
      default: "left"
    },
    compareFn: {
      type: [Function, null],
      default: null
    },
    onSearch: {
      type: Function,
      default: null
    },
    ...Le(va, "allowedPlacements")
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    var $, b;
    const t = e, l = a, { options: r } = et(t), o = ce(t, "modelValue", l), n = O(null);
    La(n, g);
    const { normalizedModelValue: i, statefullOptionsList: s } = pn(o, r), c = O(t.initialSearch || (((b = ($ = i.value) == null ? void 0 : $[0]) == null ? void 0 : b.label) ?? "")), p = O(!1), d = O(!1), m = (C, z) => z.label.toLowerCase().includes(c.value.toLowerCase()), y = Hn(async () => {
      const C = t.compareFn || m;
      p.value = !0;
      const z = await Po(
        s.value,
        async (P) => c.value ? C(c.value, P) : !0
      );
      return p.value = !1, z;
    }, s.value);
    function w() {
      d.value = !0;
    }
    function g() {
      d.value = !1;
    }
    function _(C) {
      C && (l("update:modelValue", C.original), g());
    }
    function M(C) {
      var U;
      if ([27, 13, 9, 16, 17, 18].includes(C.keyCode))
        return;
      const { value: z, label: P } = ((U = i.value) == null ? void 0 : U[0]) || {}, V = C.key.match(/^[a-zA-Z0-9\s]+$/) ? C.key : "";
      V !== z && V !== P && w();
    }
    return X(() => t.initialSearch, (C = "") => {
      c.value = C;
    }), X(o, (C) => {
      c.value = typeof C == "string" ? C : (C == null ? void 0 : C.label) ?? "";
    }), X(c, (C) => {
      var z;
      C !== t.initialSearch && ((z = t.onSearch) == null || z.call(t, C)), C === "" && l("update:modelValue", null);
    }), (C, z) => (f(), A(gn, {
      opened: d.value,
      "onUpdate:opened": z[1] || (z[1] = (P) => d.value = P),
      "open-on-trigger-click": !1
    }, {
      trigger: h(() => [
        x(Se, {
          modelValue: c.value,
          "onUpdate:modelValue": z[0] || (z[0] = (P) => c.value = P),
          fluid: "",
          placeholder: C.placeholder,
          "interect-with-icon": "",
          loading: p.value || C.loading,
          autocomplete: "off",
          required: C.required,
          "initial-focused": d.value || C.initialFocused,
          error: C.error,
          type: "search",
          "error-message": C.errorMessage,
          onKeydown: M
        }, null, 8, ["modelValue", "placeholder", "loading", "required", "initial-focused", "error", "error-message"])
      ]),
      content: h(() => [
        p.value || C.loading ? (f(), k("div", Gs, [
          x(yt, { class: "text-[8px] text-brand" })
        ])) : u(y).length ? (f(), k("ul", Ks, [
          (f(!0), k(K, null, le(u(y), (P) => (f(), k("li", {
            key: P.label,
            class: S(["flex cursor-pointer items-center gap-x-3 p-4 hover:bg-grey-100/50", {
              "text-brand": P.selected
            }]),
            onClick: (Z) => _(P),
            onKeydown: $e((Z) => _(P), ["enter"])
          }, [
            T(C.$slots, "option", Ta(Ea({ ...P })), () => [
              P.selected ? (f(), A(u(Oa), {
                key: 0,
                class: "shrink-0 text-success",
                "aria-hidden": "true"
              })) : D("", !0),
              v("span", Xs, E(P.label), 1)
            ])
          ], 42, Zs))), 128))
        ])) : (f(), k("div", Js, [
          x(u(An), { class: "text-[1.3rem] text-grey-300" }),
          x(I, {
            class: "text-center",
            size: u(N).sm
          }, {
            default: h(() => [
              j(E(e.emptyMessage), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]))
      ]),
      _: 3
    }, 8, ["opened"]));
  }
});
async function Qs(e, a, t = B(() => ({
  disabled: !1,
  options: {}
}))) {
  const { default: l } = await import("./tippy.esm-f4cd93ed.js"), r = Jt(null);
  return Ce(() => {
    !e.value || !a.value || (r.value = l(e.value, {
      ...t.value.options,
      allowHTML: !0,
      content: a.value,
      animation: "scale",
      duration: [150, 150],
      appendTo: () => document.body
    }), r.value && (t.value.disabled && r.value.disable(), X(() => t.value.disabled, (o) => {
      var n;
      if (r.value) {
        if (o) {
          (n = r.value) == null || n.disable();
          return;
        }
        r.value.enable();
      }
    })));
  }), X(() => t.value.options, (o) => {
    !r.value || !o || r.value.setProps(o);
  }), Un(() => {
    var o;
    (o = r.value) == null || o.destroy(), r.value = null;
  }), { tippyInstance: r };
}
const ei = { class: "inline-block align-middle" }, ti = ["innerHTML"], Bt = /* @__PURE__ */ R({
  __name: "CfgHint",
  props: {
    content: { default: "" },
    hideIcon: { type: Boolean, default: !1 },
    delay: { default: () => [100, 200] },
    placement: { default: "auto-end" },
    iconPlacement: { default: "right" },
    interactive: { type: Boolean },
    tooltipPadding: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    hintElementClassnames: { default: "" },
    fluid: { type: Boolean },
    triggerElementClassnames: { default: "" }
  },
  setup(e) {
    const a = e, t = O(null), l = O(null), r = B(() => ({
      disabled: a.disabled,
      options: {
        placement: a.placement,
        interactive: a.interactive,
        delay: a.delay
      }
    })), o = Jt(null), n = B(() => !!o.value);
    Ne(async () => {
      const { tippyInstance: d } = await Qs(t, l, r);
      o.value = d.value, X(d, () => {
        o.value = d.value;
      });
    });
    const i = Pt(), s = B(() => {
      var d, m;
      return (m = (d = i.class) == null ? void 0 : d.includes) == null ? void 0 : m.call(d, "w-");
    }), c = B(() => `${S(a.triggerElementClassnames)}
  inline-flex items-center gap-x-2 group
  ${S({
      "flex-row-reverse": a.iconPlacement === "left",
      "w-full": s,
      "cursor-help": !a.disabled
    })}`);
    function p() {
      var d;
      (d = o.value) == null || d.hide();
    }
    return (d, m) => (f(), k("div", ei, [
      v("div", {
        class: S(["base-hint flex h-max", {
          "w-max items-end justify-end": !s.value,
          [d.hintElementClassnames]: d.hintElementClassnames
        }])
      }, [
        v("div", {
          ref_key: "refTrigger",
          ref: t,
          class: S({
            "w-full": s.value
          })
        }, [
          v("div", {
            class: S(c.value)
          }, [
            T(d.$slots, "trigger"),
            !u(i).disabled && !d.hideIcon ? (f(), A(u(ot), {
              key: 0,
              class: S(["text-[1.1em] text-grey-200", {
                "transition-colors duration-200 group-hover:text-brand": !d.disabled
              }])
            }, null, 8, ["class"])) : D("", !0)
          ], 2)
        ], 2),
        v("div", {
          ref_key: "refContent",
          ref: l
        }, [
          tt(v("div", {
            class: S({ "p-5": d.tooltipPadding })
          }, [
            T(d.$slots, "content", {
              closeHint: p,
              initialized: n.value
            }, () => [
              v("div", {
                class: "block max-w-[200px] text-left text-sm",
                innerHTML: d.content
              }, null, 8, ti)
            ])
          ], 2), [
            [bt, n.value]
          ])
        ], 512)
      ], 2)
    ]));
  }
});
const rd = /* @__PURE__ */ R({
  __name: "CfgTabs",
  props: {
    as: { default: "div" },
    disabled: { type: Boolean },
    selectedTab: { default: 0 },
    defaultTab: { default: 0 }
  },
  emits: ["update:selectedTab"],
  setup(e, { emit: a }) {
    const t = a;
    return (l, r) => (f(), A(u(tr), J({
      as: l.as,
      "default-index": l.defaultTab
    }, {
      ...l.selectedTab !== null && { "selected-index": l.selectedTab }
    }, {
      onChange: r[0] || (r[0] = (o) => t("update:selectedTab", o))
    }), {
      default: h(() => [
        x(u(ar), { class: "space-x-5 border-b border-b-grey-stroke" }, {
          default: h(() => [
            T(l.$slots, "tabs")
          ]),
          _: 3
        }),
        x(u(nr), { class: "focus:outline-none" }, {
          default: h(() => [
            T(l.$slots, "panels")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16, ["as", "default-index"]));
  }
}), ld = /* @__PURE__ */ R({
  __name: "CfgTabPanel",
  props: {
    unmount: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (a, t) => (f(), A(u(rr), {
      class: "focus:outline-none",
      unmount: a.unmount
    }, {
      default: h(() => [
        T(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["unmount"]));
  }
}), od = /* @__PURE__ */ R({
  __name: "CfgTab",
  props: {
    as: { default: "button" },
    disabled: { type: Boolean }
  },
  setup(e) {
    return (a, t) => (f(), A(u(lr), {
      as: "template",
      disabled: a.disabled
    }, {
      default: h(({ selected: l }) => [
        v("button", {
          type: "button",
          class: S(["relative translate-y-[1px] border-b px-3 pb-4 leading-none transition duration-200 focus:outline-0", {
            "border-b-brand text-brand": l,
            "border-b-transparent focus:border-b-grey-stroke": !l
          }])
        }, [
          T(a.$slots, "default", { selected: l })
        ], 2)
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
});
var Ye = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e.XLarge = "xlarge", e))(Ye || {});
const ai = /* @__PURE__ */ v("div", { class: "bg-dark/60 fixed inset-0 transition-opacity sm:backdrop-blur" }, null, -1), ni = { class: "fixed inset-0 z-10 overflow-y-auto" }, ri = {
  key: 0,
  class: "absolute right-3 top-3 z-20 mb-2 md:right-5 md:top-5"
}, li = { class: "space-y-3" }, oi = {
  key: 0,
  class: "mb-2 flex items-center justify-end"
}, si = {
  key: 0,
  class: "bg-brand-opacity text-brand mx-auto mb-5 flex size-[2em] items-center justify-center rounded-full text-[1.5em]"
}, sd = /* @__PURE__ */ R({
  __name: "CfgDialog",
  props: {
    opened: {
      type: Boolean,
      required: !0
    },
    initialFocus: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    closable: {
      type: Boolean,
      default: !0
    },
    unmount: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: Ye.Small
    },
    /**
     * If true, the dialog will not have a
     * padding and the close button will be moved to the top right corner.
     */
    flat: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      default: void 0
    },
    isFullScreen: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "close-click:button", "close-click:backdrop", "after-close-animation"],
  setup(e, { emit: a }) {
    const t = e, l = a;
    function r(o) {
      if (t.closable) {
        switch (o) {
          case "button":
            l("close-click:button");
            break;
          case "backdrop":
            l("close-click:backdrop");
            break;
        }
        l("update:opened", !1);
      }
    }
    return (o, n) => (f(), A(u(ea), {
      as: "template",
      show: e.opened
    }, {
      default: h(() => [
        x(u(ta), {
          as: "div",
          class: "z-modal relative",
          unmount: !!e.unmount,
          onClose: n[3] || (n[3] = (i) => r("backdrop"))
        }, {
          default: h(() => [
            x(u(Je), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: h(() => [
                ai
              ]),
              _: 1
            }),
            v("div", ni, [
              e.closable && e.flat ? (f(), k("div", ri, [
                v("button", {
                  type: "button",
                  class: "bg-grey-100 ring-brand focus-visible:outline-brand flex size-11 items-center justify-center rounded-full focus-visible:ring",
                  onClick: n[0] || (n[0] = (i) => r("button"))
                }, [
                  x(u(Ue))
                ])
              ])) : D("", !0),
              v("div", {
                class: S(["flex min-h-full items-center justify-center text-center sm:p-0", {
                  "p-4": !e.isFullScreen
                }])
              }, [
                x(u(Je), {
                  as: "template",
                  enter: "ease-out duration-[350ms]",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  onAfterLeave: n[2] || (n[2] = (i) => l("after-close-animation"))
                }, {
                  default: h(() => [
                    x(u(aa), {
                      class: S(["shadow-base relative w-full overflow-hidden bg-white text-left transition-all sm:my-8 sm:w-full", {
                        "sm:max-w-sm": !e.width && e.size === u(Ye).Small,
                        "sm:max-w-[32rem]": !e.width && e.size === u(Ye).Medium,
                        "sm:max-w-3xl": !e.width && e.size === u(Ye).Large,
                        "sm:max-w-[calc(100%-40px-120px)]": !e.width && e.size === u(Ye).XLarge,
                        // 40px-120px is padding + close button width
                        "px-4 pb-4 pt-5 sm:p-6": !e.flat,
                        // Add padding for non-flat dialogs
                        "mt-14": e.flat && e.closable,
                        // Prevent layering window to close button,
                        "h-screen w-full": e.isFullScreen,
                        "rounded-xl": !e.isFullScreen
                      }]),
                      style: ye(e.width ? { width: e.width } : {})
                    }, {
                      default: h(() => [
                        v("header", li, [
                          e.closable && !e.flat ? (f(), k("div", oi, [
                            v("button", {
                              type: "button",
                              class: "bg-grey-100 ring-brand focus-visible:outline-brand flex size-11 items-center justify-center rounded-full focus-visible:ring",
                              onClick: n[1] || (n[1] = (i) => r("button"))
                            }, [
                              x(u(Ue))
                            ])
                          ])) : D("", !0),
                          v("div", null, [
                            T(o.$slots, "heading", {}, () => [
                              o.$slots.icon ? (f(), k("div", si, [
                                T(o.$slots, "icon")
                              ])) : D("", !0),
                              e.title || o.$slots.title ? (f(), A(u(or), {
                                key: 1,
                                as: "div",
                                class: "text-dark-100"
                              }, {
                                default: h(() => [
                                  T(o.$slots, "title", {}, () => [
                                    x(I, {
                                      "tag-name": "h3",
                                      size: u(N).h3,
                                      class: "text-center"
                                    }, {
                                      default: h(() => [
                                        j(E(e.title), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : D("", !0),
                              e.description || o.$slots.description ? (f(), A(u(sr), {
                                key: 2,
                                as: "div",
                                class: "mt-3"
                              }, {
                                default: h(() => [
                                  T(o.$slots, "description", {}, () => [
                                    x(I, {
                                      size: u(N).md,
                                      "tag-name": "p",
                                      class: "text-grey-300 text-center text-sm"
                                    }, {
                                      default: h(() => [
                                        j(E(e.description), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : D("", !0)
                            ])
                          ])
                        ]),
                        v("main", {
                          class: S({ "mt-5": !e.flat })
                        }, [
                          T(o.$slots, "default")
                        ], 2)
                      ]),
                      _: 3
                    }, 8, ["class", "style"])
                  ]),
                  _: 3
                })
              ], 2)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
});
var he = /* @__PURE__ */ ((e) => (e.Success = "success", e.Error = "error", e.Warning = "warning", e.Info = "info", e))(he || {});
const ii = { class: "p-4" }, ui = { class: "flex items-center" }, di = { class: "shrink-0" }, ci = { class: "ml-4 w-0 flex-1 pt-0.5" }, fi = ["innerHTML"], pi = { class: "ml-5 flex shrink-0 self-center" }, mi = /* @__PURE__ */ v("span", { class: "sr-only" }, "Close", -1), id = /* @__PURE__ */ R({
  __name: "CfgToastNotification",
  props: {
    type: {},
    title: {},
    message: {}
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = B(() => t.type === he.Info ? jt : t.type === he.Success ? Oa : t.type === he.Warning ? Vn : t.type === he.Error ? Ue : jt);
    return (o, n) => (f(), k("div", {
      class: S(["pointer-events-auto w-full max-w-sm overflow-hidden rounded-xl border-l-4 bg-white shadow-base ring-1 ring-dark-100/5", {
        "border-none": o.type === u(he).Info,
        "border-success": o.type === u(he).Success,
        "border-yellow": o.type === u(he).Warning,
        "border-warning": o.type === u(he).Error
      }])
    }, [
      v("div", ii, [
        v("div", ui, [
          v("div", di, [
            T(o.$slots, "icon", {}, () => [
              v("div", {
                class: S(["mt-1 rounded-xl p-2", {
                  "bg-grey-100/50 text-grey-200": o.type === u(he).Info,
                  "bg-success-light text-success": o.type === u(he).Success,
                  "bg-yellow-light text-yellow": o.type === u(he).Warning,
                  "bg-warning-light text-warning": o.type === u(he).Error
                }])
              }, [
                (f(), A(be(r.value), {
                  class: "text-lg",
                  "aria-hidden": "true"
                }))
              ], 2)
            ])
          ]),
          v("div", ci, [
            x(I, {
              "tag-name": "h4",
              class: "text-dark-300 text-[18px] leading-[1.15]"
            }, {
              default: h(() => [
                j(E(o.title), 1)
              ]),
              _: 1
            }),
            o.message ? (f(), k("p", {
              key: 0,
              class: "mt-2 text-sm font-medium text-grey-400",
              innerHTML: o.message
            }, null, 8, fi)) : D("", !0)
          ]),
          v("div", pi, [
            v("button", {
              type: "button",
              class: "focusable inline-flex rounded-xl bg-white text-grey-300 hover:text-grey-500",
              onClick: n[0] || (n[0] = (i) => l("close"))
            }, [
              mi,
              x(u(Ue), {
                class: "text-lg",
                "aria-hidden": "true"
              })
            ])
          ])
        ])
      ])
    ], 2));
  }
}), gi = {
  class: "flex text-grey-300",
  "aria-label": "Breadcrumb"
}, vi = { class: "flex items-center space-x-3" }, bi = { key: 0 }, hi = /* @__PURE__ */ v("span", { class: "sr-only" }, "Home", -1), ud = /* @__PURE__ */ R({
  __name: "CfgBreadcrumbs",
  props: {
    pages: {
      type: Array,
      required: !0
    },
    /**
     * Text to display for the homepage link. If not provided, the home icon will be used.
     */
    homepageText: {
      type: [String, null],
      default: null
    }
  },
  emits: ["link:click"],
  setup(e, { emit: a }) {
    const t = a;
    function l(r) {
      t("link:click", r);
    }
    return (r, o) => (f(), k("nav", gi, [
      v("ol", vi, [
        v("li", null, [
          x(I, {
            size: u(N).sm,
            "tag-name": "div"
          }, {
            default: h(() => [
              v("a", {
                href: "/",
                class: "lg:transition lg:hover:text-brand",
                onClick: o[0] || (o[0] = Pe((n) => l("/"), ["prevent"]))
              }, [
                e.homepageText ? (f(), k("span", bi, E(e.homepageText), 1)) : (f(), k(K, { key: 1 }, [
                  x(u(Tn), {
                    class: "shrink-0 text-[1.25em]",
                    "aria-hidden": "true"
                  }),
                  hi
                ], 64))
              ])
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        (f(!0), k(K, null, le(e.pages, (n) => (f(), k("li", {
          key: n.name
        }, [
          x(I, {
            class: "flex items-center",
            size: u(N).xs,
            "tag-name": "div"
          }, {
            default: h(() => [
              x(u(Lt), {
                class: "shrink-0 text-[1.3em]",
                "aria-hidden": "true"
              }),
              (f(), A(be(n.current ? "span" : "a"), J(n.current ? {} : { href: n.path }, {
                class: ["ml-3 font-medium", {
                  "lg:transition lg:hover:text-brand": !n.current
                }],
                "aria-current": n.current ? "page" : void 0,
                onClick: Pe((i) => !n.current && l(n.path), ["prevent"])
              }), {
                default: h(() => [
                  j(E(n.name), 1)
                ]),
                _: 2
              }, 1040, ["class", "aria-current", "onClick"]))
            ]),
            _: 2
          }, 1032, ["size"])
        ]))), 128))
      ])
    ]));
  }
}), yi = { class: "space-y-3" }, ki = ["innerHTML"], dd = /* @__PURE__ */ R({
  __name: "CfgRadioGroup",
  props: {
    ...ie,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => ht("cfg-radio-name")
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * Selected item value (v-model). Should be equal to one of the items' value
     */
    modelValue: {
      type: String,
      default: ""
    },
    layout: {
      type: String,
      default: "row"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    var i;
    const t = e, r = ce(t, "modelValue", a);
    r.value || (r.value = ((i = t.options[0]) == null ? void 0 : i.value) ?? "");
    const o = B(() => t.options.map((s) => ({
      ...s,
      checked: s.value === t.modelValue
    })));
    function n(s, c) {
      s && (r.value = c);
    }
    return (s, c) => (f(), k("div", yi, [
      v("div", null, [
        x(I, {
          size: u(N).subtitle,
          class: S({
            "text-grey-200": !s.error,
            "text-red": s.error
          })
        }, {
          default: h(() => [
            j(E(s.placeholder), 1)
          ]),
          _: 1
        }, 8, ["size", "class"]),
        s.caption ? (f(), A(I, {
          key: 0,
          size: u(N).xs,
          class: "mt-1 block pb-1 text-grey-300"
        }, {
          default: h(() => [
            v("span", { innerHTML: s.caption }, null, 8, ki)
          ]),
          _: 1
        }, 8, ["size"])) : D("", !0)
      ]),
      v("div", {
        class: S({
          "flex flex-wrap gap-x-7 gap-y-4": e.layout === "row",
          "space-y-4": e.layout === "column"
        })
      }, [
        (f(!0), k(K, null, le(o.value, (p) => (f(), k("div", {
          key: p.value
        }, [
          x(ks, {
            name: e.name,
            placeholder: p.label,
            value: p.value,
            "model-value": p.checked,
            disabled: s.disabled || p.disabled,
            "onUpdate:modelValue": (d) => n(d, p.value)
          }, null, 8, ["name", "placeholder", "value", "model-value", "disabled", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      s.error && s.errorMessage ? (f(), A(I, {
        key: 0,
        size: u(N).xs,
        class: "mt-3 block text-red"
      }, {
        default: h(() => [
          j(E(s.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : D("", !0)
    ]));
  }
}), xi = { class: "space-y-3" }, cd = /* @__PURE__ */ R({
  __name: "CfgCheckboxGroup",
  props: {
    ...ie,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => ht("cfg-radio-name")
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * Selected item value (v-model). Should be equal to one of the items' value
     */
    modelValue: {
      type: Array,
      required: !0
    },
    layout: {
      type: String,
      default: "row"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = ce(t, "modelValue", a), o = B(() => t.options.map((i) => ({
      ...i,
      checked: t.modelValue.includes(i.value)
    })));
    function n(i, s) {
      if (!i) {
        r.value = r.value.filter((c) => c !== s);
        return;
      }
      r.value.push(s);
    }
    return (i, s) => (f(), k("div", xi, [
      v("div", null, [
        x(I, {
          size: u(N).subtitle,
          class: S({
            "text-grey-200": !i.error,
            "text-red": i.error
          })
        }, {
          default: h(() => [
            j(E(i.placeholder), 1)
          ]),
          _: 1
        }, 8, ["size", "class"]),
        i.caption ? (f(), A(I, {
          key: 0,
          size: u(N).xs,
          class: "mt-1 block pb-1 text-grey-300"
        }, {
          default: h(() => [
            j(E(i.caption), 1)
          ]),
          _: 1
        }, 8, ["size"])) : D("", !0)
      ]),
      v("div", {
        class: S({
          "flex flex-wrap gap-x-7 gap-y-4": e.layout === "row",
          "space-y-4": e.layout === "column"
        })
      }, [
        (f(!0), k(K, null, le(o.value, (c) => (f(), k("div", {
          key: c.value
        }, [
          x(Vt, {
            name: e.name,
            placeholder: c.label,
            value: c.value,
            "model-value": c.checked,
            disabled: i.disabled || c.disabled,
            "onUpdate:modelValue": (p) => n(p, c.value)
          }, null, 8, ["name", "placeholder", "value", "model-value", "disabled", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      i.error && i.errorMessage ? (f(), A(I, {
        key: 0,
        size: u(N).xs,
        class: "mt-3 block text-red"
      }, {
        default: h(() => [
          j(E(i.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : D("", !0)
    ]));
  }
}), oe = {
  default: "brand",
  success: "success",
  warning: "warning",
  danger: "red",
  neutral: "neutral"
}, wi = { class: "timeline-item relative z-0 grid grid-cols-[2.75rem_1fr] gap-4 before:absolute before:left-[1.375rem] before:top-1/2 before:-z-10 before:h-full before:w-[1px] before:bg-grey-100" }, $i = { class: "flex h-11 items-center justify-center" }, Ci = {
  key: 1,
  class: "h-3 w-3 rounded-full bg-grey-100"
}, _i = { class: "flex flex-col items-start justify-center gap-y-0.5" }, Si = /* @__PURE__ */ R({
  __name: "CfgTimelineItem",
  props: {
    color: { default: oe.default },
    icon: { default: void 0 },
    title: { default: void 0 },
    text: { default: void 0 },
    hasPingAnimation: { type: Boolean, default: !1 },
    id: { default: void 0 },
    tooltip: { type: Boolean },
    meta: { default: void 0 }
  },
  setup(e) {
    const a = e, t = B(() => Ut(a.icon) ? void 0 : Mn[a.icon]), l = B(() => ({
      background: {
        "bg-brand": a.color === oe.default,
        "bg-grey-300": a.color === oe.neutral,
        "bg-success": a.color === oe.success,
        "bg-warning": a.color === oe.warning,
        "bg-red": a.color === oe.danger
      },
      backgroundLight: {
        "bg-brand/30": a.color === oe.default,
        "bg-grey-300/30": a.color === oe.neutral,
        "bg-success/30": a.color === oe.success,
        "bg-warning/30": a.color === oe.warning,
        "bg-red/30": a.color === oe.danger
      },
      ring: {
        "ring-brand/30": a.color === oe.default,
        "ring-success/30": a.color === oe.success,
        "ring-warning/30": a.color === oe.warning,
        "ring-red/30": a.color === oe.danger,
        "ring-grey-300/30": a.color === oe.neutral
      },
      text: {
        "text-dark": a.color === oe.success || a.color === oe.neutral || a.color === oe.default,
        "text-warning": a.color === oe.warning,
        "text-red": a.color === oe.danger
      }
    }));
    return (r, o) => (f(), k("div", wi, [
      v("div", $i, [
        !u(Ut)(t.value) || r.$slots.icon ? (f(), k(K, { key: 0 }, [
          v("span", {
            class: S(["flex h-[30px] w-[30px] items-center justify-center rounded-full text-white ring-[7px] [&>*]:h-4 [&>*]:w-4", { ...l.value.ring, ...l.value.background }])
          }, [
            T(r.$slots, "icon", {}, () => [
              (f(), A(be(t.value)))
            ])
          ], 2),
          r.hasPingAnimation ? (f(), k("span", {
            key: 0,
            class: S(["absolute inline-flex h-[33px] w-[33px] animate-ping rounded-full", l.value.backgroundLight])
          }, null, 2)) : D("", !0)
        ], 64)) : (f(), k("span", Ci))
      ]),
      v("div", _i, [
        T(r.$slots, "content", {
          title: r.title,
          text: r.text
        }, () => [
          u(xa)(r.title) ? D("", !0) : (f(), A(u(I), {
            key: 0,
            size: u(N).sm,
            class: S(l.value.text)
          }, {
            default: h(() => [
              T(r.$slots, "title", { title: r.title }, () => [
                j(E(r.title), 1)
              ])
            ]),
            _: 3
          }, 8, ["size", "class"])),
          u(xa)(r.text) ? D("", !0) : (f(), A(u(I), {
            key: 1,
            size: u(N).sm,
            class: "text-sm text-grey-300"
          }, {
            default: h(() => [
              T(r.$slots, "text", { text: r.text }, () => [
                j(E(r.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"]))
        ])
      ])
    ]));
  }
}), fd = /* @__PURE__ */ R({
  __name: "CfgTimeline",
  props: {
    items: {}
  },
  setup(e) {
    return (a, t) => (f(), k("div", null, [
      T(a.$slots, "prependItems", { attrs: { class: "timeline-item-wrapper" } }),
      (f(!0), k(K, null, le(a.items, (l, r) => (f(), k("div", {
        key: r,
        class: "timeline-item-wrapper"
      }, [
        x(Bt, {
          disabled: !l.tooltip,
          "hide-icon": "",
          "tooltip-padding": !1,
          class: "w-full max-w-full [&>*]:max-w-full"
        }, {
          trigger: h(() => [
            x(Si, Ta(Ea(l)), null, 16)
          ]),
          content: h(() => [
            T(a.$slots, "tooltip", { item: l })
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]))), 128)),
      T(a.$slots, "appendItems", { attrs: { class: "timeline-item-wrapper" } })
    ]));
  }
});
const Mi = { class: "w-[340px] rounded-xl bg-white px-8 pb-6 pt-7 sm:w-[375px]" }, Di = /* @__PURE__ */ R({
  __name: "CfgDateField",
  props: {
    ...ie,
    ...ke,
    ...cn,
    allowedPlacements: {
      type: va.allowedPlacements.type,
      default: () => ["bottom"]
    }
  },
  emits: ["update:modelValue", "update:opened"],
  setup(e, { emit: a }) {
    const t = e, l = B(() => Le(t, Object.keys(Ie({ ...ie, ...ke }, "modelValue")))), o = ce(t, "modelValue", a), n = B(() => t.modelValue ? ae(t.modelValue).format("D. M. YYYY") : ""), i = O(!1);
    function s() {
      Ce(() => {
        i.value = !1;
      });
    }
    return (c, p) => (f(), A(gn, {
      opened: i.value,
      "onUpdate:opened": p[1] || (p[1] = (d) => i.value = d),
      "use-trigger-content-width": !0,
      "min-width": 340,
      "allowed-placements": e.allowedPlacements
    }, {
      trigger: h(() => [
        x(Se, J({
          ...l.value,
          modelValue: n.value,
          readonly: !0,
          fluid: !0
        }, {
          class: "relative cursor-pointer",
          "field-class": "!bg-white"
        }), {
          icon: h(() => [
            x(u(En), {
              class: S(["text-[1.5rem] transition-colors duration-200", { "text-brand": i.value, "text-grey-300": !i.value }])
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 16)
      ]),
      content: h(() => [
        v("div", Mi, [
          x(ps, {
            modelValue: u(o),
            "onUpdate:modelValue": p[0] || (p[0] = (d) => Be(o) ? o.value = d : null),
            "min-date": c.minDate,
            "max-date": c.maxDate,
            onSelectDate: s
          }, null, 8, ["modelValue", "min-date", "max-date"])
        ])
      ]),
      _: 1
    }, 8, ["opened", "allowed-placements"]));
  }
});
var He = /* @__PURE__ */ ((e) => (e.register = "register", e.unregister = "unregister", e.errorChanged = "error:changed", e))(He || {});
const ba = {
  modelValue: {
    type: [String, Date, Number, Array, Boolean, null, Object],
    required: !0
  },
  validators: {
    type: Array,
    default: () => []
  }
}, vn = /* @__PURE__ */ R({
  __name: "CfgValidationProvider",
  props: {
    ...ba
  },
  emits: ["update:modelValue", "error:changed", "register", "unregister"],
  setup(e, { emit: a }) {
    const t = oa().generateGuid(), l = e, r = a, o = it(l.modelValue), n = ce(l, "modelValue", r), i = Jt(!1), s = O(!1), c = O(!1), p = O(""), d = B(() => s.value && c.value);
    let m = null;
    const y = At("providerRef");
    Sn(() => {
      r(He.register, {
        name: t,
        error: c.value,
        reset: M,
        async forceValidate() {
          return s.value = !0, _();
        },
        focus() {
          m == null || m.focus();
        }
      });
    }), Ne(() => {
      Ce(() => {
        var $;
        m = ($ = y.value) == null ? void 0 : $.querySelector("input");
      });
    }), Va(() => r(He.unregister, t)), X(() => l.modelValue, _, { immediate: !0, deep: !0 }), X(c, ($) => r(He.errorChanged, {
      name: t,
      error: $
    }));
    function w($) {
      n.value = $;
    }
    function g() {
      s.value = !0;
    }
    async function _() {
      let $ = !1, b = "";
      const C = s.value;
      i.value = !0;
      const z = l.validators.some((P) => P.constructor.name === "AsyncFunction");
      z && (s.value = !1);
      for await (const P of l.validators) {
        let Z;
        if (P.constructor.name === "AsyncFunction" ? Z = await P(l.modelValue || "") : Z = P(l.modelValue || ""), typeof Z == "string") {
          $ = !0, b = Z;
          break;
        }
      }
      return c.value = $, p.value = b, i.value = !1, z && (s.value = C), $;
    }
    function M() {
      s.value = !1, c.value = !1, p.value = "", n.value = it(o);
    }
    return ($, b) => (f(), k("div", {
      ref_key: "providerRef",
      ref: y
    }, [
      T($.$slots, "default", {
        attrs: {
          error: d.value,
          errorMessage: p.value,
          modelValue: u(n),
          loading: i.value
        },
        on: {
          "update:modelValue": w,
          change: g
        }
      })
    ], 512));
  }
}), Bi = {
  ...ke,
  ...ba,
  observerSlotEvents: {
    type: Object,
    required: !0
  }
}, pd = /* @__PURE__ */ R({
  __name: "CfgValidatedField",
  props: {
    ...Bi
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = ce(t, "modelValue", a), o = B(() => Le(t, Object.keys(ke))), n = B(() => Le(t, Object.keys(ba)));
    return (i, s) => (f(), A(vn, J({
      modelValue: u(r),
      "onUpdate:modelValue": s[0] || (s[0] = (c) => Be(r) ? r.value = c : null),
      required: o.value.required,
      validators: n.value.validators
    }, pt(i.observerSlotEvents || {})), {
      default: h(({ on: c, attrs: p }) => [
        x(Se, J({ ...i.$attrs, ...o.value, ...p }, {
          "model-value": p.modelValue
        }, pt(c)), {
          icon: h(() => [
            T(i.$slots, "icon")
          ]),
          _: 2
        }, 1040, ["model-value"])
      ]),
      _: 3
    }, 16, ["modelValue", "required", "validators"]));
  }
}), Ma = 450, md = /* @__PURE__ */ R({
  __name: "CfgBankAccountField",
  props: {
    ...ie,
    ...ke,
    modelValue: {
      type: Object,
      default: () => ({
        accountNumber: "",
        bankCode: ""
      })
    },
    codePlaceholder: {
      type: String,
      required: !0
    },
    errorTranslations: {
      type: Object,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = O(), { width: o } = Qt(r), n = B(() => Le(t, Object.keys(Ie({ ...ie, ...ke }, "modelValue")))), i = Object.entries(dt).map((m) => {
      const [y, w] = m;
      return {
        value: dt[y],
        label: `${w} - ${ko[`${dt[y]}`]}`
      };
    }), s = B({
      get() {
        return t.modelValue || { accountNumber: "", bankCode: "" };
      },
      set(m) {
        l("update:modelValue", m);
      }
    }), c = B({
      get() {
        var m, y;
        if ((m = s.value) != null && m.bankCode) {
          const w = (y = i.find((g) => g.value === s.value.bankCode)) == null ? void 0 : y.value;
          if (w)
            return {
              label: w,
              value: w
            };
        }
        return null;
      },
      set(m) {
        m && (s.value = {
          ...s.value || {},
          bankCode: m.value
        });
      }
    }), p = B(() => {
      const m = {
        accountNumber: "",
        bankCode: ""
      };
      return t.error && (s.value.accountNumber || (m.accountNumber = t.errorTranslations.accountNumber.required), s.value.bankCode || (m.bankCode = t.errorTranslations.bankCode), s.value.accountNumber && !s.value.bankCode && (m.accountNumber = ""), s.value.accountNumber && s.value.bankCode && (m.accountNumber = t.errorTranslations.accountNumber.invalid)), m;
    });
    function d(m) {
      s.value = { ...s.value, accountNumber: m };
    }
    return (m, y) => {
      var w;
      return f(), k("div", {
        ref_key: "rootElRef",
        ref: r,
        class: S(["flex gap-2", {
          "flex-col": u(o) < Ma
        }])
      }, [
        x(Se, J({
          fluid: "",
          required: ""
        }, {
          ...n.value,
          modelValue: ((w = s.value) == null ? void 0 : w.accountNumber) || ""
        }, {
          error: !!p.value.accountNumber,
          "error-message": p.value.accountNumber,
          class: "relative grow cursor-pointer",
          "onUpdate:modelValue": y[0] || (y[0] = (g) => d(String(g)))
        }), null, 16, ["error", "error-message"]),
        x(mn, {
          modelValue: c.value,
          "onUpdate:modelValue": y[1] || (y[1] = (g) => c.value = g),
          placeholder: e.codePlaceholder,
          disabled: t.disabled,
          options: u(i),
          error: !!p.value.bankCode,
          "error-message": p.value.bankCode,
          required: "",
          origin: "right",
          class: S(["w-1/4 min-w-[180px]", {
            "max-w-[300px]": u(o) >= Ma
          }]),
          style: { "--max-height": "400px" }
        }, null, 8, ["modelValue", "placeholder", "disabled", "options", "error", "error-message", "class"])
      ], 2);
    };
  }
}), zi = { class: "grow" }, Da = 450, gd = /* @__PURE__ */ R({
  __name: "CfgBirthNumberField",
  props: {
    ...ie,
    ...ke,
    modelValue: {
      type: [Object, null],
      required: !0
    },
    translates: {
      type: Object,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = B(() => Le(t, Object.keys(Ie({ ...ie, ...ke }, "modelValue")))), o = ce(t, "modelValue", l), n = O(), { width: i } = Qt(n), s = B({
      get() {
        var m;
        return ((m = o.value) == null ? void 0 : m.birthDate) || null;
      },
      set(m) {
        m && d({
          birthDate: m
        });
      }
    });
    function c(m) {
      d({ birthNumber: m });
    }
    function p() {
      var m;
      (m = o.value) != null && m.birthNumber && Oo.validateBirthNumber(o.value.birthNumber) && d({
        birthDate: No(o.value.birthNumber)
      });
    }
    function d(m) {
      o.value = {
        ...o.value || { birthDate: null, birthNumber: "" },
        ...m
      };
    }
    return (m, y) => {
      var w;
      return f(), k("div", {
        ref_key: "rootElRef",
        ref: n,
        class: S(["flex gap-2", {
          "flex-col": u(i) < Da
        }])
      }, [
        v("div", zi, [
          x(Se, J({ required: "" }, {
            ...r.value,
            modelValue: ((w = u(o)) == null ? void 0 : w.birthNumber) || "",
            placeholder: e.translates.birthNumberPlaceholder,
            fluid: !0
          }, {
            class: "relative cursor-pointer",
            "onUpdate:modelValue": y[0] || (y[0] = (g) => c(g.toString())),
            onBlur: p
          }), null, 16)
        ]),
        x(Di, {
          modelValue: s.value,
          "onUpdate:modelValue": y[1] || (y[1] = (g) => s.value = g),
          placeholder: e.translates.birthDatePlaceholder,
          disabled: t.disabled,
          class: S({
            "w-[240px]": u(i) >= Da
          })
        }, null, 8, ["modelValue", "placeholder", "disabled", "class"])
      ], 2);
    };
  }
}), Ai = { class: "flex flex-col gap-5" }, Vi = { class: "flex gap-x-2" }, Ti = { class: "grow" }, vd = /* @__PURE__ */ R({
  __name: "CfgAddressDetailsField",
  props: {
    ...ie,
    ...ke,
    modelValue: {
      type: [Object, null],
      required: !0
    },
    translates: {
      type: Object,
      required: !0
    },
    zipLengthErrorMessage: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = B(() => {
      const n = {
        firstLine: "",
        secondLine: "",
        zip: "",
        state: ""
      };
      return t.error && o.value && Object.entries(o.value).forEach(([i, s]) => {
        s || (n[i] = t.errorMessage);
      }), o.value.zip.length > 5 && (n.zip = t.zipLengthErrorMessage), n;
    }), o = B({
      get() {
        const n = {
          firstLine: "",
          secondLine: "",
          zip: "",
          state: ""
        };
        return t.modelValue || n;
      },
      set(n) {
        l("update:modelValue", n);
      }
    });
    return (n, i) => {
      var s, c, p, d;
      return f(), k("div", Ai, [
        x(Se, {
          "initial-focused": n.initialFocused,
          "model-value": (s = o.value) == null ? void 0 : s.firstLine,
          fluid: !0,
          required: n.required,
          error: !!r.value.firstLine,
          "error-message": r.value.firstLine,
          placeholder: e.translates.placeholders.firstLine,
          caption: e.translates.captions.firstLine,
          "onUpdate:modelValue": i[0] || (i[0] = (m) => {
            o.value = {
              ...o.value,
              firstLine: m.toString()
            };
          })
        }, null, 8, ["initial-focused", "model-value", "required", "error", "error-message", "placeholder", "caption"]),
        v("div", Vi, [
          x(Se, {
            "model-value": (c = o.value) == null ? void 0 : c.secondLine,
            required: n.required,
            placeholder: e.translates.placeholders.secondLine,
            caption: e.translates.captions.secondLine,
            error: !!r.value.secondLine,
            "error-message": r.value.secondLine,
            fluid: !0,
            "onUpdate:modelValue": i[1] || (i[1] = (m) => {
              o.value = {
                ...o.value,
                secondLine: m.toString()
              };
            })
          }, null, 8, ["model-value", "required", "placeholder", "caption", "error", "error-message"]),
          v("div", Ti, [
            x(Se, {
              "model-value": (p = o.value) == null ? void 0 : p.zip,
              required: n.required,
              error: !!r.value.zip,
              "error-message": r.value.zip,
              placeholder: e.translates.placeholders.zip,
              caption: e.translates.captions.zip,
              fluid: !0,
              class: "w-[100px]",
              "onUpdate:modelValue": i[2] || (i[2] = (m) => {
                o.value = {
                  ...o.value,
                  zip: m.toString()
                };
              })
            }, null, 8, ["model-value", "required", "error", "error-message", "placeholder", "caption"])
          ])
        ]),
        x(Se, {
          "model-value": (d = o.value) == null ? void 0 : d.state,
          required: n.required,
          placeholder: e.translates.placeholders.state,
          caption: e.translates.captions.state,
          error: !!r.value.state,
          "error-message": r.value.state,
          fluid: !0,
          "onUpdate:modelValue": i[3] || (i[3] = (m) => {
            o.value = {
              ...o.value,
              state: m.toString()
            };
          })
        }, null, 8, ["model-value", "required", "placeholder", "caption", "error", "error-message"])
      ]);
    };
  }
}), bd = /* @__PURE__ */ R({
  __name: "CfgPasswordField",
  props: {
    ...ie,
    ...ke
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = B(() => Le(t, Object.keys(Ie({ ...ie, ...ke }, "modelValue")))), r = a, o = ce(t, "modelValue", r), n = O(!1);
    function i() {
      n.value = !n.value;
    }
    function s(c) {
      r("update:modelValue", c);
    }
    return (c, p) => (f(), k("div", null, [
      x(Se, J({
        ...l.value,
        fluid: !0
      }, {
        "model-value": u(o),
        type: n.value ? "text" : "password",
        "interact-with-icon": "",
        "onUpdate:modelValue": s
      }), {
        icon: h(() => [
          x(u(On), {
            class: S([{
              "text-grey-300": !n.value,
              "text-brand": n.value
            }, "text-[1.5rem] hover:cursor-pointer"]),
            onClick: Pe(i, ["prevent"])
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 16, ["model-value", "type"])
    ]));
  }
}), Ei = { class: "flex flex-wrap gap-2" }, Oi = ["for"], Pi = ["id", "aria-label", "checked", "name", "type", "value", "onChange"], hd = /* @__PURE__ */ R({
  __name: "CfgChipsToggle",
  props: {
    id: {},
    options: {},
    isMultiple: {},
    modelValue: {},
    name: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = B(() => t.id || `chips-toggle-${Math.random().toString(36).substr(2, 9)}`), o = B(() => t.name || r.value), n = B(() => t.options.map((s) => ({
      ...s,
      isSelected: s.value === t.modelValue
    }))), i = B(() => t.isMultiple ? "checkbox" : "radio");
    if (t.isMultiple)
      throw new Error("Multiple chips toggle is not implemented yet");
    return (s, c) => (f(), k("div", Ei, [
      (f(!0), k(K, null, le(n.value, ({ isSelected: p, label: d, value: m }, y) => (f(), k("label", {
        key: m,
        for: `${r.value}-${y}`,
        class: S(["relative block cursor-pointer overflow-hidden rounded-full border leading-none ring-offset-4 transition duration-200 focus-within:ring focus-within:ring-brand/30 hover:-translate-y-1", {
          "border-brand bg-brand text-white": p,
          "border-grey-stroke bg-white": !p
        }])
      }, [
        x(I, {
          class: "block px-[1em] py-[0.75em]",
          size: u(N).sm,
          "tag-name": "span"
        }, {
          default: h(() => [
            T(s.$slots, "default", { label: d }, () => [
              v("input", {
                id: `${r.value}-${y}`,
                "aria-label": d,
                checked: p,
                class: "absolute -top-5 opacity-0",
                name: o.value,
                type: i.value,
                value: d,
                onChange: (w) => l("update:modelValue", m)
              }, null, 40, Pi),
              j(E(d), 1)
            ])
          ]),
          _: 2
        }, 1032, ["size"])
      ], 10, Oi))), 128))
    ]));
  }
}), Li = /* @__PURE__ */ R({
  __name: "CfgValidationObserver",
  emits: ["error:changed", "submit"],
  setup(e, { expose: a, emit: t }) {
    const l = t, r = O([]), o = B(() => r.value.some(({ error: g }) => g)), n = O(!1), i = {
      [He.register]: p,
      [He.unregister]: d,
      [He.errorChanged]: s
    };
    a({
      resetForm: y,
      async submit() {
        return c();
      }
    }), X(o, (g) => l("error:changed", g));
    function s(g) {
      const _ = r.value.find((M) => M.name === g.name);
      _ && (_.error = g.error);
    }
    async function c() {
      var _;
      return await m(), w() ? (l("submit"), !0) : ((_ = r.value.find(({ error: M }) => M)) == null || _.focus(), !1);
    }
    function p(g) {
      r.value.find((_) => _.name === g.name) || r.value.push(g);
    }
    function d(g) {
      r.value = r.value.filter((_) => _.name !== g);
    }
    async function m() {
      n.value = !0, await Promise.all(r.value.map((g) => g.forceValidate())), n.value = !1;
    }
    function y() {
      r.value.forEach((g) => g.reset());
    }
    function w() {
      return !o.value;
    }
    return (g, _) => T(g.$slots, "default", {
      submit: c,
      on: i,
      validationLoading: n.value
    });
  }
}), Ni = { class: "mx-auto flex max-w-[310px] shrink-0 flex-col items-center text-center sm:max-w-[360px]" }, Ii = { class: "mx-auto flex max-w-[500px] grow flex-col items-center justify-center py-10 text-center" }, Ri = ["innerHTML"], yd = /* @__PURE__ */ R({
  __name: "CfgApplicationError",
  props: {
    header: {},
    headerClasses: {},
    statusCode: {},
    statusCodeClasses: {},
    title: {},
    titleClasses: {},
    description: {},
    descriptionClasses: {},
    buttonLabel: {},
    buttonClasses: {}
  },
  emits: ["error"],
  setup(e, { emit: a }) {
    const t = a;
    return (l, r) => (f(), k(K, null, [
      v("header", Ni, [
        T(l.$slots, "logo"),
        l.header ? (f(), A(I, {
          key: 0,
          "tag-name": "p",
          class: S([l.headerClasses, "mt-5 text-grey-400 md:mt-7"]),
          size: u(N).h4,
          html: l.header
        }, null, 8, ["class", "size", "html"])) : D("", !0)
      ]),
      v("main", Ii, [
        v("span", {
          class: S(u(We)("font-display text-[120px] font-extrabold leading-none text-grey-200 opacity-10 sm:text-[240px]", l.statusCodeClasses))
        }, E(l.statusCode), 3),
        T(l.$slots, "title", {}, () => [
          x(I, {
            "tag-name": "h1",
            size: u(N).h1,
            class: S(u(We)("page-not-found__title -mt-[7%] sm:-mt-[12%]", l.titleClasses)),
            html: l.title
          }, null, 8, ["size", "class", "html"])
        ]),
        T(l.$slots, "description", {}, () => [
          x(I, {
            size: u(N).md,
            "tag-name": "p",
            class: S(u(We)("mt-5 text-dark-200 md:mt-6", l.descriptionClasses))
          }, {
            default: h(() => [
              v("span", { innerHTML: l.description }, null, 8, Ri)
            ]),
            _: 1
          }, 8, ["size", "class"])
        ]),
        l.buttonLabel ? (f(), A(u(Nt), {
          key: 0,
          variant: "primary",
          class: S(u(We)("mt-10", l.buttonClasses)),
          onClick: r[0] || (r[0] = (o) => t("error"))
        }, {
          default: h(() => [
            j(E(l.buttonLabel), 1)
          ]),
          _: 1
        }, 8, ["class"])) : D("", !0)
      ])
    ], 64));
  }
});
const Fi = { class: "flex grow items-start justify-between" }, ji = { class: "flex shrink-0 justify-between" }, Hi = {
  key: 1,
  class: "items-center"
}, bn = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "CfgOverlayPanelContent",
  props: {
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    isBackAllowed: { type: Boolean },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean }
  },
  emits: ["close", "back"],
  setup(e) {
    const a = e, t = ["px-", "pr-", "pl"], l = Pt(), r = O(null), o = B(() => l.class ?? ""), n = B(() => a.flat ? !1 : !t.some((i) => o.value.includes(i)));
    return (i, s) => (f(), A(u(Ms), {
      ref_key: "scrollbarView",
      ref: r,
      class: S(["flex h-full flex-col rounded-t-xl bg-white shadow-xl", {
        [o.value]: !0,
        "pb-6 ": !i.disableBottomPadding
      }])
    }, {
      default: h(() => {
        var c;
        return [
          i.title || i.description || i.$slots.head ? (f(), k("header", {
            key: 0,
            name: "head",
            class: S(["border-b-grey-stroke z-sticky flex border-b bg-white py-5 transition-shadow duration-200", {
              "px-5 sm:px-9": n.value,
              "shadow-light": (((c = r.value) == null ? void 0 : c.scrollPositionY) || 0) > 0 && (i.title || i.description),
              "sticky top-0": i.title || i.description
            }])
          }, [
            v("div", Fi, [
              v("div", null, [
                T(i.$slots, "head", {}, () => [
                  i.title ? (f(), A(u(I), {
                    key: 0,
                    size: u(N).h2,
                    "tag-name": "h3"
                  }, {
                    default: h(() => [
                      j(E(i.title), 1)
                    ]),
                    _: 1
                  }, 8, ["size"])) : D("", !0),
                  i.description ? (f(), A(u(I), {
                    key: 1,
                    size: u(N).sm,
                    "tag-name": "p",
                    class: "text-grey-300 mt-2"
                  }, {
                    default: h(() => [
                      j(E(i.description), 1)
                    ]),
                    _: 1
                  }, 8, ["size"])) : D("", !0)
                ])
              ])
            ]),
            v("div", ji, [
              i.isBackAllowed ? (f(), k("button", {
                key: 0,
                type: "button",
                class: "bg-grey-100 ring-brand focus-visible:outline-brand flex size-11 items-center justify-center rounded-full focus-visible:ring",
                onClick: s[0] || (s[0] = (p) => i.$emit("back"))
              }, [
                x(u(Pn))
              ])) : D("", !0),
              i.closable && i.renderClose ? (f(), k("div", Hi, [
                v("button", {
                  type: "button",
                  class: "bg-grey-100 ring-brand focus-visible:outline-brand flex size-11 items-center justify-center rounded-full focus-visible:ring",
                  onClick: s[1] || (s[1] = (p) => i.$emit("close"))
                }, [
                  x(u(Ue))
                ])
              ])) : D("", !0)
            ])
          ], 2)) : D("", !0),
          v("main", {
            class: S(["relative flex flex-1 first-of-type:mt-5 lg:first-of-type:mt-8 [&>*]:flex-1", {
              "px-5 sm:px-9": n.value
            }])
          }, [
            T(i.$slots, "default")
          ], 2)
        ];
      }),
      _: 3
    }, 8, ["class"]));
  }
}), Ui = /* @__PURE__ */ v("div", { class: "bg-dark/30 fixed inset-0 transition-opacity" }, null, -1), Yi = { class: "fixed inset-0 overflow-hidden" }, Wi = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full" }, qi = {
  key: 1,
  class: "flex h-80 max-h-full w-full items-center justify-center"
}, kd = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "CfgSlideOver",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    renderHead: { type: Boolean, default: !0 },
    size: { default: "md" },
    renderClose: { type: Boolean, default: !0 },
    width: { default: void 0 },
    disableBottomPadding: { type: Boolean, default: !1 },
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 }
  },
  emits: ["update:opened"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = O(!1), o = B(() => Ie(t, ["opened", "unmount", "onBack"]));
    function n() {
      !t.closable && t.onBack && t.onBack(), t.closable && l("update:opened", !1);
    }
    return (i, s) => (f(), A(u(ea), {
      as: "template",
      show: i.opened
    }, {
      default: h(() => [
        x(u(ta), {
          as: "div",
          class: "z-modal relative",
          unmount: i.unmount ?? !1,
          onClose: n
        }, {
          default: h(() => [
            x(u(Je), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: h(() => [
                Ui
              ]),
              _: 1
            }),
            v("div", Yi, [
              v("div", {
                class: "absolute inset-0 overflow-hidden",
                onClose: n
              }, [
                v("div", Wi, [
                  x(u(Je), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": "translate-x-full",
                    onAfterEnter: s[0] || (s[0] = (c) => r.value = !0),
                    onAfterLeave: s[1] || (s[1] = (c) => r.value = !1)
                  }, {
                    default: h(() => [
                      x(u(aa), {
                        class: S(["pointer-events-auto w-screen", {
                          "max-w-sm": !i.width && i.size === "sm",
                          "max-w-xl": !i.width && i.size === "md",
                          "max-w-[700px]": !i.width && i.size === "lg"
                        }]),
                        style: ye(i.width ? { width: i.width } : {})
                      }, {
                        default: h(() => [
                          x(bn, J({ ...o.value, ...i.$attrs }, {
                            "is-back-allowed": !!t.onBack,
                            onBack: t.onBack,
                            onClose: n
                          }), Et({
                            default: h(() => [
                              r.value ? T(i.$slots, "default", { key: 0 }) : D("", !0),
                              r.value ? D("", !0) : (f(), k("div", qi, [
                                x(u(yt), { class: "text-brand" })
                              ]))
                            ]),
                            _: 2
                          }, [
                            i.$slots.head ? {
                              name: "head",
                              fn: h(() => [
                                T(i.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      }, 8, ["class", "style"])
                    ]),
                    _: 3
                  })
                ])
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Gi = /* @__PURE__ */ v("div", { class: "bg-dark/30 fixed inset-0 transition-opacity" }, null, -1), Ki = { class: "fixed inset-0 overflow-hidden" }, Zi = { class: "pointer-events-none fixed inset-x-0 bottom-0 flex size-full" }, xd = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "CfgBottomSheet",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    title: { default: "" },
    description: { default: "" },
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean }
  },
  emits: ["update:opened"],
  setup(e, { emit: a }) {
    const t = e, l = a, r = B(() => Ie(t, ["opened", "unmount", "onBack"]));
    function o() {
      !t.closable && t.onBack && t.onBack(), t.closable && l("update:opened", !1);
    }
    return (n, i) => (f(), A(u(ea), {
      as: "template",
      show: n.opened
    }, {
      default: h(() => [
        x(u(ta), {
          as: "div",
          class: "z-modal relative",
          unmount: n.unmount ?? !1,
          onClose: o
        }, {
          default: h(() => [
            x(u(Je), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: h(() => [
                Gi
              ]),
              _: 1
            }),
            v("div", Ki, [
              v("div", {
                class: "absolute inset-0",
                onClose: o
              }, [
                v("div", Zi, [
                  x(u(Je), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-y-full",
                    "enter-to": "translate-y-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-y-0",
                    "leave-to": "translate-y-full"
                  }, {
                    default: h(() => [
                      x(u(aa), { class: "pointer-events-auto h-[calc(100%-70px)] w-full self-end" }, {
                        default: h(() => [
                          x(bn, J({ ...r.value, ...n.$attrs }, {
                            "is-back-allowed": !!t.onBack,
                            onBack: t.onBack,
                            onClose: o
                          }), Et({
                            default: h(() => [
                              T(n.$slots, "default")
                            ]),
                            _: 2
                          }, [
                            n.$slots.head ? {
                              name: "head",
                              fn: h(() => [
                                T(n.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  })
                ])
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
});
var Me = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.center = "center", e))(Me || {});
function Xi(e, a) {
  return {
    rowGroups: B(() => e.value.data.reduce((t, l, r) => {
      var s;
      let o = {
        ...l,
        originalIndex: r,
        original: l,
        isSelected: !1,
        isExpended: !1,
        cells: e.value.headers.map(({ keyName: c }) => ({
          keyName: c,
          value: l[c]
        }))
      };
      a.mapEachRow && (o = a.mapEachRow(o));
      const n = (s = e.value.groups) == null ? void 0 : s.find((c) => c.value === o.group);
      if (!n)
        return t.length ? t[0].rows.push(o) : t.push({ value: "", label: "", rows: [o] }), t;
      const i = t.find((c) => c.value === n.value);
      return i ? i.rows.push(o) : t.push({ ...n, rows: [o] }), t;
    }, []))
  };
}
function Ji(e, a, t) {
  if (!a)
    return {};
  const l = B(() => e.value.reduce((s, { rows: c }) => s + c.length, 0)), r = B(() => (a.value || []).length === l.value);
  function o(s) {
    if (!(a != null && a.value))
      return;
    if (!s) {
      t([]);
      return;
    }
    const c = [];
    e.value.forEach(({ rows: p }) => {
      p.forEach((d) => {
        var m;
        c.push({
          index: d.originalIndex,
          id: (m = d.meta) == null ? void 0 : m.id
        });
      });
    }), t(c);
  }
  function n(s, c) {
    t(
      i(s, c)
    );
  }
  function i(s, c) {
    return a != null && a.value ? c ? [...a.value, s] : a.value.filter((p) => !vt(s, p)) : [];
  }
  return {
    toggleAllRowsSelected: o,
    toggleRowSelected: n,
    areAllRowsSelected: r
  };
}
function Qi(e, a) {
  return a ? !!a.find((t) => vt(e, t)) : !1;
}
const Ct = /* @__PURE__ */ R({
  __name: "CfgTableHeadCell",
  props: {
    flat: { type: Boolean },
    align: {},
    cellIndex: {},
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {},
    sort: {},
    width: {},
    text: {}
  },
  emits: ["sort", "update:pagination", "click:row"],
  setup(e, { emit: a }) {
    const t = a;
    function l(r) {
      t("sort", r);
    }
    return (r, o) => (f(), k("th", {
      scope: "col",
      class: S(["z-sticky sticky top-0 bg-white/30 text-left text-sm font-semibold", {
        "px-5 sm:px-5": !r.flat,
        "lg:px-8": !r.flat && (r.bulk ? r.cellIndex + 1 : r.cellIndex) === 0,
        "py-2": r.compact,
        "md:py-3.5": !r.compact,
        "text-center": r.align === u(Me).center,
        "text-right": r.align === u(Me).right
      }]),
      style: ye({
        ...r.width ? { width: r.width } : {}
      })
    }, [
      (f(), A(be(r.sort ? "button" : "span"), J(r.sort ? { type: "button" } : {}, pt(r.sort ? {
        click: () => l({
          ...r.sort,
          order: r.sort.order === "asc" ? "desc" : "asc"
        })
      } : {})), {
        default: h(() => {
          var n;
          return [
            v("span", {
              class: S(["flex items-center gap-x-2", {
                "justify-center": r.align === u(Me).center,
                "justify-end": r.align === u(Me).right
              }])
            }, [
              v("span", null, [
                x(u(I), {
                  size: u(N).subtitle,
                  "tag-name": "span",
                  class: S([(n = r.sort) != null && n.active ? "text-brand" : "text-grey-200"])
                }, {
                  default: h(() => [
                    T(r.$slots, "head", { text: r.text }, () => [
                      j(E(r.text), 1)
                    ])
                  ]),
                  _: 3
                }, 8, ["size", "class"])
              ]),
              r.sort ? (f(), A(u(Xe), {
                key: 0,
                class: S(["shrink-0", {
                  "rotate-180": r.sort.order === "desc"
                }])
              }, null, 8, ["class"])) : D("", !0)
            ], 2)
          ];
        }),
        _: 3
      }, 16))
    ], 6));
  }
}), _t = /* @__PURE__ */ R({
  __name: "CfgTableCell",
  props: {
    flat: { type: Boolean },
    align: {},
    cellIndex: {},
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {}
  },
  setup(e) {
    return (a, t) => (f(), A(u(I), {
      "tag-name": "td",
      size: u(N).sm,
      class: S(["pr-5", {
        "pl-5 sm:pl-5": !a.flat,
        "lg:pl-8": !a.flat && (a.bulk ? a.cellIndex + 1 : a.cellIndex) === 0,
        "py-2": a.compact,
        "md:py-3.5": !a.compact,
        "text-center": a.align === u(Me).center,
        "text-right": a.align === u(Me).right
      }])
    }, {
      default: h(() => [
        T(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["size", "class"]));
  }
});
function eu(e, a) {
  if (!e)
    return {};
  const t = B({
    get() {
      var n;
      return ((n = e.value) == null ? void 0 : n.page) ?? 1;
    },
    set(n) {
      e.value && a({ ...e.value, page: n });
    }
  }), l = Yn(() => {
    if (!e.value)
      return "";
    const n = e.value.page * e.value.perPage - e.value.perPage + 1, i = e.value.page * e.value.perPage;
    return `${n} - ${i > e.value.total ? e.value.total : i} / ${e.value.total}`;
  }), r = [10, 20, 50, 100].map((n) => ({ value: n, label: String(n) })), o = B({
    get() {
      var i;
      const n = ((i = e == null ? void 0 : e.value) == null ? void 0 : i.perPage) || 0;
      return { value: n, label: String(n) };
    },
    set({ value: n }) {
      e.value && a({ ...e.value, perPage: n });
    }
  });
  return {
    paginationPage: t,
    paginationSubtext: l,
    paginationPerPageOptions: r,
    selectedPerPage: o
  };
}
function tu(e) {
  if (!(e != null && e.value))
    return {};
  const a = O(null);
  function t(l) {
    a.value = a.value === l ? null : l;
  }
  return { expendedIndex: a, toggleRowExpendedHandler: t };
}
const au = { class: "max-w-full overflow-y-hidden" }, nu = { class: "inline-block min-w-full" }, ru = { class: "w-max" }, lu = { class: "block text-md" }, ou = { class: "w-max" }, su = ["colspan"], iu = ["onClick"], uu = { class: "ml-auto block px-3 py-2" }, du = ["onClick", "onKeypress"], cu = { class: "overlow-hidden" }, fu = {
  type: "button",
  class: "focusable -my-2 min-w-max p-4"
}, pu = { key: 0 }, mu = ["colspan"], gu = {
  key: 0,
  class: "border-t border-grey-stroke/50"
}, vu = { class: "flex items-center gap-x-3" }, bu = { class: "flex w-full justify-center lg:grow" }, hu = { class: "min-w-[150px] shrink-0" }, wd = /* @__PURE__ */ R({
  __name: "CfgTable",
  props: {
    actionColumnTitle: {},
    dataSources: {},
    allowSelectPerPage: { type: Boolean, default: !0 },
    pagination: {},
    bulk: {},
    expendable: { type: Boolean },
    interactive: { type: Boolean },
    fixed: { type: Boolean },
    flatFirtsCell: { type: Boolean },
    compact: { type: Boolean },
    hideHeader: { type: Boolean }
  },
  emits: ["sort", "update:pagination", "update:bulk", "click:row"],
  setup(e, { emit: a }) {
    const t = Ba(), l = e, r = a, {
      pagination: o,
      bulk: n,
      expendable: i,
      dataSources: s
    } = et(l), c = B(() => Le(l, ["compact", "expendable", "bulk"])), p = mt(s.value.headers, (F) => {
      var H;
      const ee = (H = l.dataSources.sort) == null ? void 0 : H.find((Q) => Q.key === F.keyName);
      return {
        ...F,
        sort: ee,
        keyName: String(F.keyName)
      };
    }), d = B(() => p.value.every((F) => {
      var ee, H;
      return !((H = (ee = F.text) == null ? void 0 : ee.trim()) != null && H.length);
    })), m = B(() => Object.keys(t).some((F) => F.startsWith("head:"))), y = B(() => !l.hideHeader && (!d.value || !!(n != null && n.value) || m.value)), w = O(null), { height: g } = gt(w), { expendedIndex: _, toggleRowExpendedHandler: M } = tu(i), {
      paginationPage: $,
      selectedPerPage: b,
      paginationSubtext: C,
      paginationPerPageOptions: z
    } = eu(
      o,
      (F) => r("update:pagination", F)
    ), { rowGroups: P } = Xi(s, {
      mapEachRow(F) {
        var ee;
        return {
          ...F,
          isSelected: Qi({ index: F.originalIndex, id: (ee = F.meta) == null ? void 0 : ee.id }, (n == null ? void 0 : n.value) || []),
          isExpended: ((_ == null ? void 0 : _.value) ?? -1) === F.originalIndex
        };
      }
    }), { areAllRowsSelected: Z, toggleAllRowsSelected: V, toggleRowSelected: U } = Ji(P, n, (F) => r("update:bulk", F)), q = B(() => l.dataSources.headers.map(({ footerValue: F, align: ee, keyName: H }) => ({
      value: F,
      align: ee,
      keyName: String(H)
    }))), G = B(() => q.value.some(({ value: F }) => F)), L = B(() => !!t["body:actions"]), fe = [
      n,
      i,
      L
    ], pe = B(() => fe.map((F) => F == null ? void 0 : F.value).filter(Boolean).length);
    function ze(F) {
      r("sort", F);
    }
    function Ae(F, ee, H) {
      M && M(H), l.interactive && r("click:row", { item: F, e: ee });
    }
    return (F, ee) => (f(), k("div", au, [
      v("div", {
        class: S(["-mt-5 max-w-full pt-5", { "overflow-x-auto": !F.fixed }])
      }, [
        v("div", nu, [
          v("table", {
            class: S(["min-w-full max-w-full border-spacing-0", {
              "w-max": !F.fixed,
              "w-full table-fixed": F.fixed
            }]),
            style: ye({
              // Hide head if all headers are hidden.
              // Display none doesn't work because table cells will wrong calculate width without rendered table head
              ...y.value ? {} : { marginTop: `-${u(g)}px` }
            })
          }, [
            v("thead", {
              ref_key: "headRef",
              ref: w,
              class: S(["shadow-none", {
                invisible: !y.value
              }])
            }, [
              v("tr", ru, [
                u(n) ? (f(), A(Ct, J({
                  key: 0,
                  "key-name": "bulk",
                  text: "",
                  "cell-index": 0
                }, c.value, { width: "80px" }), {
                  head: h(() => [
                    v("span", lu, [
                      x(u(Vt), {
                        class: "text-md",
                        "model-value": u(Z),
                        "onUpdate:modelValue": u(V)
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 1
                }, 16)) : D("", !0),
                (f(!0), k(K, null, le(u(p), ({
                  keyName: H,
                  text: Q,
                  sort: ne,
                  align: ue,
                  width: W
                }, de) => (f(), A(Ct, J({
                  key: `head-${H}`
                }, c.value, {
                  text: Q,
                  sort: ne,
                  align: ue,
                  "cell-index": u(n) ? de + 1 : de,
                  width: W,
                  "key-name": H,
                  onSort: ze
                }), {
                  head: h(() => [
                    T(F.$slots, `head:${H}`, { text: Q }, () => [
                      j(E(Q), 1)
                    ])
                  ]),
                  _: 2
                }, 1040, ["text", "sort", "align", "cell-index", "width", "key-name"]))), 128)),
                F.$slots["body:actions"] ? (f(), A(Ct, {
                  key: "action",
                  width: "70px",
                  "cell-index": u(p).length + 1,
                  text: F.actionColumnTitle || "",
                  align: u(Me).center,
                  "key-name": "action",
                  class: S(["text-end", {
                    "pr-10": !u(i)
                  }]),
                  compact: F.compact
                }, null, 8, ["cell-index", "text", "align", "class", "compact"])) : D("", !0),
                u(i) ? (f(), A(Ct, J({
                  key: 2,
                  width: "70px",
                  "cell-index": u(p).length + (L.value ? 2 : 1)
                }, c.value, { class: "pr-10" }), null, 16, ["cell-index"])) : D("", !0)
              ])
            ], 2),
            v("tbody", ou, [
              (f(!0), k(K, null, le(u(P), ({ rows: H, value: Q, label: ne }, ue) => (f(), k(K, null, [
                ne || Q ? (f(), k("tr", {
                  key: `group-${ue}`
                }, [
                  v("th", {
                    colspan: H[0].cells.length || 0,
                    scope: "colgroup",
                    class: S([{ "pt-2": F.compact, "pt-5": !F.compact }, "px-5 pb-2 text-left text-grey-300 lg:px-8"])
                  }, [
                    T(F.$slots, "group", {
                      group: { rows: H, value: Q, label: ne }
                    }, () => [
                      x(u(I), {
                        size: u(N).sm,
                        class: "font-bold"
                      }, {
                        default: h(() => [
                          j(E(ne || Q), 1)
                        ]),
                        _: 2
                      }, 1032, ["size"])
                    ])
                  ], 10, su)
                ])) : D("", !0),
                (f(!0), k(K, null, le(H, (W, de) => (f(), k(K, {
                  key: `row-${de}`
                }, [
                  v("tr", {
                    class: S(["row last-child:!border-b-none", {
                      "cursor-pointer transition-colors duration-200": F.interactive || u(i),
                      "hover:bg-grey-100/50": F.interactive,
                      "border-b border-b-grey-stroke": !W.isExpended && !W.isSelected && de !== H.length - 1,
                      "border-b border-b-brand/20": !W.isExpended && W.isSelected && de !== H.length - 1,
                      "border-b border-b-white": W.isExpended && de !== H.length - 1,
                      "hover:bg-brand/10": u(i),
                      "expended-row bg-brand/10": W.isExpended || W.isSelected
                    }]),
                    onClick: (ve) => Ae(W.original, ve, W.originalIndex)
                  }, [
                    u(n) ? (f(), A(_t, J({
                      key: 0,
                      "cell-index": 0,
                      "row-index": de,
                      selected: W.isSelected,
                      expended: W.isExpended
                    }, c.value), {
                      default: h(() => [
                        x(u(Vt), {
                          class: "text-md",
                          "model-value": W.isSelected,
                          "onUpdate:modelValue": (ve) => {
                            var _e;
                            u(U) && u(U)({
                              index: W.originalIndex,
                              id: (_e = W.meta) == null ? void 0 : _e.id
                            }, ve);
                          },
                          onClick: ee[0] || (ee[0] = Pe(() => {
                          }, ["stop"]))
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1040, ["row-index", "selected", "expended"])) : D("", !0),
                    (f(!0), k(K, null, le(W.cells, (ve, _e) => (f(), A(_t, J({
                      key: `cell-${ve.keyName}-${de}`,
                      "cell-index": u(n) ? _e + 1 : _e
                    }, c.value, {
                      "row-index": de,
                      expended: W.isExpended,
                      align: u(s).headers[_e].align,
                      flat: F.flatFirtsCell && _e === 0 && !u(n),
                      selected: W.isSelected
                    }), {
                      default: h(() => [
                        F.$slots[`body:${ve.keyName}`] ? T(F.$slots, `body:${ve.keyName}`, {
                          key: 0,
                          value: ve.value,
                          item: u(s).data[de]
                        }) : T(F.$slots, "body:item", {
                          key: 1,
                          keyName: ve.keyName,
                          value: ve.value,
                          item: u(s).data[de]
                        }, () => [
                          j(E(ve.value || "-"), 1)
                        ])
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "row-index", "expended", "align", "flat", "selected"]))), 128)),
                    L.value ? (f(), A(_t, J({
                      key: 1,
                      "cell-index": W.cells.length + 1,
                      "row-index": de,
                      selected: W.isSelected,
                      expended: W.isExpended
                    }, c.value, {
                      onClick: ee[1] || (ee[1] = Pe(() => {
                      }, ["stop"]))
                    }), {
                      default: h(() => [
                        x(Xl, {
                          overlay: "",
                          class: "mx-auto",
                          "origin-x": "right"
                        }, {
                          trigger: h(() => [
                            v("span", uu, [
                              x(u(Ln), { class: "text-grey-300" })
                            ])
                          ]),
                          default: h(({ close: ve }) => {
                            var _e, ha;
                            return [
                              v("span", {
                                class: "block min-w-max px-6 py-4",
                                onClick: ve,
                                onKeypress: $e(ve, ["enter"])
                              }, [
                                T(F.$slots, "body:actions", {
                                  row: (ha = (_e = u(P)[ue]) == null ? void 0 : _e.rows) == null ? void 0 : ha[de],
                                  index: de
                                })
                              ], 40, du)
                            ];
                          }),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "row-index", "selected", "expended"])) : D("", !0),
                    u(i) ? (f(), A(_t, J({
                      key: 2,
                      "cell-index": W.cells.length + (L.value ? 2 : 1),
                      "row-index": de,
                      selected: W.isSelected,
                      expended: W.isExpended
                    }, c.value), {
                      default: h(() => [
                        v("div", cu, [
                          v("button", fu, [
                            x(u(Xe), {
                              class: S(["h-5 w-5 transition duration-200", {
                                "rotate-180 text-brand": W.isExpended
                              }])
                            }, null, 8, ["class"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "row-index", "selected", "expended"])) : D("", !0)
                  ], 10, iu),
                  u(i) ? (f(), k("tr", pu, [
                    v("td", {
                      colspan: W.cells.length + pe.value,
                      class: S(["p-0", {
                        "pt-[1px]": W.isExpended
                      }])
                    }, [
                      x(Ds, {
                        opened: W.isExpended,
                        class: "border-transparent bg-brand/10"
                      }, {
                        default: h(() => [
                          v("div", null, [
                            v("div", {
                              class: S(["lg:px-8", { "p-3": F.compact, "p-5": !F.compact }])
                            }, [
                              T(F.$slots, "row:expended", {
                                row: W.original,
                                index: W.originalIndex
                              })
                            ], 2)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["opened"])
                    ], 10, mu)
                  ])) : D("", !0)
                ], 64))), 128))
              ], 64))), 256))
            ]),
            G.value ? (f(), k("tfoot", gu, [
              v("tr", null, [
                u(n) ? (f(), k("td", {
                  key: 0,
                  class: S(["font-mediumxl:text-[15px] py-3 pl-5 pr-7 text-center text-xs sm:pl-6 lg:pl-8", {
                    "md:py-5": !F.compact,
                    "md:py-3": F.compact
                  }]),
                  onClick: ee[2] || (ee[2] = Pe(() => {
                  }, ["stop"]))
                }, null, 2)) : D("", !0),
                (f(!0), k(K, null, le(q.value, ({ value: H, align: Q, keyName: ne }, ue) => (f(), k("td", { key: ue }, [
                  v("span", {
                    class: S(["flex w-full py-3 pr-5", {
                      "justify-center text-center": Q === u(Me).center,
                      "justify-end text-right": Q === u(Me).right,
                      "pl-5 sm:pl-5": !F.flatFirtsCell
                    }])
                  }, [
                    H ? T(F.$slots, `footer:${ne}`, {
                      key: 0,
                      value: H,
                      item: u(s).data[ue]
                    }, () => [
                      x(u(I), {
                        html: String(H),
                        size: u(N).md,
                        class: "!font-semibold"
                      }, null, 8, ["html", "size"])
                    ]) : D("", !0)
                  ], 2)
                ]))), 128))
              ])
            ])) : D("", !0)
          ], 6)
        ])
      ], 2),
      u(o) && u($) ? (f(), k("div", {
        key: 0,
        style: { "--cfg-select-min-width": "150px" },
        class: S(["mt-0 block w-full border-t border-grey-stroke/50 p-5 lg:px-8", {
          "pt-10": !F.allowSelectPerPage
        }])
      }, [
        v("div", vu, [
          x(u(I), {
            size: u(N).sm,
            class: "shrink-0 text-grey-300"
          }, {
            default: h(() => [
              j(E(u(C)), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          v("div", bu, [
            x(Nl, {
              page: u($),
              "onUpdate:page": ee[3] || (ee[3] = (H) => Be($) ? $.value = H : null),
              "total-items": u(o).total,
              "items-per-page": u(o).perPage,
              class: "w-full lg:w-max"
            }, null, 8, ["page", "total-items", "items-per-page"])
          ]),
          v("div", hu, [
            F.allowSelectPerPage ? (f(), A(mn, {
              key: 0,
              modelValue: u(b),
              "onUpdate:modelValue": ee[4] || (ee[4] = (H) => Be(b) ? b.value = H : null),
              options: u(z),
              "content-min-width": "150px",
              placeholder: "Řádků na stránku:"
            }, null, 8, ["modelValue", "options"])) : D("", !0)
          ])
        ])
      ], 2)) : D("", !0)
    ]));
  }
}), yu = {
  key: 0,
  class: "flex items-center text-[1.2em]"
}, $d = /* @__PURE__ */ R({
  __name: "CfgTableMenuItem",
  props: {
    as: {
      type: String,
      default: "button"
    }
  },
  setup(e) {
    return (a, t) => (f(), A(u(I), {
      size: u(N).md,
      "tag-name": e.as,
      class: "flex items-center gap-x-3 px-3 py-2 transition duration-200 hover:opacity-70"
    }, {
      default: h(() => [
        a.$slots.icon ? (f(), k("div", yu, [
          T(a.$slots, "icon")
        ])) : D("", !0),
        v("div", null, [
          T(a.$slots, "body")
        ])
      ]),
      _: 3
    }, 8, ["size", "tag-name"]));
  }
});
var se = /* @__PURE__ */ ((e) => (e.Input = "input", e.Textarea = "textarea", e.DateField = "dateField", e.Select = "select", e.Multiselect = "multiselect", e.Combobox = "combobox", e.Radio = "radio", e.Switch = "switch", e.Checkbox = "checkbox", e.RadioGroup = "radioGroup", e.CheckboxGroup = "checkboxGroup", e.AccountNumber = "accountNumber", e.Slider = "slider", e.RangeSlider = "rangeSlider", e.BirthNumberField = "birthNumberField", e.AddressDetailsField = "addressDetailsField", e.PasswordField = "passwordField", e))(se || {});
function Cd(e, a) {
  const t = Object.entries(e).reduce((o, [n, i]) => {
    const {
      value: s,
      cols: c = 2,
      validators: p = [],
      classNames: d,
      show: m,
      ...y
    } = i;
    return o[n] = {
      component: i.control,
      props: y,
      modelValue: s,
      validators: p,
      cols: c,
      show: m,
      _visible: !0,
      attributes: {
        classNames: d
      }
    }, o;
  }, {}), l = Kt(
    Object.fromEntries(
      Object.entries(t).map((o) => {
        const [n, i] = o;
        return [n, {
          ...it(i),
          props: i.props
          // pass props separately to avoid loosing reactivity
        }];
      })
    )
  );
  X(() => a, () => {
    if (a) {
      let o = a;
      Be(a) && (o = a.value), Object.entries(o).forEach((n) => {
        const [i, s] = n;
        l[i].modelValue = it(s);
      });
    }
  }, { deep: !0, immediate: !0 });
  const r = B(() => hn(l));
  return za(() => {
    Object.entries(r.value).forEach((o) => {
      const [n] = o, i = l == null ? void 0 : l[n];
      i._visible = Ut(i.show) ? !0 : i.show({ state: r.value });
    });
  }), {
    results: r,
    schema: l,
    resetData() {
      Object.entries(l).forEach((o) => {
        const [n] = o;
        l[n].modelValue = a ? (Be(a) ? a.value : a)[n] : it(e[n].value);
      });
    }
  };
}
function hn(e) {
  return Object.entries(e).reduce(
    (a, [t, l]) => ({
      ...a,
      [t]: l.modelValue
    }),
    {}
  );
}
const ku = {
  key: 0,
  class: "flex justify-center"
}, xu = /* @__PURE__ */ R({
  __name: "CfgForm",
  props: {
    /**
     * The schema of the form. Can be generated useForm hook
     */
    schema: {
      type: Object,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * The label of the submit button. Default button will be replaced with slot name submit. Contains onSubmit event in slot props.
     * For example: v-slot={ onSubmit }
     */
    buttonLabel: {
      type: String,
      default: "DEFAULT_BUTTON_LABEL"
    },
    /**
     * Controls whether the submit button should be rendered or not
     */
    renderSubmitButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Shows elements placed horizontally - next to each other
     */
    horizontal: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["submit"],
  async setup(e, { expose: a, emit: t }) {
    let l, r;
    const o = e, { schema: n, loading: i } = et(o), s = B(() => Wn(n.value, ($) => ($ == null ? void 0 : $._visible) !== !1)), c = t, p = O(null), d = O(null), { width: m } = gt(p), y = B(() => m.value > 500), w = Object.fromEntries(Object.keys(n).map(($) => [$, null])), g = {
      [se.Input]: async () => (await import("./CfgInput-11b88112.js")).default,
      [se.Textarea]: async () => (await import("./CfgTextarea-672742ce.js")).default,
      [se.DateField]: async () => (await import("./CfgDateField-2fd0e563.js")).default,
      [se.Select]: async () => (await import("./index-a86ab19d.js")).CfgSelect,
      [se.Multiselect]: async () => (await import("./index-a86ab19d.js")).CfgSelect,
      [se.Combobox]: async () => (await import("./index-a86ab19d.js")).CfgCombobox,
      [se.Radio]: async () => (await import("./index-c248acd5.js")).CfgRadio,
      [se.Switch]: async () => (await import("./index-c248acd5.js")).CfgSwitch,
      [se.Checkbox]: async () => (await import("./index-c248acd5.js")).CfgCheckbox,
      [se.RadioGroup]: async () => (await import("./index-a86ab19d.js")).CfgRadioGroup,
      [se.CheckboxGroup]: async () => (await import("./index-a86ab19d.js")).CfgCheckboxGroup,
      [se.AccountNumber]: async () => (await import("./CfgBankAccountField-876a20c5.js")).default,
      [se.Slider]: async () => (await import("./index-a86ab19d.js")).CfgSlider,
      [se.RangeSlider]: async () => (await import("./index-a86ab19d.js")).CfgSlider,
      [se.BirthNumberField]: async () => (await import("./CfgBirthNumberField-f5d5e299.js")).default,
      [se.AddressDetailsField]: async () => (await import("./CfgAddressDetailsField-5aa6594f.js")).default,
      [se.PasswordField]: async () => (await import("./CfgPasswordField-1fe3a1d3.js")).default
    };
    a({
      resetForm() {
        var $;
        ($ = d.value) == null || $.resetForm();
      },
      async submit() {
        return d.value ? d.value.submit() : !1;
      }
    }), [l, r] = Xt(() => _()), await l, r();
    async function _() {
      (await Promise.all(
        Object.entries(n.value).map(async (b) => {
          const [C, z] = b, P = await g[z.component]();
          return [C, P];
        })
      )).forEach(([b, C]) => {
        w[b] = C;
      });
    }
    function M() {
      c("submit", hn(n.value));
    }
    return ($, b) => (f(), k("div", null, [
      x(Li, {
        ref_key: "validationObserverRef",
        ref: d,
        onSubmit: M
      }, {
        default: h((C) => [
          v("form", {
            ref_key: "formRoot",
            ref: p,
            novalidate: "",
            class: "cfg-form space-y-4 pt-2",
            onSubmit: b[0] || (b[0] = Pe(() => {
            }, ["prevent"]))
          }, [
            v("div", {
              class: S(["grid gap-5", e.horizontal ? "cfg-table-form-container-horizontal" : "grid-cols-2"])
            }, [
              (f(!0), k(K, null, le(s.value, (z, P) => (f(), k("div", {
                key: P,
                class: S({
                  "col-span-1": z.cols === 1 && y.value,
                  "col-span-2": z.cols === 2 || !y.value,
                  [`cfg-form__field--${z.component}`]: !0,
                  [z.attributes.classNames]: !!z.attributes.classNames
                })
              }, [
                x(vn, J({
                  modelValue: z.modelValue,
                  "onUpdate:modelValue": (Z) => z.modelValue = Z,
                  validators: z.validators
                }, pt(C.on)), {
                  default: h(({ on: Z, attrs: V }) => [
                    (f(), A(be(u(w)[P]), J({
                      // User's passed props
                      ...u(Ie)(z.props, "control"),
                      ...V,
                      loading: z.props.loading || V.loading
                    }, { class: "w-full" }, pt(Z)), null, 16))
                  ]),
                  _: 2
                }, 1040, ["modelValue", "onUpdate:modelValue", "validators"])
              ], 2))), 128))
            ], 2),
            e.renderSubmitButton ? (f(), k("div", ku, [
              T($.$slots, "submit", {
                onSubmit: C.submit
              }, () => [
                x(Nt, {
                  type: "submit",
                  class: "mt-4 w-full",
                  loading: u(i) || C.validationLoading,
                  fluid: "",
                  onClick: C.submit
                }, {
                  default: h(() => [
                    j(E(e.buttonLabel), 1)
                  ]),
                  _: 2
                }, 1032, ["loading", "onClick"])
              ], !0)
            ])) : D("", !0)
          ], 544)
        ]),
        _: 3
      }, 512)
    ]));
  }
});
const _d = /* @__PURE__ */ Re(xu, [["__scopeId", "data-v-9b9a5294"]]), wu = { class: "rounded-md" }, $u = { class: "flex w-full flex-row items-center justify-between space-y-2 lg:flex-col lg:items-start lg:justify-start" }, Cu = { class: "!mt-0 flex flex-row gap-x-2 lg:!mt-2" }, _u = ["innerHTML"], Su = ["innerHTML"], Mu = ["innerHTML"], Du = { class: "mt-4" }, Bu = { class: "flex items-center justify-between pb-8" }, zu = { class: "w-32 shrink-0" }, Au = {
  id: "calculator-slider",
  class: "lg:px-0"
}, Vu = { class: "mt-7 flex flex-wrap justify-start gap-4 lg:gap-x-20" }, Tu = { key: 0 }, Eu = { class: "space-y-1" }, Ou = ["innerHTML"], Pu = { class: "space-y-2" }, Lu = { class: "space-y-1" }, Nu = ["innerHTML"], Sd = /* @__PURE__ */ R({
  __name: "CfgInvestCalculator",
  props: {
    modelValue: {
      type: Number,
      required: !0
    },
    /**
     * Main parameters on the top of the calculator
     */
    mainParameters: {
      type: Object,
      default: () => ({})
    },
    /**
     * Translations for calculator
     */
    translations: {
      type: Object,
      required: !0
    },
    /**
     * Minimum investment amount
     */
    minInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Max investment amount
     */
    maxInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Show periodic result under slider, should not show on ReturnsPeriodicityEnum.OneTime
     */
    showPeriodicResult: {
      type: Boolean,
      required: !0
    },
    /**
     * Show periodic result and whole period result
     */
    result: {
      type: [Object, null],
      default: null
    },
    /**
     * Each change on slider will increment and decrement by this value
     */
    stepValue: {
      type: Number,
      required: !0
    },
    /**
     * Control if slider should be lazy emitted update:modelValue
     */
    sliderLazy: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "slider:dragEnd"],
  setup(e, { emit: a }) {
    const t = e, r = ce(t, "modelValue", a), o = O($t(r.value, !0)), n = B(() => t.stepValue ?? 0);
    function i(s) {
      const c = Lo(Number(s.replace(/\s/g, "")), {
        min: t.minInvestment,
        max: t.maxInvestment,
        step: n.value
      });
      r.value = c, o.value = $t(c, !0);
    }
    return X(r, (s) => {
      const c = $t(s, !0);
      o.value !== c && (o.value = $t(s, !0));
    }, { deep: !0 }), (s, c) => {
      var p, d;
      return f(), k("div", wu, [
        Object.keys(e.mainParameters).length ? (f(), k("ul", {
          key: 0,
          class: S(["mb-10 flex flex-col flex-wrap gap-y-2 lg:flex-row lg:justify-between", {
            "gap-x-5": Object.keys(e.mainParameters).length > 2,
            "gap-x-10": Object.keys(e.mainParameters).length <= 2
          }])
        }, [
          (f(!0), k(K, null, le(e.mainParameters, ({
            label: m,
            tooltip: y,
            description: w,
            value: g
          }) => (f(), k("li", { key: m }, [
            x(u(Bt), {
              "hide-icon": "",
              interactive: "",
              disabled: !y,
              class: "w-full"
            }, {
              trigger: h(() => [
                v("div", $u, [
                  x(u(I), {
                    size: u(N).xs,
                    class: "flex items-center gap-x-1.5 text-grey-300"
                  }, {
                    default: h(() => [
                      j(E(m) + " ", 1),
                      y ? (f(), A(u(ot), {
                        key: 0,
                        class: "hidden text-[20px] lg:block"
                      })) : D("", !0)
                    ]),
                    _: 2
                  }, 1032, ["size"]),
                  v("div", Cu, [
                    x(u(I), {
                      size: u(N).lg,
                      "tag-name": "strong",
                      class: "flex flex-col items-end !font-bold lg:items-start"
                    }, {
                      default: h(() => [
                        v("span", {
                          class: "block w-max",
                          innerHTML: g
                        }, null, 8, _u),
                        w ? (f(), k("small", {
                          key: 0,
                          class: "block text-xs font-normal text-grey-300",
                          innerHTML: w
                        }, null, 8, Su)) : D("", !0)
                      ]),
                      _: 2
                    }, 1032, ["size"]),
                    y ? (f(), A(u(ot), {
                      key: 0,
                      class: "text-[20px] text-grey-500 lg:hidden"
                    })) : D("", !0)
                  ])
                ])
              ]),
              content: h(({ initialized: _ }) => [
                _ ? (f(), A(u(I), {
                  key: 0,
                  size: u(N).sm
                }, {
                  default: h(() => [
                    v("span", { innerHTML: y }, null, 8, Mu)
                  ]),
                  _: 2
                }, 1032, ["size"])) : D("", !0)
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]))), 128))
        ], 2)) : D("", !0),
        e.result ? (f(), k(K, { key: 1 }, [
          x(u(I), {
            size: u(N).h3,
            "tag-name": "h2"
          }, {
            default: h(() => [
              j(E(e.translations.title), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          v("div", Du, [
            v("div", Bu, [
              x(u(I), {
                size: u(N).sm,
                class: "grow text-grey-300"
              }, {
                default: h(() => [
                  j(E(e.translations.label), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              v("div", zu, [
                x(u(St), {
                  modelValue: o.value,
                  "onUpdate:modelValue": c[0] || (c[0] = (m) => o.value = m),
                  type: "text",
                  step: n.value,
                  min: e.minInvestment,
                  max: e.maxInvestment,
                  suffix: e.translations.currency,
                  onBlur: i,
                  "onKeydown:enter": i
                }, null, 8, ["modelValue", "step", "min", "max", "suffix"])
              ])
            ]),
            v("div", Au, [
              x(u(Ps), {
                modelValue: u(r),
                "onUpdate:modelValue": c[1] || (c[1] = (m) => Be(r) ? r.value = m : null),
                step: n.value,
                min: e.minInvestment,
                max: e.maxInvestment,
                lazy: e.sliderLazy,
                tooltips: !1,
                "onDrag:end": c[2] || (c[2] = (m) => s.$emit("slider:dragEnd"))
              }, null, 8, ["modelValue", "step", "min", "max", "lazy"])
            ])
          ]),
          v("div", Vu, [
            e.showPeriodicResult ? (f(), k("div", Tu, [
              x(u(Bt), {
                interactive: "",
                "hide-icon": "",
                disabled: !((p = e.translations.result.periodic) != null && p.tooltip)
              }, {
                trigger: h(() => [
                  v("div", Eu, [
                    x(u(I), {
                      size: u(N).sm,
                      class: "flex items-center gap-x-1.5 text-center !font-bold text-grey-300 sm:text-left"
                    }, {
                      default: h(() => [
                        j(E(e.translations.result.periodic.label) + " ", 1),
                        e.translations.result.periodic.tooltip ? (f(), A(u(ot), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : D("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    x(u(I), {
                      size: u(N).h3,
                      class: "block"
                    }, {
                      default: h(() => [
                        j(E(e.result.periodic), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: h(({ initialized: m, closeHint: y }) => [
                  T(s.$slots, "periodicResultTooltip", { closeHint: y }, () => [
                    m ? (f(), k("span", {
                      key: 0,
                      innerHTML: e.translations.result.periodic.tooltip
                    }, null, 8, Ou)) : D("", !0)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])) : D("", !0),
            v("div", Pu, [
              x(u(Bt), {
                interactive: "",
                "hide-icon": "",
                disabled: !((d = e.translations.result.wholePeriod) != null && d.tooltip)
              }, {
                trigger: h(() => [
                  v("div", Lu, [
                    x(u(I), {
                      size: u(N).sm,
                      class: "flex items-center gap-x-1.5 text-center !font-bold text-grey-300 sm:text-left"
                    }, {
                      default: h(() => [
                        j(E(e.translations.result.wholePeriod.label) + " ", 1),
                        e.translations.result.wholePeriod.tooltip ? (f(), A(u(ot), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : D("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    x(u(I), {
                      size: u(N).h3,
                      class: "block !font-extrabold text-brand"
                    }, {
                      default: h(() => [
                        j(E(e.result.wholePeriod), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: h(({ initialized: m, closeHint: y }) => [
                  T(s.$slots, "wholePeriodTooltip", { closeHint: y }, () => [
                    m ? (f(), k("span", {
                      key: 0,
                      innerHTML: e.translations.result.wholePeriod.tooltip
                    }, null, 8, Nu)) : D("", !0)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])
          ])
        ], 64)) : D("", !0)
      ]);
    };
  }
});
export {
  vd as CfgAddressDetailsField,
  qu as CfgAlert,
  ge as CfgAlertVariants,
  yd as CfgApplicationError,
  md as CfgBankAccountField,
  gd as CfgBirthNumberField,
  xd as CfgBottomSheet,
  ud as CfgBreadcrumbs,
  Nt as CfgButton,
  ad as CfgButtonsGroup,
  ps as CfgCalendar,
  Gu as CfgCard,
  Vt as CfgCheckbox,
  cd as CfgCheckboxGroup,
  td as CfgChip,
  xe as CfgChipColors,
  hd as CfgChipsToggle,
  Ds as CfgCollapsable,
  nd as CfgCombobox,
  St as CfgCompactInput,
  Di as CfgDateField,
  sd as CfgDialog,
  Xl as CfgDropdown,
  gn as CfgFloating,
  _d as CfgForm,
  Qu as CfgHeaderBanner,
  Bt as CfgHint,
  Se as CfgInput,
  Sd as CfgInvestCalculator,
  Ye as CfgModalSizes,
  Ju as CfgOtpInput,
  Nl as CfgPagination,
  bd as CfgPasswordField,
  yt as CfgPreloader,
  ks as CfgRadio,
  dd as CfgRadioGroup,
  Ms as CfgScrollbarView,
  mn as CfgSelect,
  kd as CfgSlideOver,
  Ps as CfgSlider,
  Ku as CfgSwitch,
  od as CfgTab,
  ld as CfgTabPanel,
  wd as CfgTable,
  $d as CfgTableMenuItem,
  rd as CfgTabs,
  ed as CfgTextarea,
  fd as CfgTimeline,
  Si as CfgTimelineItem,
  oe as CfgTimelineItemColors,
  id as CfgToastNotification,
  he as CfgToastNotificationType,
  I as CfgTypography,
  N as CfgTypographySizes,
  pd as CfgValidatedField,
  Li as CfgValidationObserver,
  vn as CfgValidationProvider,
  se as FormControlNames,
  Me as TableCallAlign,
  hn as buildFormResults,
  Cd as useForm
};
